import moment from "moment";
// // // /* ------------------------------------------------------------------ */
// // // /*  OrdersPage.jsx – LOGIC ONLY (no UI)                               */
// // // /* ------------------------------------------------------------------ */

// // // import PaymentQRDisplay from '../components/PaymentQRDisplay';
// // // import React, { useEffect, useRef, useState } from "react";
// // // import { useTranslation } from "react-i18next";
// // // import Page from "../components/Page";
// // // import {
// // //   cancelKitchenOrder,
// // //   completeKitchenOrder,
// // //   getCompleteOrderPaymentSummary,
// // //   getInvoiceIdFromOrderId,
// // //   getOrders,
// // //   getOrdersInit,
// // //   payAndCompleteKitchenOrder,
// // //   updateKitchenOrderItemStatus,
// // // } from "../controllers/orders.controller";
// // // import { toast } from "react-hot-toast";
// // // import { iconStroke } from "../config/config";
// // // import { CURRENCIES } from "../config/currencies.config";
// // // import { PAYMENT_ICONS } from "../config/payment_icons";
// // // import { setDetailsForReceiptPrint } from "../helpers/ReceiptHelper";

// // // import { initSocket, getSocket } from "../utils/socket";   // NEW
// // // import { getUserDetailsInLocalStorage } from "../helpers/UserDetails";
// // // import QRCode from "qrcode";
// // // import { getQRMenuLink } from "../helpers/QRMenuHelper";
// // // import { useTheme } from "../contexts/ThemeContext";

// // // export default function OrdersPage() {
// // //   const { t } = useTranslation();
// // //   const { theme } = useTheme();
// // //   const printReceiptRef = useRef();
// // //   const user = getUserDetailsInLocalStorage();

// // //   const [state, setState] = useState({
// // //     kitchenOrders: [],
// // //     printSettings: null,
// // //     storeSettings: null,
// // //     paymentTypes: [],
// // //     isLoading: true,
// // //     cancelOrderIds: [],
// // //     completeOrderIds: [],
// // //     completeTokenIds: "",
// // //     currency: null,
// // //     summaryNetTotal: 0,
// // //     summaryTaxTotal: 0,
// // //     summaryServiceChargeTotal: 0,
// // //     summaryTotal: 0,
// // //     summaryOrders: [],
// // //     order: null,
// // //     selectedPaymentType: null,
// // //     feedbackInvoiceId: null,
// // //     feedbackCustomerId: null,
// // //     feedbackQRCode: null,
// // //   });

// // //   /* --------------------------------------------------------------- */
// // //   /* 1. Init data + socket                                           */
// // //   /* --------------------------------------------------------------- */
// // //   useEffect(() => {
// // //     _init();               // load orders + init data
// // //     initSocket();          // start socket (uses token from localStorage)

// // //     const socket = getSocket();
// // //     if (!socket) return;

// // //     const audio = new Audio("/new_order_sound.mp3");

// // //     const onNewOrder = (payload) => {
// // //       console.log("new_order", payload);
// // //       audio.play();
// // //       refreshOrders();
// // //     };

// // //     const onOrderUpdate = () => {
// // //       console.log("order_update");
// // //       refreshOrders();
// // //     };

// // //     socket.on("new_order", onNewOrder);
// // //     socket.on("order_update", onOrderUpdate);

// // //     // Authenticate the POS for this tenant
// // //     socket.emit("authenticate", user.tenant_id);

// // //     return () => {
// // //       socket.off("new_order", onNewOrder);
// // //       socket.off("order_update", onOrderUpdate);
// // //     };
// // //   }, []);   // run once

// // //   const {
// // //     kitchenOrders,
// // //     printSettings,
// // //     storeSettings,
// // //     paymentTypes,
// // //     isLoading,
// // //     currency,
// // //   } = state;

// // //   /* --------------------------------------------------------------- */
// // //   /* 2. Load orders                                                   */
// // //   /* --------------------------------------------------------------- */
// // //   const _init = async () => {
// // //     try {
// // //       const [ordersResponse, ordersInitResponse] = await Promise.all([
// // //         getOrders(),
// // //         getOrdersInit(),
// // //       ]);

// // //       if (ordersResponse.status === 200 && ordersInitResponse.status === 200) {
// // //         const orders = ordersResponse?.data || [];
// // //         const ordersInit = ordersInitResponse.data;

// // //         const currency = CURRENCIES.find(
// // //           (c) => c.cc === ordersInit?.storeSettings?.currency
// // //         );

// // //         setState({
// // //           ...state,
// // //           kitchenOrders: orders,
// // //           printSettings: ordersInit.printSettings || {},
// // //           storeSettings: ordersInit.storeSettings || {},
// // //           paymentTypes: ordersInit.paymentTypes || [],
// // //           currency: currency?.symbol,
// // //           isLoading: false,
// // //         });
// // //       }
// // //     } catch (error) {
// // //       console.error(error);
// // //       toast.error("Error loading orders! Please try later!");
// // //       setState({ ...state, isLoading: false });
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 3. Refresh (manual)                                              */
// // //   /* --------------------------------------------------------------- */
// // //   const refreshOrders = async () => {
// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await getOrders();
// // //       toast.dismiss();
// // //       if (res.status === 200) {
// // //         toast.success(t("orders.orders_loaded"));
// // //         setState({
// // //           ...state,
// // //           kitchenOrders: res.data,
// // //           isLoading: false,
// // //         });
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error.response?.data?.message ||
// // //         "Error loading orders! Please try later!";
// // //       toast.dismiss();
// // //       toast.error(message);
// // //       setState({ ...state, isLoading: false });
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 4. Send update event to kitchen / other POS                     */
// // //   /* --------------------------------------------------------------- */
// // //   const sendOrderUpdateEvent = () => {
// // //     const socket = getSocket();
// // //     if (socket?.connected) {
// // //       socket.emit("order_update_backend", {}, user.tenant_id);
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 5. Order item status change                                      */
// // //   /* --------------------------------------------------------------- */
// // //   const btnChangeOrderItemStatus = async (orderItemId, status) => {
// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await updateKitchenOrderItemStatus(orderItemId, status);
// // //       toast.dismiss();
// // //       if (res.status === 200) {
// // //         sendOrderUpdateEvent();
// // //         await refreshOrders();
// // //         toast.success(res.data.message);
// // //         document.getElementById("modal-order-item-status-update").showModal();
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error?.response?.data?.message ||
// // //         "Error processing your request, Please try later!";
// // //       toast.dismiss();
// // //       console.error(error);
// // //       toast.error(message);
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 6. Cancel order                                                  */
// // //   /* --------------------------------------------------------------- */
// // //   const btnShowCancelOrderModal = (orderIds) => {
// // //     setState({ ...state, cancelOrderIds: orderIds });
// // //     document.getElementById("modal-order-cancel").showModal();
// // //   };

// // //   const btnCancelOrder = async () => {
// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await cancelKitchenOrder(state.cancelOrderIds);
// // //       toast.dismiss();
// // //       if (res.status === 200) {
// // //         sendOrderUpdateEvent();
// // //         await refreshOrders();
// // //         toast.success(res.data.message);
// // //         document.getElementById("modal-order-cancel").close();
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error?.response?.data?.message ||
// // //         "Error processing your request, Please try later!";
// // //       toast.dismiss();
// // //       console.error(error);
// // //       toast.error(message);
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 7. Complete order (already paid)                                 */
// // //   /* --------------------------------------------------------------- */
// // //   const btnShowCompleteOrderModal = (orderIds) => {
// // //     setState({ ...state, completeOrderIds: orderIds });
// // //     document.getElementById("modal-order-complete").showModal();
// // //   };

// // //   const btnCompleteOrder = async () => {
// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await completeKitchenOrder(state.completeOrderIds);
// // //       toast.dismiss();
// // //       if (res.status === 200) {
// // //         sendOrderUpdateEvent();
// // //         await refreshOrders();
// // //         toast.success(res.data.message);
// // //         document.getElementById("modal-order-complete").close();
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error?.response?.data?.message ||
// // //         "Error processing your request, Please try later!";
// // //       toast.dismiss();
// // //       console.error(error);
// // //       toast.error(message);
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 8. Pay & Complete order                                          */
// // //   /* --------------------------------------------------------------- */
// // //   const btnShowPayAndComplete = async (orderIds, order) => {
// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await getCompleteOrderPaymentSummary(orderIds);
// // //       toast.dismiss();

// // //       if (res.status === 200) {
// // //         const { subtotal, taxTotal, serviceChargeTotal, total, orders } = res.data;
// // //         const tokenNoArray = orders.map((o) => o.token_no);
// // //         const tokens = tokenNoArray.join(",");

// // //         setState({
// // //           ...state,
// // //           summaryNetTotal: subtotal,
// // //           summaryTaxTotal: taxTotal,
// // //           summaryServiceChargeTotal: serviceChargeTotal,
// // //           summaryTotal: total,
// // //           summaryOrders: orders,
// // //           completeOrderIds: orderIds,
// // //           completeTokenIds: tokens,
// // //           order: order,
// // //         });

// // //         document.getElementById("modal-order-summary-complete").showModal();
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error?.response?.data?.message ||
// // //         "Error processing your request, Please try later!";
// // //       toast.dismiss();
// // //       console.error(error);
// // //       toast.error(message);
// // //     }
// // //   };

// // //   const btnPayAndComplete = async () => {
// // //     const isPrintReceipt = printReceiptRef.current?.checked || false;

// // //     if (!state.selectedPaymentType) {
// // //       return toast.error(t("orders.select_payment_method"));
// // //     }

// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await payAndCompleteKitchenOrder(
// // //         state.completeOrderIds,
// // //         state.summaryNetTotal,
// // //         state.summaryTaxTotal,
// // //         state.summaryServiceChargeTotal,
// // //         state.summaryTotal,
// // //         state.selectedPaymentType
// // //       );
// // //       toast.dismiss();

// // //       if (res.status === 200) {
// // //         const invoiceId = res.data?.invoiceId || null;
// // //         const customerId = res.data?.customerId || null;

// // //         sendOrderUpdateEvent();
// // //         await refreshOrders();
// // //         toast.success(res.data.message);
// // //         document.getElementById("modal-order-summary-complete").close();

// // //         if (isPrintReceipt) {
// // //           const { table_id, table_title, floor } = state.order;
// // //           const orders = [];
// // //           const orderIds = state.completeOrderIds.join(", ");

// // //           for (const o of state.summaryOrders) {
// // //             o.items.forEach((i) => {
// // //               const variant = i.variant_id
// // //                 ? { id: i.variant_id, title: i.variant_title, price: i.variant_price }
// // //                 : null;
// // //               orders.push({
// // //                 ...i,
// // //                 title: i.item_title,
// // //                 addons_ids: i?.addons?.length ? i.addons.map((a) => a.id) : [],
// // //                 variant,
// // //               });
// // //             });
// // //           }

// // //           const { customer_id, customer_type, customer_name, date, delivery_type } =
// // //             state.summaryOrders[0];

// // //           const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v) => v.id == state.selectedPaymentType);
// // //           const paymentMethodText = paymentType?.title;

// // //           setDetailsForReceiptPrint({
// // //             cartItems: orders,
// // //             deliveryType: delivery_type,
// // //             customerType: customer_type,
// // //             customer: { id: customer_id, name: customer_name },
// // //             tableId: table_id,
// // //             currency,
// // //             storeSettings,
// // //             printSettings,
// // //             itemsTotal: state.summaryNetTotal,
// // //             taxTotal: state.summaryTaxTotal,
// // //             serviceChargeTotal: state.summaryServiceChargeTotal,
// // //             payableTotal: state.summaryTotal,
// // //             tokenNo: state.completeTokenIds,
// // //             orderId: orderIds,
// // //             paymentMethod: paymentMethodText,
// // //           });

// // //           const receiptWindow = window.open(
// // //             "/print-receipt",
// // //             "_blank",
// // //             "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
// // //           );
// // //           receiptWindow.onload = () => {
// // //             setTimeout(() => receiptWindow.print(), 400);
// // //           };
// // //         }

// // //         // Feedback QR
// // //         const link =
// // //           getQRMenuLink(storeSettings?.unique_qr_code) +
// // //           `/feedback?_ref=${invoiceId}${customerId ? `&_cref=${customerId}` : ""}`;

// // //         const qrDataURL = await QRCode.toDataURL(link, { width: 1080 });

// // //         if (storeSettings?.is_feedback_enabled) {
// // //           document.getElementById("modal-collect-feedback").showModal();
// // //         }

// // //         setState((prev) => ({
// // //           ...prev,
// // //           selectedPaymentType: null,
// // //           feedbackInvoiceId: invoiceId,
// // //           feedbackCustomerId: customerId,
// // //           feedbackQRCode: qrDataURL,
// // //         }));
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error?.response?.data?.message ||
// // //         "Error processing your request, Please try later!";
// // //       toast.dismiss();
// // //       console.error(error);
// // //       toast.error(message);
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 9. Print receipt (any time)                                      */
// // //   /* --------------------------------------------------------------- */
// // //   const btnPrintReceipt = async (orderIdsArr, tokens) => {
// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await getCompleteOrderPaymentSummary(orderIdsArr);
// // //       toast.dismiss();

// // //       if (res.status === 200) {
// // //         const { subtotal, taxTotal, serviceChargeTotal, total, orders: ordersArr } = res.data;
// // //         const orders = [];
// // //         const orderIds = orderIdsArr.join(", ");

// // //         for (const o of ordersArr) {
// // //           o.items.forEach((i) => {
// // //             const variant = i.variant_id
// // //               ? { id: i.variant_id, title: i.variant_title, price: i.variant_price }
// // //               : null;
// // //             orders.push({
// // //               ...i,
// // //               title: i.item_title,
// // //               addons_ids: i?.addons?.length ? i.addons.map((a) => a.id) : [],
// // //               variant,
// // //             });
// // //           });
// // //         }

// // //         const { customer_id, customer_type, customer_name, date, delivery_type } =
// // //           ordersArr[0];

// // //         setDetailsForReceiptPrint({
// // //           cartItems: orders,
// // //           deliveryType: delivery_type,
// // //           customerType: customer_type,
// // //           customer: { id: customer_id, name: customer_name },
// // //           tableId: null,
// // //           currency,
// // //           storeSettings,
// // //           printSettings,
// // //           itemsTotal: subtotal,
// // //           taxTotal: taxTotal,
// // //           serviceChargeTotal: serviceChargeTotal,
// // //           payableTotal: total,
// // //           tokenNo: tokens,
// // //           orderId: orderIds,
// // //         });

// // //         const receiptWindow = window.open(
// // //           "/print-receipt",
// // //           "_blank",
// // //           "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
// // //         );
// // //         receiptWindow.onload = () => {
// // //           setTimeout(() => receiptWindow.print(), 400);
// // //         };
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error?.response?.data?.message ||
// // //         "Error processing your request, Please try later!";
// // //       toast.dismiss();
// // //       console.error(error);
// // //       toast.error(message);
// // //     }
// // //   };

// // //   /* --------------------------------------------------------------- */
// // //   /* 10. Collect feedback                                             */
// // //   /* --------------------------------------------------------------- */
// // //   const btnCollectFeedback = async (orderIdsArr) => {
// // //     try {
// // //       toast.loading(t("orders.loading_message"));
// // //       const res = await getInvoiceIdFromOrderId(orderIdsArr);
// // //       toast.dismiss();

// // //       if (res.status === 200) {
// // //         const { invoiceId, customerId } = res.data;

// // //         if (!invoiceId) {
// // //           toast.error("Please finish the order to collect feedback!");
// // //           return;
// // //         }

// // //         const link =
// // //           getQRMenuLink(storeSettings?.unique_qr_code) +
// // //           `/feedback?_ref=${invoiceId}${customerId ? `&_cref=${customerId}` : ""}`;

// // //         const qrDataURL = await QRCode.toDataURL(link, { width: 1080 });

// // //         setState({
// // //           ...state,
// // //           feedbackInvoiceId: invoiceId,
// // //           feedbackCustomerId: customerId,
// // //           feedbackQRCode: qrDataURL,
// // //         });

// // //         document.getElementById("modal-collect-feedback").showModal();
// // //       }
// // //     } catch (error) {
// // //       const message =
// // //         error?.response?.data?.message ||
// // //         "Error processing your request, Please try later!";
// // //       toast.dismiss();
// // //       console.error(error);
// // //       toast.error(message);
// // //     }
// // //   };

// // //   const btnOpenFeedbackLink = () => {
// // //     const a = document.createElement("a");
// // //     a.href =
// // //       getQRMenuLink(storeSettings?.unique_qr_code) +
// // //       `/feedback?_ref=${state.feedbackInvoiceId}${
// // //         state.feedbackCustomerId ? `&_cref=${state.feedbackCustomerId}` : ""
// // //       }`;
// // //     a.target = "_blank";
// // //     a.click();
// // //     a.remove();
// // //     document.getElementById("modal-collect-feedback").close();
// // //   };



// // //   return (
// // //     <Page>
// // //       <div className="flex items-center gap-6">
// // //         <h3 className="text-3xl font-light">{t('orders.title')}</h3>
// // //         <button
// // //           onClick={refreshOrders}
// // //           className = "flex items-center gap-1 rounded-xl text-restro-text shadow-none transition active:scale-95 px-2 py-1 bg-restro-gray hover:bg-restro-button-hover border border-restro-border-green"
// // //         >
// // //           <IconRefresh size={22} stroke={iconStroke} /> {t('orders.refresh')}
// // //         </button>
// // //       </div>

// // //       {kitchenOrders?.length == 0 && (
// // //         <div className="w-full h-[calc(100vh-15vh)] flex gap-4 flex-col items-center justify-center">
// // //           <img
// // //             src="/assets/illustrations/orders-not-found.webp"
// // //             alt={t('orders.no_orders_img_alt')}
// // //             className="w-1/2 md:w-60"
// // //           />
// // //           <p className="text-gray-400">{t('orders.no_orders')}</p>
// // //         </div>
// // //       )}

// // //       {kitchenOrders?.length > 0 && (
// // //         <div className={`mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 `}>
// // //           {kitchenOrders.map((order, index) => {
// // //             const { table_id, table_title, floor, orders, order_ids } = order;

// // //             const tokenNoArray = orders.map(o=>o.token_no);
// // //             const tokens = tokenNoArray.join(",")

// // //             const isPaid = orders.every((o)=>o.payment_status=='paid');

// // //             return (
// // //               <div
// // //                 key={index}
// // //                 className = "flex flex-col divide-y divide-dashed divide-gray-200 dark:divide-gray-700 px-4 py-5 border rounded-2xl border-restro-border-green"
// // //               >
// // //                 <div className="flex md:items-center flex-col md:flex-row md:justify-between md:text-center gap-2 pb-2">
// // //                   <div className="flex items-center gap-2">
// // //                     <div className = "flex w-12 h-12 rounded-full items-center justify-center bg-restro-gray">
// // //                       {table_id ? (
// // //                         <IconArmchair size={24} stroke={iconStroke} />
// // //                       ) : (
// // //                         <IconReceipt size={24} stroke={iconStroke} />
// // //                       )}
// // //                     </div>
// // //                     <div>
// // //                       <p className="font-bold">
// // //                         {table_id ? `${table_title}` : "Dine Out / Delivery"}
// // //                       </p>
// // //                       {floor && <p className="text-sm">{floor}</p>}
// // //                     </div>
// // //                   </div>
// // //                   <div className="dropdown dropdown-end">
// // //                     <div
// // //                       tabIndex={0}
// // //                       role="button"
// // //                       className="m-1 btn btn-sm btn-circle bg-transparent border-none shadow-none p-2 rounded-full hover:bg-restro-button-hover"
// // //                     >
// // //                       <IconDotsVertical size={18} stroke={iconStroke} />
// // //                     </div>
// // //                     <ul
// // //                       tabIndex={0}
// // //                       className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-lg w-52 border border-restro-border-green "
// // //                     >
// // //                       <li>
// // //                         <button
// // //                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
// // //                           onClick={() => {
// // //                             btnPrintReceipt(order_ids, tokens);
// // //                           }}
// // //                         >
// // //                           <IconReceipt size={18} stroke={iconStroke} /> {t('orders.print_receipt')}
// // //                         </button>
// // //                       </li>
// // //                       {storeSettings?.is_feedback_enabled ? <li>
// // //                         <button
// // //                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
// // //                           onClick={() => {
// // //                             btnCollectFeedback(order_ids);
// // //                           }}
// // //                         >
// // //                           <IconStars size={18} stroke={iconStroke} /> {t('orders.collect_feedback')}
// // //                         </button>
// // //                       </li>:<></>}
// // //                       <li>
// // //                         <button
// // //                           className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
// // //                           onClick={() => {
// // //                             btnShowCancelOrderModal(order_ids);
// // //                           }}
// // //                         >
// // //                           <IconX size={18} stroke={iconStroke} /> {t('orders.cancel')}
// // //                         </button>
// // //                       </li>
// // //                       <li>
// // //                         <button
// // //                           className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
// // //                           onClick={() => {
// // //                             if(isPaid == false) {
// // //                               toast.error(t('orders.payment_not_collected_error'));
// // //                               return;
// // //                             }
// // //                             btnShowCompleteOrderModal(order_ids);
// // //                           }}
// // //                         >
// // //                           <IconCheck size={18} stroke={iconStroke} /> {t('orders.complete')}
// // //                         </button>
// // //                       </li>
// // //                       <li>
// // //                         <button
// // //                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
// // //                           onClick={() => {
// // //                             if(isPaid == true) {
// // //                               toast.error(t('orders.payment_already_collected_error'));
// // //                               return;
// // //                             }
// // //                             btnShowPayAndComplete(order_ids, order);
// // //                           }}
// // //                         >
// // //                           <IconCash size={18} stroke={iconStroke} /> {t('orders.pay_complete')}
// // //                         </button>
// // //                       </li>
// // //                     </ul>
// // //                   </div>
// // //                 </div>

// // //                 {orders.map((o, i) => {
// // //                   const {
// // //                     id,
// // //                     date,
// // //                     delivery_type,
// // //                     customer_type,
// // //                     customer_id,
// // //                     customer_name,
// // //                     status,
// // //                     payment_status,
// // //                     token_no,
// // //                     items,
// // //                   } = o;

// // //                   return (
// // //                     <div className = "py-2 px-2 mt-2 mb-2 rounded-xl bg-gray-50 dark:bg-restro-gray" key={i}>
// // //                       <div className="flex items-center justify-between gap-2">
// // //                         <div className="flex items-center justify-center flex-col text-center">
// // //                           <p>{t('orders.token')}</p>
// // //                           <div className = "w-12 h-12 flex items-center justify-center font-bold rounded-full bg-gray-700 dark:bg-[#0a0a0a] text-white" >
// // //                             {token_no}
// // //                           </div>
// // //                         </div>
// // //                         <div className="text-end">
// // //                           <p>
// // //                             {moment(date).format("hh:mm A")}
// // //                           </p>
// // //                           <p className={clsx("flex gap-2 items-center text-sm", {
// // //                             "text-amber-500": payment_status == "pending",
// // //                             "text-restro-green": payment_status == "paid",
// // //                           })}>
// // //                             {" "}
// // //                             <IconCash stroke={iconStroke} size={18} />{" "}
// // //                             {payment_status.toUpperCase()}
// // //                           </p>
// // //                         </div>
// // //                       </div>

// // //                       {/* order items */}
// // //                       <div className="mt-4 flex flex-col divide-y divide-gray-200 dark:divide-gray-700">
// // //                         {items.map((item, index) => {
// // //                           const {
// // //                             id: orderItemId,
// // //                             order_id,
// // //                             item_id,
// // //                             item_title,
// // //                             variant_id,
// // //                             variant_title,
// // //                             quantity,
// // //                             status,
// // //                             date,
// // //                             addons,
// // //                             notes,
// // //                           } = item;

// // //                           const addonsText =
// // //                             addons?.length > 0
// // //                               ? addons?.map((a) => a?.title)?.filter(Boolean)?.join(", ")
// // //                               : null;

// // //                           return (
// // //                             <div
// // //                               key={index}
// // //                               className="flex items-center gap-2 py-2"
// // //                             >
// // //                               {/* status */}
// // //                               {status == "preparing" && (
// // //                                 <IconClock
// // //                                   stroke={iconStroke}
// // //                                   className="text-restro-yellow"
// // //                                 />
// // //                               )}
// // //                               {status == "completed" && (
// // //                                 <IconCheck
// // //                                   stroke={iconStroke}
// // //                                   className="text-restro-green"
// // //                                 />
// // //                               )}
// // //                               {status == "cancelled" && (
// // //                                 <IconX
// // //                                   stroke={iconStroke}
// // //                                   className="text-restro-red"
// // //                                 />
// // //                               )}
// // //                               {status == "delivered" && (
// // //                                 <IconChecks
// // //                                   stroke={iconStroke}
// // //                                   className="text-restro-green"
// // //                                 />
// // //                               )}
// // //                               {/* status */}

// // //                               {/* item title */}
// // //                               <div className="flex-1">
// // //                                 <p>
// // //                                   {item_title} {variant_title} x {quantity}
// // //                                 </p>
// // //                                 {addonsText && (
// // //                                   <p className="text-sm text-gray-700 dark:text-white">
// // //                                     Addons: {addonsText}
// // //                                   </p>
// // //                                 )}
// // //                                 {notes && (
// // //                                   <p className="text-sm text-gray-700 dark:text-white">
// // //                                     Notes: {notes}
// // //                                   </p>
// // //                                 )}
// // //                               </div>
// // //                               {/* item title */}

// // //                               {/* action */}
// // //                               <div className="dropdown dropdown-left">
// // //                                 <div
// // //                                   tabIndex={0}
// // //                                   role="button"
// // //                                   className="btn btn-sm btn-circle bg-transparent border-none shadow-none m-1"
// // //                                 >
// // //                                   <IconDotsVertical
// // //                                     size={18}
// // //                                     stroke={iconStroke}
// // //                                   />
// // //                                 </div>
// // //                                 <ul
// // //                                   tabIndex={0}
// // //                                   className="dropdown-content z-[1] menu p-2 shadow bg-base-100 w-52 rounded-lg border border-restro-border-green"
// // //                                 >
// // //                                   <li>
// // //                                     <button
// // //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-yellow"
// // //                                       onClick={() => {
// // //                                         btnChangeOrderItemStatus(
// // //                                           orderItemId,
// // //                                           "preparing"
// // //                                         );
// // //                                       }}
// // //                                     >
// // //                                       <IconClock
// // //                                         size={18}
// // //                                         stroke={iconStroke}
// // //                                       />{" "}
// // //                                       {t('orders.preparing')}
// // //                                     </button>
// // //                                   </li>
// // //                                   <li>
// // //                                     <button
// // //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
// // //                                       onClick={() => {
// // //                                         btnChangeOrderItemStatus(
// // //                                           orderItemId,
// // //                                           "completed"
// // //                                         );
// // //                                       }}
// // //                                     >
// // //                                       <IconCheck
// // //                                         size={18}
// // //                                         stroke={iconStroke}
// // //                                       />{" "}
// // //                                       {t('orders.completed')}
// // //                                     </button>
// // //                                   </li>
// // //                                   <li>
// // //                                     <button
// // //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none "
// // //                                       onClick={() => {
// // //                                         btnChangeOrderItemStatus(
// // //                                           orderItemId,
// // //                                           "delivered"
// // //                                         );
// // //                                       }}
// // //                                     >
// // //                                       <IconChecks
// // //                                         size={18}
// // //                                         stroke={iconStroke}
// // //                                       />{" "}
// // //                                       {t('orders.delivered')}
// // //                                     </button>
// // //                                   </li>
// // //                                   <li>
// // //                                     <button
// // //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
// // //                                       onClick={() => {
// // //                                         btnChangeOrderItemStatus(
// // //                                           orderItemId,
// // //                                           "cancelled"
// // //                                         );
// // //                                       }}
// // //                                     >
// // //                                       <IconX size={18} stroke={iconStroke} />{" "}
// // //                                       {t('orders.cancelled')}
// // //                                     </button>
// // //                                   </li>
// // //                                 </ul>
// // //                               </div>
// // //                               {/* action */}
// // //                             </div>
// // //                           );
// // //                         })}
// // //                       </div>
// // //                       {/* order items */}
// // //                     </div>
// // //                   );
// // //                 })}
// // //               </div>
// // //             );
// // //           })}
// // //         </div>
// // //       )}

// // //       {/* dialog: successful order item status update */}
// // //       <dialog id="modal-order-item-status-update" className="modal">
// // //         <div className = "modal-box border border-restro-border-green rounded-2xl">
// // //           <h3 className="font-bold text-lg">{t('orders.success')}</h3>
// // //           <p className="py-4">{t('orders.order_item_status_success')}</p>
// // //           <div className="modal-action">
// // //             <form method="dialog">
// // //               {/* if there is a button in form, it will close the modal */}
// // //               <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl dark:hover:border-restro-gray">{t('orders.close')}</button>
// // //             </form>
// // //           </div>
// // //         </div>
// // //       </dialog>
// // //       {/* dialog: successful order item status update */}

// // //       {/* dialog: cancel order */}
// // //       <dialog id="modal-order-cancel" className="modal">
// // //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// // //           <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
// // //           <p className="py-4">
// // //             {t('orders.cancel_order_alert')}
// // //           </p>
// // //           <div className="modal-action">
// // //             <form method="dialog">
// // //               {/* if there is a button in form, it will close the modal */}
// // //               <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl bg-restro-gray hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
// // //               <button
// // //                 onClick={() => {
// // //                   btnCancelOrder();
// // //                 }}
// // //                 className={`ml-2 btn bg-restro-red text-white hover:bg-red-500 transition active:scale-95 px-4 py-3 rounded-xl border-restro-red hover:border-red-600`}
// // //               >
// // //                 {t('orders.confirm')}
// // //               </button>
// // //             </form>
// // //           </div>
// // //         </div>
// // //       </dialog>
// // //       {/* dialog: cancel order */}

// // //       {/* dialog: complete order */}
// // //       <dialog id="modal-order-complete" className="modal">
// // //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// // //           <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
// // //           <p className="py-4">
// // //             {t('orders.complete_order_alert')}
// // //           </p>
// // //           <div className="modal-action">
// // //             <form method="dialog">
// // //               {/* if there is a button in form, it will close the modal */}
// // //               <button className="btn border-restro-gray bg-restro-gray rounded-xl hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
// // //               <button
// // //                 onClick={() => {
// // //                   btnCompleteOrder();
// // //                 }}
// // //                 className="ml-2 btn bg-restro-green border-restro-green-light hover:bg-restro-green-button-hover rounded-xl"
// // //               >
// // //                 {t('orders.confirm')}
// // //               </button>
// // //             </form>
// // //           </div>
// // //         </div>
// // //       </dialog>
// // //       {/* dialog: complete order */}

// // //       {/* dialog: complete order & payment summary */}
// // //       <dialog id="modal-order-summary-complete" className="modal">
// // //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// // //           <div className="flex items-center justify-between">
// // //             <h3 className="font-bold text-lg">{t('orders.pay_complete_order')}</h3>
// // //             <form method='dialog'>
// // //               <button className="btn btn-sm btn-circle text-restro-red border-none transition active:scale-95 hover:bg-restro-gray"><IconX size={18} stroke={iconStroke} /></button>
// // //             </form>
// // //           </div>

// // //           <div className="my-6">
// // //             <div className="my-8 space-y-4 px-1">
// // //             {[
// // //               { label: t('orders.items_net_total'), value: state.summaryNetTotal },
// // //               { label: t('orders.tax_total'), value: state.summaryTaxTotal, prefix: "+" },
// // //               { label: t('orders.service_charge_total'), value: state.summaryServiceChargeTotal, prefix: "+" },
// // //             ].map(({ label, value, prefix = "" }, index) => (
// // //               <div key={index} className="flex items-center justify-between text-restro-text">
// // //                 <p>{label}</p>
// // //                 <p className="text-lg">
// // //                   {prefix}{currency}{value.toFixed(2)}
// // //                 </p>
// // //               </div>
// // //             ))}

// // //             <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
// // //               <p className="text-xl font-medium">{t('orders.payable_total')}</p>
// // //               <p className="text-xl font-bold text-restro-green">
// // //                 {currency}{state.summaryTotal.toFixed(2)}
// // //               </p>
// // //             </div>
// // //           </div>

// // //             <label
// // //               htmlFor="print_receipt"
// // //               className="mt-4 w-full flex justify-end items-center gap-2 "
// // //             >
// // //               <input
// // //                 type="checkbox"
// // //                 className="checkbox rounded-lg"
// // //                 id="print_receipt"
// // //                 ref={printReceiptRef}
// // //               />{" "}
// // //               {t('orders.print_receipt_option')}
// // //             </label>
// // //           </div>

// // //           <div className="grid grid-cols-3 gap-2">
// // //             {(paymentTypes||[]).map((paymentType, i)=>{
// // //               const uniqueId = `icon-${paymentType?.id}`;
// // //               return <label key={i} className=''>
// // //                 <input
// // //                 checked={state?.selectedPaymentType == paymentType?.id}
// // //                 onChange={e=>{
// // //                   setState({
// // //                     ...state,
// // //                     selectedPaymentType: e.target.value,
// // //                   });
// // //                 }} type="radio" name="payment_type" id={uniqueId} value={paymentType?.id} className='peer hidden' />
// // //                 <label htmlFor={uniqueId} className='border dark:border-restro-gray rounded-2xl flex items-center justify-center gap-1 flex-col px-4 py-3 peer-checked:border-restro-green peer-checked:text-restro-green peer-checked:font-bold cursor-pointer transition'>
// // //                   {paymentType?.icon ? <div>{PAYMENT_ICONS[paymentType?.icon]}</div>:<></>}
// // //                   <p className='text-xs'>{paymentType.title}</p>
// // //                 </label>
// // //               </label>
// // //             })}
// // //           </div>

// // //           <div className="modal-action">
            
// // //               {/* if there is a button in form, it will close the modal */}
// // //               <button
// // //                 onClick={() => {
// // //                   btnPayAndComplete();
// // //                 }}
// // //                 className="w-full rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 bg-restro-green hover:bg-restro-green-button-hover"
// // //               >
// // //                 {t('orders.pay_complete_order')}
// // //               </button>
           
// // //           </div>
// // //         </div>
// // //       </dialog>
// // //       {/* dialog: complete order & payment summary */}

// // //       {/* dialog: complete order */}
// // //       <dialog id="modal-collect-feedback" className="modal">
// // //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// // //           <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-restro-gray">
// // //             <IconStars stroke={iconStroke} />
// // //           </div>
// // //           <h3 className="mt-4 font-bold text-lg text-center">{t('orders.collect_feedback')}</h3>

// // //           <div className="absolute top-6 right-6">
// // //             <form method="dialog">
// // //               <button className="btn btn-sm btn-circle border-none transition active:scale-95 text-restro-red hover:bg-restro-button-hover">
// // //                 <IconX stroke={iconStroke} size={18} />
// // //               </button>
// // //             </form>
// // //           </div>

// // //           <div className="my-4">
// // //             <img src={state.feedbackQRCode} alt={t('orders.feedback_qr_img_alt')} className="w-52 h-52 mx-auto border rounded-lg" />
// // //           </div>

// // //           <p className="text-center italic mb-10" dangerouslySetInnerHTML={{__html: t('orders.feedback_message')}}>

// // //           </p>

// // //           <div className="flex items-center gap-2 text-sm">
// // //             <div className="flex-1 border-b border-restro-gray"></div>
// // //             <div className="w-12 h-12 flex items-center justify-center rounded-full bg-restro-gray">
// // //               OR
// // //             </div>
// // //             <div className="flex-1 border-b border-restro-gray"></div>
// // //           </div>

// // //           <div className="modal-action justify-center">
// // //             <form method="dialog">
// // //               <button
// // //                 onClick={() => {
// // //                   btnOpenFeedbackLink();
// // //                 }}
// // //                 className="btn ml-2 transition active:scale-95 hover:shadow-lg px-4 py-3 border bg-restro-green hover:bg-restro-green-button-hover text-white rounded-xl"
// // //               >
// // //                 {t('orders.open_in_new_tab')} <IconExternalLink stroke={iconStroke} />
// // //               </button>
// // //             </form>
// // //           </div>
// // //           </div>
// // //       </dialog>
// // //       {/* dialog: complete order */}

// // //     </Page>
// // //   );
// // // }
// // import React, { useContext, useEffect, useRef, useState } from "react";
// // import { useTranslation } from "react-i18next";
// // import Page from "../components/Page";
// // import {
// //   cancelKitchenOrder,
// //   completeKitchenOrder,
// //   getCompleteOrderPaymentSummary,
// //   getInvoiceIdFromOrderId,
// //   getOrders,
// //   getOrdersInit,
// //   payAndCompleteKitchenOrder,
// //   updateKitchenOrderItemStatus,
// // } from "../controllers/orders.controller";
// // import { toast } from "react-hot-toast";
// // import {
// //   IconArmchair,
// //   IconBoxSeam,
// //   IconCash,
// //   IconCheck,
// //   IconChecks,
// //   IconClock,
// //   IconDotsVertical,
// //   IconExternalLink,
// //   IconReceipt,
// //   IconRefresh,
// //   IconStars,
// //   IconX,
// // } from "@tabler/icons-react";
// // import { FRONTEND_DOMAIN, VITE_BACKEND_SOCKET_IO, iconStroke } from "../config/config";
// // import { CURRENCIES } from "../config/currencies.config";
// // import { PAYMENT_ICONS } from "../config/payment_icons";
// // import { setDetailsForReceiptPrint } from "../helpers/ReceiptHelper";

// // import { useSocket } from "../contexts/SocketContext";

// // import { textToSpeech } from "../utils/textToSpeech";
// // import { getUserDetailsInLocalStorage } from "../helpers/UserDetails";
// // import QRCode from "qrcode"
// // import { getQRMenuLink } from "../helpers/QRMenuHelper";
// // import { useTheme } from "../contexts/ThemeContext";
// // import clsx from "clsx";

// // export default function OrdersPage() {
// //   const { t } = useTranslation();
// //   const { theme } = useTheme();
// //   const printReceiptRef = useRef();
// //   const user = getUserDetailsInLocalStorage();
// //   const { socket, isConnected, safeEmit, initSocket, getSocket, waitForConnection, disconnectSocket } = useSocket();

// //   const [state, setState] = useState({
// //     kitchenOrders: [],
// //     printSettings: null,
// //     storeSettings: null,
// //     paymentTypes: [],
// //     isLoading: true,

// //     cancelOrderIds: [],
// //     completeOrderIds: [],
// //     completeTokenIds: "",

// //     currency: null,

// //     summaryNetTotal: 0,
// //     summaryTaxTotal: 0,
// //     summaryServiceChargeTotal:0,
// //     summaryTotal: 0,
// //     summaryOrders: [],
// //     order: null,

// //     selectedPaymentType: null,

// //     feedbackInvoiceId: null,
// //     feedbackCustomerId: null,
// //     feedbackQRCode: null,
// //   });

// // useEffect(() => {
// //   // Initialize your page and socket
// //   _init();
// //   _initSocket();

// //   // Cleanup on unmount
// //   return () => {
// //     try {
// //       // ✅ Use getSocket() to safely access the current socket instance
// //       const s = getSocket();
// //       if (s) {
// //         s.off("new_order");
// //         s.off("order_update");
// //       }

// //       // 🔌 Optional: fully disconnect the socket when leaving this page
// //       // disconnectSocket();
// //     } catch (err) {
// //       console.warn("⚠️ Socket cleanup failed:", err);
// //     }
// //   };
// // }, []); // 👈 keep this dependency array empty


// //   const {
// //     kitchenOrders,
// //     printSettings,
// //     storeSettings,
// //     paymentTypes,
// //     isLoading,
// //     currency,
// //   } = state;

// //   const _init = async () => {
// //     try {
// //       const [ordersResponse, ordersInitResponse] = await Promise.all([
// //         getOrders(),
// //         getOrdersInit(),
// //       ]);

// //       if (ordersResponse.status == 200 && ordersInitResponse.status == 200) {
// //         const orders = ordersResponse?.data || [];
// //         const ordersInit = ordersInitResponse.data;

// //         const currency = CURRENCIES.find(
// //           (c) => c.cc == ordersInit?.storeSettings?.currency
// //         );

// //         setState({
// //           ...state,
// //           kitchenOrders: orders,
// //           printSettings: ordersInit.printSettings || {},
// //           storeSettings: ordersInit.storeSettings || {},
// //           paymentTypes: ordersInit.paymentTypes || [],
// //           currency: currency?.symbol,
// //           isLoading: false,
// //         });
// //       }
// //     } catch (error) {
// //       console.error(error);
// //       toast.dismiss();
// //       toast.error("Error loading orders! Please try later!");

// //       setState({
// //         ...state,
// //         isLoading: false,
// //       });
// //     }
// //   };

// //   const refreshOrders = async () => {
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await getOrders();
// //       toast.dismiss();
// //       if (res.status == 200) {
// //         toast.success(t('orders.orders_loaded'));
// //         setState({
// //           ...state,
// //           kitchenOrders: res.data,
// //           isLoading: false,
// //         });
// //       }
// //     } catch (error) {
// //       const message =
// //         error.response.data.message ||
// //         "Error loading orders! Please try later!";
// //       console.error(error);
// //       toast.dismiss();
// //       toast.error(message);
// //       setState({
// //         ...state,
// //         isLoading: false,
// //       });
// //     }
// //   };

// //  // Replace your existing _initSocket with this
// // const _initSocket = async () => {
// //   const audio = new Audio("/new_order_sound.mp3");

// //   try {
// //     // 1) ensure socket exists / start it (idempotent)
// //     initSocket();

// //     // 2) wait a short time for socket to connect (don't block forever)
// //     try {
// //       await waitForConnection(8000); // waits up to 8s
// //     } catch (waitErr) {
// //       console.warn("Socket did not connect within 8s:", waitErr?.message || waitErr);
// //     }

// //     // 3) get current socket instance
// //     const s = getSocket();
// //     if (!s) {
// //       console.warn("Socket instance not available after init");
// //       return;
// //     }

// //     // 4) if not connected, don't attempt to use emit directly — safeEmit will handle waiting
// //     if (!s.connected) {
// //       console.warn("Socket is not connected yet; will still attempt to authenticate via safeEmit");
// //     }

// //     // 5) remove old listeners to avoid duplicate handlers
// //     s.off("new_order");
// //     s.off("order_update");

// //     // 6) authenticate safely (this will wait if needed)
// //     try {
// //       await safeEmit("authenticate", user.tenant_id, { wait: true, timeout: 5000 });
// //       console.log("Socket authenticated for tenant:", user.tenant_id);
// //     } catch (authErr) {
// //       console.warn("Socket authenticate failed (continuing):", authErr?.message || authErr);
// //     }

// //     // 7) attach listeners (we use the raw socket for on/off)
// //     s.on("new_order", (payload) => {
// //       try {
// //         console.log("socket new_order payload:", payload);
// //         // optional: speak the token
// //         // textToSpeech(`New order received, token number: ${payload}`);
// //         audio.play().catch((e) => console.warn("audio play failed:", e));
// //         if (typeof refreshOrders === "function") {
// //           refreshOrders();
// //         } else {
// //           console.warn("refreshOrders is not a function");
// //         }
// //       } catch (err) {
// //         console.error("new_order handler error:", err);
// //       }
// //     });

// //     s.on("order_update", () => {
// //       try {
// //         console.log("socket order_update");
// //         if (typeof refreshOrders === "function") {
// //           refreshOrders();
// //         }
// //       } catch (err) {
// //         console.error("order_update handler error:", err);
// //       }
// //     });

// //     console.log("Socket listeners for new_order/order_update attached.");
// //   } catch (err) {
// //     console.error("_initSocket: unexpected error", err);
// //   }
// // };


// // // Replace your current sendOrderUpdateEvent with this:
// // const sendOrderUpdateEvent = async () => {
// //   try {
// //     const userLocal = getUserDetailsInLocalStorage(); // tenant_id

// //     // Prefer the raw socket if it's connected
// //     const s = getSocket();
// //     if (s && s.connected) {
// //       s.emit("order_update_backend", {}, userLocal.tenant_id);
// //       return;
// //     }

// //     // Otherwise try to (re)initialize and use safeEmit which handles waiting
// //     initSocket();

// //     try {
// //       // wait a short time for connection, but don't block forever
// //       await waitForConnection(5000);
// //     } catch (waitErr) {
// //       // continue — safeEmit will still try to send and/or wait
// //       console.warn("Socket did not connect within 5s (continuing with safeEmit)", waitErr?.message || waitErr);
// //     }

// //     // Use safeEmit (safeEmit implementation should handle waiting / queuing)
// //     // Note: safeEmit arguments depend on your util; below we send payload then tenant id as in old emit
// //     await safeEmit("order_update_backend", {}, userLocal.tenant_id);
// //   } catch (err) {
// //     console.warn("sendOrderUpdateEvent failed:", err);
// //   }
// // };


// //   if (state.isLoading) {
// //     return <Page>{t('orders.loading_message')}</Page>;
// //   }

// //   const btnChangeOrderItemStatus = async (orderItemId, status) => {
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await updateKitchenOrderItemStatus(orderItemId, status);
// //       toast.dismiss();
// //       if (res.status == 200) {
// //         sendOrderUpdateEvent();
// //         await refreshOrders();
// //         toast.success(res.data.message);
// //         document.getElementById("modal-order-item-status-update").showModal();
// //       }
// //     } catch (error) {
// //       const message =
// //         error?.response?.data?.message ||
// //         "Error processing your request, Please try later!";
// //       toast.dismiss();
// //       console.error(error);
// //       toast.error(message);
// //     }
// //   };

// //   const btnShowCancelOrderModal = (orderIds) => {
// //     setState({
// //       ...state,
// //       cancelOrderIds: orderIds,
// //     });
// //     document.getElementById("modal-order-cancel").showModal();
// //   };
// //   const btnCancelOrder = async () => {
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await cancelKitchenOrder(state.cancelOrderIds);
// //       toast.dismiss();
// //       if (res.status == 200) {
// //         sendOrderUpdateEvent();
// //         await refreshOrders();
// //         toast.success(res.data.message);
// //         document.getElementById("modal-order-cancel").close();
// //       }
// //     } catch (error) {
// //       const message =
// //         error?.response?.data?.message ||
// //         "Error processing your request, Please try later!";
// //       toast.dismiss();
// //       console.error(error);
// //       toast.error(message);
// //     }
// //   };

// //   const btnShowCompleteOrderModal = (orderIds) => {
// //     setState({
// //       ...state,
// //       completeOrderIds: orderIds,
// //     });
// //     document.getElementById("modal-order-complete").showModal();
// //   };
// //   const btnCompleteOrder = async () => {
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await completeKitchenOrder(state.completeOrderIds);
// //       toast.dismiss();
// //       if (res.status == 200) {
// //         sendOrderUpdateEvent();
// //         await refreshOrders();
// //         toast.success(res.data.message);
// //         document.getElementById("modal-order-complete").close();
// //       }
// //     } catch (error) {
// //       const message =
// //         error?.response?.data?.message ||
// //         "Error processing your request, Please try later!";
// //       toast.dismiss();
// //       console.error(error);
// //       toast.error(message);
// //     }
// //   };

// //   const btnShowPayAndComplete = async (orderIds, order) => {
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await getCompleteOrderPaymentSummary(orderIds);
// //       toast.dismiss();

// //       if (res.status == 200) {
// //         const { subtotal, taxTotal, serviceChargeTotal, total, orders } = res.data;


// //         const tokenNoArray = orders.map(o=>o.token_no);
// //         const tokens = tokenNoArray.join(",");

// //         setState({
// //           ...state,
// //           summaryNetTotal: subtotal,
// //           summaryTaxTotal: taxTotal,
// //           summaryServiceChargeTotal:serviceChargeTotal,
// //           summaryTotal: total,
// //           summaryOrders: orders,
// //           completeOrderIds: orderIds,
// //           completeTokenIds: tokens,
// //           order: order,
// //         });

// //         document.getElementById("modal-order-summary-complete").showModal();
// //       }
// //     } catch (error) {
// //       const message =
// //         error?.response?.data?.message ||
// //         "Error processing your request, Please try later!";
// //       toast.dismiss();
// //       console.error(error);
// //       toast.error(message);
// //     }
// //   };
// //   const btnPayAndComplete = async () => {
// //     const isPrintReceipt = printReceiptRef.current.checked || false;

// //     if(!state.selectedPaymentType) {
// //       return toast.error(t('orders.select_payment_method'));
// //     }
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await payAndCompleteKitchenOrder(
// //         state.completeOrderIds,
// //         state.summaryNetTotal,
// //         state.summaryTaxTotal,
// //         state.summaryServiceChargeTotal,
// //         state.summaryTotal,
// //         state.selectedPaymentType,
// //       );
// //       toast.dismiss();
// //       if (res.status == 200) {
// //         const invoiceId = res.data?.invoiceId || null;
// //         const customerId = res.data?.customerId || null;

// //         sendOrderUpdateEvent();
// //         await refreshOrders();
// //         toast.success(res.data.message);
// //         document.getElementById("modal-order-summary-complete").close();

// //         if (isPrintReceipt) {
// //           const { table_id, table_title, floor } = state.order;

// //           const orders = [];
// //           const orderIds = state.completeOrderIds.join(", ");

// //           for (const o of state.summaryOrders) {
// //             const items = o.items;
// //             items.forEach((i) => {
// //               const variant = i.variant_id
// //                 ? {
// //                     id: i.variant_id,
// //                     title: i.variant_title,
// //                     price: i.variant_price,
// //                   }
// //                 : null;
// //               orders.push({
// //                 ...i,
// //                 title: i.item_title,
// //                 addons_ids:
// //                   i?.addons?.length > 0 ? i?.addons?.map((a) => a.id) : [],
// //                 variant: variant,
// //               });
// //             });
// //           }

// //           const {
// //             customer_id,
// //             customer_type,
// //             customer_name,
// //             date,
// //             delivery_type,
// //           } = state.summaryOrders[0];

// //           const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v)=>v.id == state.selectedPaymentType);
// //           let paymentMethodText;
// //           if(paymentType) {
// //             paymentMethodText = paymentType.title;
// //           }

// //           setDetailsForReceiptPrint({
// //             cartItems: orders,
// //             deliveryType: delivery_type,
// //             customerType: customer_type,
// //             customer: { id: customer_id, name: customer_name },
// //             tableId: table_id,
// //             currency,
// //             storeSettings,
// //             printSettings,
// //             itemsTotal: state.summaryNetTotal,
// //             taxTotal: state.summaryTaxTotal,
// //             serviceChargeTotal:state.summaryServiceChargeTotal,
// //             payableTotal: state.summaryTotal,
// //             tokenNo: state.completeTokenIds,
// //             orderId: orderIds,
// //             paymentMethod: paymentMethodText
// //           });

// //           const receiptWindow = window.open(
// //             "/print-receipt",
// //             "_blank",
// //             "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
// //           );
// //           receiptWindow.onload = (e) => {
// //             setTimeout(() => {
// //               receiptWindow.print();
// //             }, 400);
// //           };
// //         }



// //         // Feedback
// //         const link = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${invoiceId}${customerId?`&_cref=${customerId}`:''}`

// //         const qrDataURL = await QRCode.toDataURL(link, {width: 1080});

// //         if(storeSettings?.is_feedback_enabled) {
// //           document.getElementById("modal-collect-feedback").showModal();
// //         }

// //         setState((prev)=>({...prev,
// //           selectedPaymentType: null,
// //           feedbackInvoiceId: invoiceId,
// //           feedbackCustomerId: customerId,
// //           feedbackQRCode: qrDataURL
// //         }));
// //         // Feedback
// //       }
// //     } catch (error) {
// //       const message =
// //         error?.response?.data?.message ||
// //         "Error processing your request, Please try later!";
// //       toast.dismiss();
// //       console.error(error);
// //       toast.error(message);
// //     }
// //   };

// //   const btnPrintReceipt = async (orderIdsArr, tokens) => {
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await getCompleteOrderPaymentSummary(orderIdsArr);
// //       toast.dismiss();

// //       if (res.status == 200) {
// //         const { subtotal, taxTotal, serviceChargeTotal, total, orders: ordersArr } = res.data;

// //         const orders = [];
// //         const orderIds = orderIdsArr.join(", ");

// //         for (const o of ordersArr) {
// //           const items = o.items;
// //           items.forEach((i) => {
// //             const variant = i.variant_id
// //               ? {
// //                   id: i.variant_id,
// //                   title: i.variant_title,
// //                   price: i.variant_price,
// //                 }
// //               : null;
// //             orders.push({
// //               ...i,
// //               title: i.item_title,
// //               addons_ids:
// //                 i?.addons?.length > 0 ? i?.addons?.map((a) => a.id) : [],
// //               variant: variant,
// //             });
// //           });
// //         }

// //         const {
// //           customer_id,
// //           customer_type,
// //           customer_name,
// //           date,
// //           delivery_type,
// //         } = ordersArr;

// //         setDetailsForReceiptPrint({
// //           cartItems: orders,
// //           deliveryType: delivery_type,
// //           customerType: customer_type,
// //           customer: { id: customer_id, name: customer_name },
// //           tableId: null,
// //           currency,
// //           storeSettings,
// //           printSettings,
// //           itemsTotal: subtotal,
// //           taxTotal: taxTotal,
// //           serviceChargeTotal:serviceChargeTotal,
// //           payableTotal: total,
// //           tokenNo: tokens,
// //           orderId: orderIds,
// //         });

// //         const receiptWindow = window.open(
// //           "/print-receipt",
// //           "_blank",
// //           "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
// //         );
// //         receiptWindow.onload = (e) => {
// //           setTimeout(() => {
// //             receiptWindow.print();
// //           }, 400);
// //         };
// //       }
// //     } catch (error) {
// //       const message =
// //         error?.response?.data?.message ||
// //         "Error processing your request, Please try later!";
// //       toast.dismiss();
// //       console.error(error);
// //       toast.error(message);
// //     }
// //   };

// //   const btnCollectFeedback = async (orderIdsArr) => {
// //     try {
// //       toast.loading(t('orders.loading_message'));
// //       const res = await getInvoiceIdFromOrderId(orderIdsArr);
// //       toast.dismiss();

// //       if (res.status == 200) {
// //         const { invoiceId, customerId } = res.data;

// //         if(!invoiceId) {
// //           toast.error("Please finish the order to collect feedback!");
// //           return;
// //         }

// //         const link = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${invoiceId}${customerId?`&_cref=${customerId}`:''}`

// //         const qrDataURL = await QRCode.toDataURL(link, {width: 1080});

// //         setState({
// //           ...state,
// //           feedbackInvoiceId: invoiceId,
// //           feedbackCustomerId: customerId,
// //           feedbackQRCode: qrDataURL
// //         })

// //         document.getElementById("modal-collect-feedback").showModal();
// //       }
// //     } catch (error) {
// //       const message =
// //         error?.response?.data?.message ||
// //         "Error processing your request, Please try later!";
// //       toast.dismiss();
// //       console.error(error);
// //       toast.error(message);
// //     }
// //   };

// //   const btnOpenFeedbackLink = () => {
// //     const a = document.createElement("a");
// //     a.href = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${state.feedbackInvoiceId}${state.feedbackCustomerId?`&_cref=${state.feedbackCustomerId}`:''}`;
// //     a.target = '_blank';
// //     a.click();
// //     a.remove();

// //     document.getElementById("modal-collect-feedback").close();
// //   };

// //   return (
// //     <Page>
// //       <div className="flex items-center gap-6">
// //         <h3 className="text-3xl font-light">{t('orders.title')}</h3>
// //         <button
// //           onClick={refreshOrders}
// //           className = "flex items-center gap-1 rounded-xl text-restro-text shadow-none transition active:scale-95 px-2 py-1 bg-restro-gray hover:bg-restro-button-hover border border-restro-border-green"
// //         >
// //           <IconRefresh size={22} stroke={iconStroke} /> {t('orders.refresh')}
// //         </button>
// //       </div>

// //       {kitchenOrders?.length == 0 && (
// //         <div className="w-full h-[calc(100vh-15vh)] flex gap-4 flex-col items-center justify-center">
// //           <img
// //             src="/assets/illustrations/orders-not-found.webp"
// //             alt={t('orders.no_orders_img_alt')}
// //             className="w-1/2 md:w-60"
// //           />
// //           <p className="text-gray-400">{t('orders.no_orders')}</p>
// //         </div>
// //       )}

// //       {kitchenOrders?.length > 0 && (
// //         <div className={`mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 `}>
// //           {kitchenOrders.map((order, index) => {
// //             const { table_id, table_title, floor, orders, order_ids } = order;

// //             const tokenNoArray = orders.map(o=>o.token_no);
// //             const tokens = tokenNoArray.join(",")

// //             const isPaid = orders.every((o)=>o.payment_status=='paid');

// //             return (
// //               <div
// //                 key={index}
// //                 className = "flex flex-col divide-y divide-dashed divide-gray-200 dark:divide-gray-700 px-4 py-5 border rounded-2xl border-restro-border-green"
// //               >
// //                 <div className="flex md:items-center flex-col md:flex-row md:justify-between md:text-center gap-2 pb-2">
// //                   <div className="flex items-center gap-2">
// //                     <div className = "flex w-12 h-12 rounded-full items-center justify-center bg-restro-gray">
// //                       {table_id ? (
// //                         <IconArmchair size={24} stroke={iconStroke} />
// //                       ) : (
// //                         <IconReceipt size={24} stroke={iconStroke} />
// //                       )}
// //                     </div>
// //                     <div>
// //                       <p className="font-bold">
// //                         {table_id ? `${table_title}` : "Dine Out / Delivery"}
// //                       </p>
// //                       {floor && <p className="text-sm">{floor}</p>}
// //                     </div>
// //                   </div>
// //                   <div className="dropdown dropdown-end">
// //                     <div
// //                       tabIndex={0}
// //                       role="button"
// //                       className="m-1 btn btn-sm btn-circle bg-transparent border-none shadow-none p-2 rounded-full hover:bg-restro-button-hover"
// //                     >
// //                       <IconDotsVertical size={18} stroke={iconStroke} />
// //                     </div>
// //                     <ul
// //                       tabIndex={0}
// //                       className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-lg w-52 border border-restro-border-green "
// //                     >
// //                       <li>
// //                         <button
// //                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
// //                           onClick={() => {
// //                             btnPrintReceipt(order_ids, tokens);
// //                           }}
// //                         >
// //                           <IconReceipt size={18} stroke={iconStroke} /> {t('orders.print_receipt')}
// //                         </button>
// //                       </li>
// //                       {storeSettings?.is_feedback_enabled ? <li>
// //                         <button
// //                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
// //                           onClick={() => {
// //                             btnCollectFeedback(order_ids);
// //                           }}
// //                         >
// //                           <IconStars size={18} stroke={iconStroke} /> {t('orders.collect_feedback')}
// //                         </button>
// //                       </li>:<></>}
// //                       <li>
// //                         <button
// //                           className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
// //                           onClick={() => {
// //                             btnShowCancelOrderModal(order_ids);
// //                           }}
// //                         >
// //                           <IconX size={18} stroke={iconStroke} /> {t('orders.cancel')}
// //                         </button>
// //                       </li>
// //                       <li>
// //                         <button
// //                           className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
// //                           onClick={() => {
// //                             if(isPaid == false) {
// //                               toast.error(t('orders.payment_not_collected_error'));
// //                               return;
// //                             }
// //                             btnShowCompleteOrderModal(order_ids);
// //                           }}
// //                         >
// //                           <IconCheck size={18} stroke={iconStroke} /> {t('orders.complete')}
// //                         </button>
// //                       </li>
// //                       <li>
// //                         <button
// //                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
// //                           onClick={() => {
// //                             if(isPaid == true) {
// //                               toast.error(t('orders.payment_already_collected_error'));
// //                               return;
// //                             }
// //                             btnShowPayAndComplete(order_ids, order);
// //                           }}
// //                         >
// //                           <IconCash size={18} stroke={iconStroke} /> {t('orders.pay_complete')}
// //                         </button>
// //                       </li>
// //                     </ul>
// //                   </div>
// //                 </div>

// //                 {orders.map((o, i) => {
// //                   const {
// //                     id,
// //                     date,
// //                     delivery_type,
// //                     customer_type,
// //                     customer_id,
// //                     customer_name,
// //                     status,
// //                     payment_status,
// //                     token_no,
// //                     items,
// //                   } = o;

// //                   return (
// //                     <div className = "py-2 px-2 mt-2 mb-2 rounded-xl bg-gray-50 dark:bg-restro-gray" key={i}>
// //                       <div className="flex items-center justify-between gap-2">
// //                         <div className="flex items-center justify-center flex-col text-center">
// //                           <p>{t('orders.token')}</p>
// //                           <div className = "w-12 h-12 flex items-center justify-center font-bold rounded-full bg-gray-700 dark:bg-[#0a0a0a] text-white" >
// //                             {token_no}
// //                           </div>
// //                         </div>
// //                         <div className="text-end">
// //                           <p>
// //                             {moment(date).format("hh:mm A")}
// //                           </p>
// //                           <p className={clsx("flex gap-2 items-center text-sm", {
// //                             "text-amber-500": payment_status == "pending",
// //                             "text-restro-green": payment_status == "paid",
// //                           })}>
// //                             {" "}
// //                             <IconCash stroke={iconStroke} size={18} />{" "}
// //                             {payment_status.toUpperCase()}
// //                           </p>
// //                         </div>
// //                       </div>

// //                       {/* order items */}
// //                       <div className="mt-4 flex flex-col divide-y divide-gray-200 dark:divide-gray-700">
// //                         {items.map((item, index) => {
// //                           const {
// //                             id: orderItemId,
// //                             order_id,
// //                             item_id,
// //                             item_title,
// //                             variant_id,
// //                             variant_title,
// //                             quantity,
// //                             status,
// //                             date,
// //                             addons,
// //                             notes,
// //                           } = item;

// //                           const addonsText =
// //                             addons?.length > 0
// //                               ? addons?.map((a) => a?.title)?.filter(Boolean)?.join(", ")
// //                               : null;

// //                           return (
// //                             <div
// //                               key={index}
// //                               className="flex items-center gap-2 py-2"
// //                             >
// //                               {/* status */}
// //                               {status == "preparing" && (
// //                                 <IconClock
// //                                   stroke={iconStroke}
// //                                   className="text-restro-yellow"
// //                                 />
// //                               )}
// //                               {status == "completed" && (
// //                                 <IconCheck
// //                                   stroke={iconStroke}
// //                                   className="text-restro-green"
// //                                 />
// //                               )}
// //                               {status == "cancelled" && (
// //                                 <IconX
// //                                   stroke={iconStroke}
// //                                   className="text-restro-red"
// //                                 />
// //                               )}
// //                               {status == "delivered" && (
// //                                 <IconChecks
// //                                   stroke={iconStroke}
// //                                   className="text-restro-green"
// //                                 />
// //                               )}
// //                               {/* status */}

// //                               {/* item title */}
// //                               <div className="flex-1">
// //                                 <p>
// //                                   {item_title} {variant_title} x {quantity}
// //                                 </p>
// //                                 {addonsText && (
// //                                   <p className="text-sm text-gray-700 dark:text-white">
// //                                     Addons: {addonsText}
// //                                   </p>
// //                                 )}
// //                                 {notes && (
// //                                   <p className="text-sm text-gray-700 dark:text-white">
// //                                     Notes: {notes}
// //                                   </p>
// //                                 )}
// //                               </div>
// //                               {/* item title */}

// //                               {/* action */}
// //                               <div className="dropdown dropdown-left">
// //                                 <div
// //                                   tabIndex={0}
// //                                   role="button"
// //                                   className="btn btn-sm btn-circle bg-transparent border-none shadow-none m-1"
// //                                 >
// //                                   <IconDotsVertical
// //                                     size={18}
// //                                     stroke={iconStroke}
// //                                   />
// //                                 </div>
// //                                 <ul
// //                                   tabIndex={0}
// //                                   className="dropdown-content z-[1] menu p-2 shadow bg-base-100 w-52 rounded-lg border border-restro-border-green"
// //                                 >
// //                                   <li>
// //                                     <button
// //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-yellow"
// //                                       onClick={() => {
// //                                         btnChangeOrderItemStatus(
// //                                           orderItemId,
// //                                           "preparing"
// //                                         );
// //                                       }}
// //                                     >
// //                                       <IconClock
// //                                         size={18}
// //                                         stroke={iconStroke}
// //                                       />{" "}
// //                                       {t('orders.preparing')}
// //                                     </button>
// //                                   </li>
// //                                   <li>
// //                                     <button
// //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
// //                                       onClick={() => {
// //                                         btnChangeOrderItemStatus(
// //                                           orderItemId,
// //                                           "completed"
// //                                         );
// //                                       }}
// //                                     >
// //                                       <IconCheck
// //                                         size={18}
// //                                         stroke={iconStroke}
// //                                       />{" "}
// //                                       {t('orders.completed')}
// //                                     </button>
// //                                   </li>
// //                                   <li>
// //                                     <button
// //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none "
// //                                       onClick={() => {
// //                                         btnChangeOrderItemStatus(
// //                                           orderItemId,
// //                                           "delivered"
// //                                         );
// //                                       }}
// //                                     >
// //                                       <IconChecks
// //                                         size={18}
// //                                         stroke={iconStroke}
// //                                       />{" "}
// //                                       {t('orders.delivered')}
// //                                     </button>
// //                                   </li>
// //                                   <li>
// //                                     <button
// //                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
// //                                       onClick={() => {
// //                                         btnChangeOrderItemStatus(
// //                                           orderItemId,
// //                                           "cancelled"
// //                                         );
// //                                       }}
// //                                     >
// //                                       <IconX size={18} stroke={iconStroke} />{" "}
// //                                       {t('orders.cancelled')}
// //                                     </button>
// //                                   </li>
// //                                 </ul>
// //                               </div>
// //                               {/* action */}
// //                             </div>
// //                           );
// //                         })}
// //                       </div>
// //                       {/* order items */}
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             );
// //           })}
// //         </div>
// //       )}

// //       {/* dialog: successful order item status update */}
// //       <dialog id="modal-order-item-status-update" className="modal">
// //         <div className = "modal-box border border-restro-border-green rounded-2xl">
// //           <h3 className="font-bold text-lg">{t('orders.success')}</h3>
// //           <p className="py-4">{t('orders.order_item_status_success')}</p>
// //           <div className="modal-action">
// //             <form method="dialog">
// //               {/* if there is a button in form, it will close the modal */}
// //               <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl dark:hover:border-restro-gray">{t('orders.close')}</button>
// //             </form>
// //           </div>
// //         </div>
// //       </dialog>
// //       {/* dialog: successful order item status update */}

// //       {/* dialog: cancel order */}
// //       <dialog id="modal-order-cancel" className="modal">
// //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// //           <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
// //           <p className="py-4">
// //             {t('orders.cancel_order_alert')}
// //           </p>
// //           <div className="modal-action">
// //             <form method="dialog">
// //               {/* if there is a button in form, it will close the modal */}
// //               <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl bg-restro-gray hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
// //               <button
// //                 onClick={() => {
// //                   btnCancelOrder();
// //                 }}
// //                 className={`ml-2 btn bg-restro-red text-white hover:bg-red-500 transition active:scale-95 px-4 py-3 rounded-xl border-restro-red hover:border-red-600`}
// //               >
// //                 {t('orders.confirm')}
// //               </button>
// //             </form>
// //           </div>
// //         </div>
// //       </dialog>
// //       {/* dialog: cancel order */}

// //       {/* dialog: complete order */}
// //       <dialog id="modal-order-complete" className="modal">
// //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// //           <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
// //           <p className="py-4">
// //             {t('orders.complete_order_alert')}
// //           </p>
// //           <div className="modal-action">
// //             <form method="dialog">
// //               {/* if there is a button in form, it will close the modal */}
// //               <button className="btn border-restro-gray bg-restro-gray rounded-xl hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
// //               <button
// //                 onClick={() => {
// //                   btnCompleteOrder();
// //                 }}
// //                 className="ml-2 btn bg-restro-green border-restro-green-light hover:bg-restro-green-button-hover rounded-xl"
// //               >
// //                 {t('orders.confirm')}
// //               </button>
// //             </form>
// //           </div>
// //         </div>
// //       </dialog>
// //       {/* dialog: complete order */}

// //       {/* dialog: complete order & payment summary */}
// //       <dialog id="modal-order-summary-complete" className="modal">
// //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// //           <div className="flex items-center justify-between">
// //             <h3 className="font-bold text-lg">{t('orders.pay_complete_order')}</h3>
// //             <form method='dialog'>
// //               <button className="btn btn-sm btn-circle text-restro-red border-none transition active:scale-95 hover:bg-restro-gray"><IconX size={18} stroke={iconStroke} /></button>
// //             </form>
// //           </div>

// //           <div className="my-6">
// //             <div className="my-8 space-y-4 px-1">
// //             {[
// //               { label: t('orders.items_net_total'), value: state.summaryNetTotal },
// //               { label: t('orders.tax_total'), value: state.summaryTaxTotal, prefix: "+" },
// //               { label: t('orders.service_charge_total'), value: state.summaryServiceChargeTotal, prefix: "+" },
// //             ].map(({ label, value, prefix = "" }, index) => (
// //               <div key={index} className="flex items-center justify-between text-restro-text">
// //                 <p>{label}</p>
// //                 <p className="text-lg">
// //                   {prefix}{currency}{value.toFixed(2)}
// //                 </p>
// //               </div>
// //             ))}

// //             <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
// //               <p className="text-xl font-medium">{t('orders.payable_total')}</p>
// //               <p className="text-xl font-bold text-restro-green">
// //                 {currency}{state.summaryTotal.toFixed(2)}
// //               </p>
// //             </div>
// //           </div>

// //             <label
// //               htmlFor="print_receipt"
// //               className="mt-4 w-full flex justify-end items-center gap-2 "
// //             >
// //               <input
// //                 type="checkbox"
// //                 className="checkbox rounded-lg"
// //                 id="print_receipt"
// //                 ref={printReceiptRef}
// //               />{" "}
// //               {t('orders.print_receipt_option')}
// //             </label>
// //           </div>

// //           <div className="grid grid-cols-3 gap-2">
// //             {(paymentTypes||[]).map((paymentType, i)=>{
// //               const uniqueId = `icon-${paymentType?.id}`;
// //               return <label key={i} className=''>
// //                 <input
// //                 checked={state?.selectedPaymentType == paymentType?.id}
// //                 onChange={e=>{
// //                   setState({
// //                     ...state,
// //                     selectedPaymentType: e.target.value,
// //                   });
// //                 }} type="radio" name="payment_type" id={uniqueId} value={paymentType?.id} className='peer hidden' />
// //                 <label htmlFor={uniqueId} className='border dark:border-restro-gray rounded-2xl flex items-center justify-center gap-1 flex-col px-4 py-3 peer-checked:border-restro-green peer-checked:text-restro-green peer-checked:font-bold cursor-pointer transition'>
// //                   {paymentType?.icon ? <div>{PAYMENT_ICONS[paymentType?.icon]}</div>:<></>}
// //                   <p className='text-xs'>{paymentType.title}</p>
// //                 </label>
// //               </label>
// //             })}
// //           </div>

// //           <div className="modal-action">
            
// //               {/* if there is a button in form, it will close the modal */}
// //               <button
// //                 onClick={() => {
// //                   btnPayAndComplete();
// //                 }}
// //                 className="w-full rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 bg-restro-green hover:bg-restro-green-button-hover"
// //               >
// //                 {t('orders.pay_complete_order')}
// //               </button>
           
// //           </div>
// //         </div>
// //       </dialog>
// //       {/* dialog: complete order & payment summary */}

// //       {/* dialog: complete order */}
// //       <dialog id="modal-collect-feedback" className="modal">
// //         <div className="modal-box border border-restro-border-green rounded-2xl ">
// //           <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-restro-gray">
// //             <IconStars stroke={iconStroke} />
// //           </div>
// //           <h3 className="mt-4 font-bold text-lg text-center">{t('orders.collect_feedback')}</h3>

// //           <div className="absolute top-6 right-6">
// //             <form method="dialog">
// //               <button className="btn btn-sm btn-circle border-none transition active:scale-95 text-restro-red hover:bg-restro-button-hover">
// //                 <IconX stroke={iconStroke} size={18} />
// //               </button>
// //             </form>
// //           </div>

// //           <div className="my-4">
// //             <img src={state.feedbackQRCode} alt={t('orders.feedback_qr_img_alt')} className="w-52 h-52 mx-auto border rounded-lg" />
// //           </div>

// //           <p className="text-center italic mb-10" dangerouslySetInnerHTML={{__html: t('orders.feedback_message')}}>

// //           </p>

// //           <div className="flex items-center gap-2 text-sm">
// //             <div className="flex-1 border-b border-restro-gray"></div>
// //             <div className="w-12 h-12 flex items-center justify-center rounded-full bg-restro-gray">
// //               OR
// //             </div>
// //             <div className="flex-1 border-b border-restro-gray"></div>
// //           </div>

// //           <div className="modal-action justify-center">
// //             <form method="dialog">
// //               <button
// //                 onClick={() => {
// //                   btnOpenFeedbackLink();
// //                 }}
// //                 className="btn ml-2 transition active:scale-95 hover:shadow-lg px-4 py-3 border bg-restro-green hover:bg-restro-green-button-hover text-white rounded-xl"
// //               >
// //                 {t('orders.open_in_new_tab')} <IconExternalLink stroke={iconStroke} />
// //               </button>
// //             </form>
// //           </div>
// //           </div>
// //       </dialog>
// //       {/* dialog: complete order */}

// //     </Page>
// //   );
// // }

// import PaymentQRDisplay from '../components/PaymentQRDisplay';
// import React, { useContext, useEffect, useRef, useState } from "react";
// import { useTranslation } from "react-i18next";
// import Page from "../components/Page";
// import {
//   cancelKitchenOrder,
//   completeKitchenOrder,
//   getCompleteOrderPaymentSummary,
//   getInvoiceIdFromOrderId,
//   getOrders,
//   getOrdersInit,
//   payAndCompleteKitchenOrder,
//   updateKitchenOrderItemStatus,
// } from "../controllers/orders.controller";
// import { toast } from "react-hot-toast";
// import {
//   IconArmchair,
//   IconBoxSeam,
//   IconCash,
//   IconCheck,
//   IconChecks,
//   IconClock,
//   IconDotsVertical,
//   IconExternalLink,
//   IconReceipt,
//   IconRefresh,
//   IconStars,
//   IconX,
// } from "@tabler/icons-react";
// import { FRONTEND_DOMAIN, VITE_BACKEND_SOCKET_IO, iconStroke } from "../config/config";
// import { CURRENCIES } from "../config/currencies.config";
// import { PAYMENT_ICONS } from "../config/payment_icons";
// import { setDetailsForReceiptPrint } from "../helpers/ReceiptHelper";

// import { SocketContext } from "../contexts/SocketContext";
// import { initSocket } from "../utils/socket";
// import { textToSpeech } from "../utils/textToSpeech";
// import { getUserDetailsInLocalStorage } from "../helpers/UserDetails";
// import QRCode from "qrcode"
// import { getQRMenuLink } from "../helpers/QRMenuHelper";
// import { useTheme } from "../contexts/ThemeContext";
// import clsx from "clsx";

// export default function OrdersPage() {
//   const { t } = useTranslation();
//   const { theme } = useTheme();
//   const printReceiptRef = useRef();
//   const user = getUserDetailsInLocalStorage();
//   const { socket, isSocketConnected } = useContext(SocketContext);

//   const [state, setState] = useState({
//     kitchenOrders: [],
//     printSettings: null,
//     storeSettings: null,
//     paymentTypes: [],
//     isLoading: true,

//     cancelOrderIds: [],
//     completeOrderIds: [],
//     completeTokenIds: "",

//     currency: null,

//     summaryNetTotal: 0,
//     summaryTaxTotal: 0,
//     summaryServiceChargeTotal:0,
//     summaryTotal: 0,
//     summaryOrders: [],
//     order: null,

//     selectedPaymentType: null,

//     feedbackInvoiceId: null,
//     feedbackCustomerId: null,
//     feedbackQRCode: null,
//   });

//   useEffect(() => {
//     _init();
//     _initSocket();

//     return () => {
//       // socket.disconnect()
//       socket.off('new_order')
//       socket.off('order_update')
//     }
//   }, []);

//   const {
//     kitchenOrders,
//     printSettings,
//     storeSettings,
//     paymentTypes,
//     isLoading,
//     currency,
//   } = state;

//   const _init = async () => {
//     try {
//       const [ordersResponse, ordersInitResponse] = await Promise.all([
//         getOrders(),
//         getOrdersInit(),
//       ]);

//       if (ordersResponse.status == 200 && ordersInitResponse.status == 200) {
//         const orders = ordersResponse?.data || [];
//         const ordersInit = ordersInitResponse.data;

//         const currency = CURRENCIES.find(
//           (c) => c.cc == ordersInit?.storeSettings?.currency
//         );

//         setState({
//           ...state,
//           kitchenOrders: orders,
//           printSettings: ordersInit.printSettings || {},
//           storeSettings: ordersInit.storeSettings || {},
//           paymentTypes: ordersInit.paymentTypes || [],
//           currency: currency?.symbol,
//           isLoading: false,
//         });
//       }
//     } catch (error) {
//       console.error(error);
//       toast.dismiss();
//       toast.error("Error loading orders! Please try later!");

//       setState({
//         ...state,
//         isLoading: false,
//       });
//     }
//   };

//   const refreshOrders = async () => {
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await getOrders();
//       toast.dismiss();
//       if (res.status == 200) {
//         toast.success(t('orders.orders_loaded'));
//         setState({
//           ...state,
//           kitchenOrders: res.data,
//           isLoading: false,
//         });
//       }
//     } catch (error) {
//       const message =
//         error.response.data.message ||
//         "Error loading orders! Please try later!";
//       console.error(error);
//       toast.dismiss();
//       toast.error(message);
//       setState({
//         ...state,
//         isLoading: false,
//       });
//     }
//   };

//   const _initSocket = () => {
//     const audio = new Audio("/new_order_sound.mp3");
//     if (isSocketConnected) {
//       socket.emit("authenticate", user.tenant_id);
//       socket.on("new_order", (payload) => {
//         console.log(payload);
//         // textToSpeech(`New order received, token number: ${payload}`)
//         audio.play();
//         refreshOrders();
//       });

//       socket.on("order_update", () => {
//         console.log("Order update");
//         refreshOrders();
//       });
//     } else {
//       initSocket();
//       socket.emit("authenticate", user.tenant_id);
//       socket.on("new_order", (payload) => {
//         console.log(payload);
//         // textToSpeech(`New order received, token number: ${payload}`);
//         audio.play();
//         refreshOrders();
//       });

//       socket.on("order_update", () => {
//         console.log("Order update");
//         refreshOrders();
//       });
//     }
//   };

//   const sendOrderUpdateEvent = () => {
//     const user = getUserDetailsInLocalStorage();

//     if (isSocketConnected) {
//       socket.emit("order_update_backend", {}, user.tenant_id);
//     } else {
//       // Handle disconnected state (optional)
//       initSocket();
//       socket.emit("order_update_backend", {}, user.tenant_id);
//     }
//   };

//   if (state.isLoading) {
//     return <Page>{t('orders.loading_message')}</Page>;
//   }

//   const btnChangeOrderItemStatus = async (orderItemId, status) => {
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await updateKitchenOrderItemStatus(orderItemId, status);
//       toast.dismiss();
//       if (res.status == 200) {
//         sendOrderUpdateEvent();
//         await refreshOrders();
//         toast.success(res.data.message);
//         document.getElementById("modal-order-item-status-update").showModal();
//       }
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Error processing your request, Please try later!";
//       toast.dismiss();
//       console.error(error);
//       toast.error(message);
//     }
//   };

//   const btnShowCancelOrderModal = (orderIds) => {
//     setState({
//       ...state,
//       cancelOrderIds: orderIds,
//     });
//     document.getElementById("modal-order-cancel").showModal();
//   };
//   const btnCancelOrder = async () => {
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await cancelKitchenOrder(state.cancelOrderIds);
//       toast.dismiss();
//       if (res.status == 200) {
//         sendOrderUpdateEvent();
//         await refreshOrders();
//         toast.success(res.data.message);
//         document.getElementById("modal-order-cancel").close();
//       }
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Error processing your request, Please try later!";
//       toast.dismiss();
//       console.error(error);
//       toast.error(message);
//     }
//   };

//   const btnShowCompleteOrderModal = (orderIds) => {
//     setState({
//       ...state,
//       completeOrderIds: orderIds,
//     });
//     document.getElementById("modal-order-complete").showModal();
//   };
//   const btnCompleteOrder = async () => {
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await completeKitchenOrder(state.completeOrderIds);
//       toast.dismiss();
//       if (res.status == 200) {
//         sendOrderUpdateEvent();
//         await refreshOrders();
//         toast.success(res.data.message);
//         document.getElementById("modal-order-complete").close();
//       }
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Error processing your request, Please try later!";
//       toast.dismiss();
//       console.error(error);
//       toast.error(message);
//     }
//   };

//   const btnShowPayAndComplete = async (orderIds, order) => {
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await getCompleteOrderPaymentSummary(orderIds);
//       toast.dismiss();

//       if (res.status == 200) {
//         const { subtotal, taxTotal, serviceChargeTotal, total, orders } = res.data;


//         const tokenNoArray = orders.map(o=>o.token_no);
//         const tokens = tokenNoArray.join(",");

//         setState({
//           ...state,
//           summaryNetTotal: subtotal,
//           summaryTaxTotal: taxTotal,
//           summaryServiceChargeTotal:serviceChargeTotal,
//           summaryTotal: total,
//           summaryOrders: orders,
//           completeOrderIds: orderIds,
//           completeTokenIds: tokens,
//           order: order,
//         });

//         document.getElementById("modal-order-summary-complete").showModal();
//       }
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Error processing your request, Please try later!";
//       toast.dismiss();
//       console.error(error);
//       toast.error(message);
//     }
//   };
//   const btnPayAndComplete = async () => {
//     const isPrintReceipt = printReceiptRef.current.checked || false;

//     if(!state.selectedPaymentType) {
//       return toast.error(t('orders.select_payment_method'));
//     }
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await payAndCompleteKitchenOrder(
//         state.completeOrderIds,
//         state.summaryNetTotal,
//         state.summaryTaxTotal,
//         state.summaryServiceChargeTotal,
//         state.summaryTotal,
//         state.selectedPaymentType,
//       );
//       toast.dismiss();
//       if (res.status == 200) {
//         const invoiceId = res.data?.invoiceId || null;
//         const customerId = res.data?.customerId || null;

//         sendOrderUpdateEvent();
//         await refreshOrders();
//         toast.success(res.data.message);
//         document.getElementById("modal-order-summary-complete").close();

//         if (isPrintReceipt) {
//           const { table_id, table_title, floor } = state.order;

//           const orders = [];
//           const orderIds = state.completeOrderIds.join(", ");

//           for (const o of state.summaryOrders) {
//             const items = o.items;
//             items.forEach((i) => {
//               const variant = i.variant_id
//                 ? {
//                     id: i.variant_id,
//                     title: i.variant_title,
//                     price: i.variant_price,
//                   }
//                 : null;
//               orders.push({
//                 ...i,
//                 title: i.item_title,
//                 addons_ids:
//                   i?.addons?.length > 0 ? i?.addons?.map((a) => a.id) : [],
//                 variant: variant,
//               });
//             });
//           }

//           const {
//             customer_id,
//             customer_type,
//             customer_name,
//             date,
//             delivery_type,
//           } = state.summaryOrders[0];

//           const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v)=>v.id == state.selectedPaymentType);
//           let paymentMethodText;
//           if(paymentType) {
//             paymentMethodText = paymentType.title;
//           }

//           setDetailsForReceiptPrint({
//             cartItems: orders,
//             deliveryType: delivery_type,
//             customerType: customer_type,
//             customer: { id: customer_id, name: customer_name },
//             tableId: table_id,
//             currency,
//             storeSettings,
//             printSettings,
//             itemsTotal: state.summaryNetTotal,
//             taxTotal: state.summaryTaxTotal,
//             serviceChargeTotal:state.summaryServiceChargeTotal,
//             payableTotal: state.summaryTotal,
//             tokenNo: state.completeTokenIds,
//             orderId: orderIds,
//             paymentMethod: paymentMethodText
//           });

//           const receiptWindow = window.open(
//             "/print-receipt",
//             "_blank",
//             "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
//           );
//           receiptWindow.onload = (e) => {
//             setTimeout(() => {
//               receiptWindow.print();
//             }, 400);
//           };
//         }



//         // Feedback
//         const link = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${invoiceId}${customerId?`&_cref=${customerId}`:''}`

//         const qrDataURL = await QRCode.toDataURL(link, {width: 1080});

//         if(storeSettings?.is_feedback_enabled) {
//           document.getElementById("modal-collect-feedback").showModal();
//         }

//         setState((prev)=>({...prev,
//           selectedPaymentType: null,
//           feedbackInvoiceId: invoiceId,
//           feedbackCustomerId: customerId,
//           feedbackQRCode: qrDataURL
//         }));
//         // Feedback
//       }
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Error processing your request, Please try later!";
//       toast.dismiss();
//       console.error(error);
//       toast.error(message);
//     }
//   };

//   const btnPrintReceipt = async (orderIdsArr, tokens) => {
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await getCompleteOrderPaymentSummary(orderIdsArr);
//       toast.dismiss();

//       if (res.status == 200) {
//         const { subtotal, taxTotal, serviceChargeTotal, total, orders: ordersArr } = res.data;

//         const orders = [];
//         const orderIds = orderIdsArr.join(", ");

//         for (const o of ordersArr) {
//           const items = o.items;
//           items.forEach((i) => {
//             const variant = i.variant_id
//               ? {
//                   id: i.variant_id,
//                   title: i.variant_title,
//                   price: i.variant_price,
//                 }
//               : null;
//             orders.push({
//               ...i,
//               title: i.item_title,
//               addons_ids:
//                 i?.addons?.length > 0 ? i?.addons?.map((a) => a.id) : [],
//               variant: variant,
//             });
//           });
//         }

//         const {
//           customer_id,
//           customer_type,
//           customer_name,
//           date,
//           delivery_type,
//         } = ordersArr;

//         setDetailsForReceiptPrint({
//           cartItems: orders,
//           deliveryType: delivery_type,
//           customerType: customer_type,
//           customer: { id: customer_id, name: customer_name },
//           tableId: null,
//           currency,
//           storeSettings,
//           printSettings,
//           itemsTotal: subtotal,
//           taxTotal: taxTotal,
//           serviceChargeTotal:serviceChargeTotal,
//           payableTotal: total,
//           tokenNo: tokens,
//           orderId: orderIds,
//         });

//         const receiptWindow = window.open(
//           "/print-receipt",
//           "_blank",
//           "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
//         );
//         receiptWindow.onload = (e) => {
//           setTimeout(() => {
//             receiptWindow.print();
//           }, 400);
//         };
//       }
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Error processing your request, Please try later!";
//       toast.dismiss();
//       console.error(error);
//       toast.error(message);
//     }
//   };

//   const btnCollectFeedback = async (orderIdsArr) => {
//     try {
//       toast.loading(t('orders.loading_message'));
//       const res = await getInvoiceIdFromOrderId(orderIdsArr);
//       toast.dismiss();

//       if (res.status == 200) {
//         const { invoiceId, customerId } = res.data;

//         if(!invoiceId) {
//           toast.error("Please finish the order to collect feedback!");
//           return;
//         }

//         const link = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${invoiceId}${customerId?`&_cref=${customerId}`:''}`

//         const qrDataURL = await QRCode.toDataURL(link, {width: 1080});

//         setState({
//           ...state,
//           feedbackInvoiceId: invoiceId,
//           feedbackCustomerId: customerId,
//           feedbackQRCode: qrDataURL
//         })

//         document.getElementById("modal-collect-feedback").showModal();
//       }
//     } catch (error) {
//       const message =
//         error?.response?.data?.message ||
//         "Error processing your request, Please try later!";
//       toast.dismiss();
//       console.error(error);
//       toast.error(message);
//     }
//   };

//   const btnOpenFeedbackLink = () => {
//     const a = document.createElement("a");
//     a.href = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${state.feedbackInvoiceId}${state.feedbackCustomerId?`&_cref=${state.feedbackCustomerId}`:''}`;
//     a.target = '_blank';
//     a.click();
//     a.remove();

//     document.getElementById("modal-collect-feedback").close();
//   };

//   return (
//     <Page>
//       <div className="flex items-center gap-6">
//         <h3 className="text-3xl font-light">{t('orders.title')}</h3>
//         <button
//           onClick={refreshOrders}
//           className = "flex items-center gap-1 rounded-xl text-restro-text shadow-none transition active:scale-95 px-2 py-1 bg-restro-gray hover:bg-restro-button-hover border border-restro-border-green"
//         >
//           <IconRefresh size={22} stroke={iconStroke} /> {t('orders.refresh')}
//         </button>
//       </div>

//       {kitchenOrders?.length == 0 && (
//         <div className="w-full h-[calc(100vh-15vh)] flex gap-4 flex-col items-center justify-center">
//           <img
//             src="/assets/illustrations/orders-not-found.webp"
//             alt={t('orders.no_orders_img_alt')}
//             className="w-1/2 md:w-60"
//           />
//           <p className="text-gray-400">{t('orders.no_orders')}</p>
//         </div>
//       )}

//       {kitchenOrders?.length > 0 && (
//         <div className={`mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 `}>
//           {kitchenOrders.map((order, index) => {
//             const { table_id, table_title, floor, orders, order_ids } = order;

//             const tokenNoArray = orders.map(o=>o.token_no);
//             const tokens = tokenNoArray.join(",")

//             const isPaid = orders.every((o)=>o.payment_status=='paid');

//             return (
//               <div
//                 key={index}
//                 className = "flex flex-col divide-y divide-dashed divide-gray-200 dark:divide-gray-700 px-4 py-5 border rounded-2xl border-restro-border-green"
//               >
//                 <div className="flex md:items-center flex-col md:flex-row md:justify-between md:text-center gap-2 pb-2">
//                   <div className="flex items-center gap-2">
//                     <div className = "flex w-12 h-12 rounded-full items-center justify-center bg-restro-gray">
//                       {table_id ? (
//                         <IconArmchair size={24} stroke={iconStroke} />
//                       ) : (
//                         <IconReceipt size={24} stroke={iconStroke} />
//                       )}
//                     </div>
//                     <div>
//                       <p className="font-bold">
//                         {table_id ? `${table_title}` : "Dine Out / Delivery"}
//                       </p>
//                       {floor && <p className="text-sm">{floor}</p>}
//                     </div>
//                   </div>
//                   <div className="dropdown dropdown-end">
//                     <div
//                       tabIndex={0}
//                       role="button"
//                       className="m-1 btn btn-sm btn-circle bg-transparent border-none shadow-none p-2 rounded-full hover:bg-restro-button-hover"
//                     >
//                       <IconDotsVertical size={18} stroke={iconStroke} />
//                     </div>
//                     <ul
//                       tabIndex={0}
//                       className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-lg w-52 border border-restro-border-green "
//                     >
//                       <li>
//                         <button
//                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
//                           onClick={() => {
//                             btnPrintReceipt(order_ids, tokens);
//                           }}
//                         >
//                           <IconReceipt size={18} stroke={iconStroke} /> {t('orders.print_receipt')}
//                         </button>
//                       </li>
//                       {storeSettings?.is_feedback_enabled ? <li>
//                         <button
//                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
//                           onClick={() => {
//                             btnCollectFeedback(order_ids);
//                           }}
//                         >
//                           <IconStars size={18} stroke={iconStroke} /> {t('orders.collect_feedback')}
//                         </button>
//                       </li>:<></>}
//                       <li>
//                         <button
//                           className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
//                           onClick={() => {
//                             btnShowCancelOrderModal(order_ids);
//                           }}
//                         >
//                           <IconX size={18} stroke={iconStroke} /> {t('orders.cancel')}
//                         </button>
//                       </li>
//                       <li>
//                         <button
//                           className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
//                           onClick={() => {
//                             if(isPaid == false) {
//                               toast.error(t('orders.payment_not_collected_error'));
//                               return;
//                             }
//                             btnShowCompleteOrderModal(order_ids);
//                           }}
//                         >
//                           <IconCheck size={18} stroke={iconStroke} /> {t('orders.complete')}
//                         </button>
//                       </li>
//                       <li>
//                         <button
//                           className="flex items-center gap-2 bg-transparent border-none shadow-none "
//                           onClick={() => {
//                             if(isPaid == true) {
//                               toast.error(t('orders.payment_already_collected_error'));
//                               return;
//                             }
//                             btnShowPayAndComplete(order_ids, order);
//                           }}
//                         >
//                           <IconCash size={18} stroke={iconStroke} /> {t('orders.pay_complete')}
//                         </button>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>

//                 {orders.map((o, i) => {
//                   const {
//                     id,
//                     date,
//                     delivery_type,
//                     customer_type,
//                     customer_id,
//                     customer_name,
//                     status,
//                     payment_status,
//                     token_no,
//                     items,
//                   } = o;

//                   return (
//                     <div className = "py-2 px-2 mt-2 mb-2 rounded-xl bg-gray-50 dark:bg-restro-gray" key={i}>
//                       <div className="flex items-center justify-between gap-2">
//                         <div className="flex items-center justify-center flex-col text-center">
//                           <p>{t('orders.token')}</p>
//                           <div className = "w-12 h-12 flex items-center justify-center font-bold rounded-full bg-gray-700 dark:bg-[#0a0a0a] text-white" >
//                             {token_no}
//                           </div>
//                         </div>
//                         <div className="text-end">
//                           <p>
//                             {moment(date).format("hh:mm A")}
//                           </p>
//                           <p className={clsx("flex gap-2 items-center text-sm", {
//                             "text-amber-500": payment_status == "pending",
//                             "text-restro-green": payment_status == "paid",
//                           })}>
//                             {" "}
//                             <IconCash stroke={iconStroke} size={18} />{" "}
//                             {payment_status.toUpperCase()}
//                           </p>
//                         </div>
//                       </div>

//                       {/* order items */}
//                       <div className="mt-4 flex flex-col divide-y divide-gray-200 dark:divide-gray-700">
//                         {items.map((item, index) => {
//                           const {
//                             id: orderItemId,
//                             order_id,
//                             item_id,
//                             item_title,
//                             variant_id,
//                             variant_title,
//                             quantity,
//                             status,
//                             date,
//                             addons,
//                             notes,
//                           } = item;

//                           const addonsText =
//                             addons?.length > 0
//                               ? addons?.map((a) => a?.title)?.filter(Boolean)?.join(", ")
//                               : null;

//                           return (
//                             <div
//                               key={index}
//                               className="flex items-center gap-2 py-2"
//                             >
//                               {/* status */}
//                               {status == "preparing" && (
//                                 <IconClock
//                                   stroke={iconStroke}
//                                   className="text-restro-yellow"
//                                 />
//                               )}
//                               {status == "completed" && (
//                                 <IconCheck
//                                   stroke={iconStroke}
//                                   className="text-restro-green"
//                                 />
//                               )}
//                               {status == "cancelled" && (
//                                 <IconX
//                                   stroke={iconStroke}
//                                   className="text-restro-red"
//                                 />
//                               )}
//                               {status == "delivered" && (
//                                 <IconChecks
//                                   stroke={iconStroke}
//                                   className="text-restro-green"
//                                 />
//                               )}
//                               {/* status */}

//                               {/* item title */}
//                               <div className="flex-1">
//                                 <p>
//                                   {item_title} {variant_title} x {quantity}
//                                 </p>
//                                 {addonsText && (
//                                   <p className="text-sm text-gray-700 dark:text-white">
//                                     Addons: {addonsText}
//                                   </p>
//                                 )}
//                                 {notes && (
//                                   <p className="text-sm text-gray-700 dark:text-white">
//                                     Notes: {notes}
//                                   </p>
//                                 )}
//                               </div>
//                               {/* item title */}

//                               {/* action */}
//                               <div className="dropdown dropdown-left">
//                                 <div
//                                   tabIndex={0}
//                                   role="button"
//                                   className="btn btn-sm btn-circle bg-transparent border-none shadow-none m-1"
//                                 >
//                                   <IconDotsVertical
//                                     size={18}
//                                     stroke={iconStroke}
//                                   />
//                                 </div>
//                                 <ul
//                                   tabIndex={0}
//                                   className="dropdown-content z-[1] menu p-2 shadow bg-base-100 w-52 rounded-lg border border-restro-border-green"
//                                 >
//                                   <li>
//                                     <button
//                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-yellow"
//                                       onClick={() => {
//                                         btnChangeOrderItemStatus(
//                                           orderItemId,
//                                           "preparing"
//                                         );
//                                       }}
//                                     >
//                                       <IconClock
//                                         size={18}
//                                         stroke={iconStroke}
//                                       />{" "}
//                                       {t('orders.preparing')}
//                                     </button>
//                                   </li>
//                                   <li>
//                                     <button
//                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
//                                       onClick={() => {
//                                         btnChangeOrderItemStatus(
//                                           orderItemId,
//                                           "completed"
//                                         );
//                                       }}
//                                     >
//                                       <IconCheck
//                                         size={18}
//                                         stroke={iconStroke}
//                                       />{" "}
//                                       {t('orders.completed')}
//                                     </button>
//                                   </li>
//                                   <li>
//                                     <button
//                                       className="flex items-center gap-2 bg-transparent border-none shadow-none "
//                                       onClick={() => {
//                                         btnChangeOrderItemStatus(
//                                           orderItemId,
//                                           "delivered"
//                                         );
//                                       }}
//                                     >
//                                       <IconChecks
//                                         size={18}
//                                         stroke={iconStroke}
//                                       />{" "}
//                                       {t('orders.delivered')}
//                                     </button>
//                                   </li>
//                                   <li>
//                                     <button
//                                       className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
//                                       onClick={() => {
//                                         btnChangeOrderItemStatus(
//                                           orderItemId,
//                                           "cancelled"
//                                         );
//                                       }}
//                                     >
//                                       <IconX size={18} stroke={iconStroke} />{" "}
//                                       {t('orders.cancelled')}
//                                     </button>
//                                   </li>
//                                 </ul>
//                               </div>
//                               {/* action */}
//                             </div>
//                           );
//                         })}
//                       </div>
//                       {/* order items */}
//                     </div>
//                   );
//                 })}
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* dialog: successful order item status update */}
//       <dialog id="modal-order-item-status-update" className="modal">
//         <div className = "modal-box border border-restro-border-green rounded-2xl">
//           <h3 className="font-bold text-lg">{t('orders.success')}</h3>
//           <p className="py-4">{t('orders.order_item_status_success')}</p>
//           <div className="modal-action">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl dark:hover:border-restro-gray">{t('orders.close')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: successful order item status update */}

//       {/* dialog: cancel order */}
//       <dialog id="modal-order-cancel" className="modal">
//         <div className="modal-box border border-restro-border-green rounded-2xl ">
//           <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
//           <p className="py-4">
//             {t('orders.cancel_order_alert')}
//           </p>
//           <div className="modal-action">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl bg-restro-gray hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
//               <button
//                 onClick={() => {
//                   btnCancelOrder();
//                 }}
//                 className={`ml-2 btn bg-restro-red text-white hover:bg-red-500 transition active:scale-95 px-4 py-3 rounded-xl border-restro-red hover:border-red-600`}
//               >
//                 {t('orders.confirm')}
//               </button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: cancel order */}

//       {/* dialog: complete order */}
//       <dialog id="modal-order-complete" className="modal">
//         <div className="modal-box border border-restro-border-green rounded-2xl ">
//           <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
//           <p className="py-4">
//             {t('orders.complete_order_alert')}
//           </p>
//           <div className="modal-action">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button className="btn border-restro-gray bg-restro-gray rounded-xl hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
//               <button
//                 onClick={() => {
//                   btnCompleteOrder();
//                 }}
//                 className="ml-2 btn bg-restro-green border-restro-green-light hover:bg-restro-green-button-hover rounded-xl"
//               >
//                 {t('orders.confirm')}
//               </button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: complete order */}

//       {/* dialog: complete order & payment summary */}
//       <dialog id="modal-order-summary-complete" className="modal">
//         <div className="modal-box border border-restro-border-green rounded-2xl ">
//           <div className="flex items-center justify-between">
//             <h3 className="font-bold text-lg">{t('orders.pay_complete_order')}</h3>
//             <form method='dialog'>
//               <button className="btn btn-sm btn-circle text-restro-red border-none transition active:scale-95 hover:bg-restro-gray"><IconX size={18} stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="my-6">
//             <div className="my-8 space-y-4 px-1">
//             {[
//               { label: t('orders.items_net_total'), value: state.summaryNetTotal },
//               { label: t('orders.tax_total'), value: state.summaryTaxTotal, prefix: "+" },
//               { label: t('orders.service_charge_total'), value: state.summaryServiceChargeTotal, prefix: "+" },
//             ].map(({ label, value, prefix = "" }, index) => (
//               <div key={index} className="flex items-center justify-between text-restro-text">
//                 <p>{label}</p>
//                 <p className="text-lg">
//                   {prefix}{currency}{value.toFixed(2)}
//                 </p>
//               </div>
//             ))}

//             <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
//               <p className="text-xl font-medium">{t('orders.payable_total')}</p>
//               <p className="text-xl font-bold text-restro-green">
//                 {currency}{state.summaryTotal.toFixed(2)}
//               </p>
//             </div>
//           </div>

//             <label
//               htmlFor="print_receipt"
//               className="mt-4 w-full flex justify-end items-center gap-2 "
//             >
//               <input
//                 type="checkbox"
//                 className="checkbox rounded-lg"
//                 id="print_receipt"
//                 ref={printReceiptRef}
//               />{" "}
//               {t('orders.print_receipt_option')}
//             </label>
//           </div>

//           <div className="grid grid-cols-3 gap-2">
//             {(paymentTypes||[]).map((paymentType, i)=>{
//               const uniqueId = `icon-${paymentType?.id}`;
//               return <label key={i} className=''>
//                 <input
//                 checked={state?.selectedPaymentType == paymentType?.id}
//                 onChange={e=>{
//                   setState({
//                     ...state,
//                     selectedPaymentType: e.target.value,
//                   });
//                 }} type="radio" name="payment_type" id={uniqueId} value={paymentType?.id} className='peer hidden' />
//                 <label htmlFor={uniqueId} className='border dark:border-restro-gray rounded-2xl flex items-center justify-center gap-1 flex-col px-4 py-3 peer-checked:border-restro-green peer-checked:text-restro-green peer-checked:font-bold cursor-pointer transition'>
//                   {paymentType?.icon ? <div>{PAYMENT_ICONS[paymentType?.icon]}</div>:<></>}
//                   <p className='text-xs'>{paymentType.title}</p>
//                 </label>
//               </label>
//             })}
//           </div>

//           <div className="modal-action">
            
//               {/* if there is a button in form, it will close the modal */}
//               <button
//                 onClick={() => {
//                   btnPayAndComplete();
//                 }}
//                 className="w-full rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 bg-restro-green hover:bg-restro-green-button-hover"
//               >
//                 {t('orders.pay_complete_order')}
//               </button>
           
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: complete order & payment summary */}

//       {/* dialog: complete order */}
//       <dialog id="modal-collect-feedback" className="modal">
//         <div className="modal-box border border-restro-border-green rounded-2xl ">
//           <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-restro-gray">
//             <IconStars stroke={iconStroke} />
//           </div>
//           <h3 className="mt-4 font-bold text-lg text-center">{t('orders.collect_feedback')}</h3>

//           <div className="absolute top-6 right-6">
//             <form method="dialog">
//               <button className="btn btn-sm btn-circle border-none transition active:scale-95 text-restro-red hover:bg-restro-button-hover">
//                 <IconX stroke={iconStroke} size={18} />
//               </button>
//             </form>
//           </div>

//           <div className="my-4">
//             <img src={state.feedbackQRCode} alt={t('orders.feedback_qr_img_alt')} className="w-52 h-52 mx-auto border rounded-lg" />
//           </div>

//           <p className="text-center italic mb-10" dangerouslySetInnerHTML={{__html: t('orders.feedback_message')}}>

//           </p>

//           <div className="flex items-center gap-2 text-sm">
//             <div className="flex-1 border-b border-restro-gray"></div>
//             <div className="w-12 h-12 flex items-center justify-center rounded-full bg-restro-gray">
//               OR
//             </div>
//             <div className="flex-1 border-b border-restro-gray"></div>
//           </div>

//           <div className="modal-action justify-center">
//             <form method="dialog">
//               <button
//                 onClick={() => {
//                   btnOpenFeedbackLink();
//                 }}
//                 className="btn ml-2 transition active:scale-95 hover:shadow-lg px-4 py-3 border bg-restro-green hover:bg-restro-green-button-hover text-white rounded-xl"
//               >
//                 {t('orders.open_in_new_tab')} <IconExternalLink stroke={iconStroke} />
//               </button>
//             </form>
//           </div>
//           </div>
//       </dialog>
//       {/* dialog: complete order */}

//     </Page>
//   );
// }


import PaymentQRDisplay from '../components/PaymentQRDisplay';
import DialogAddCustomer from '../components/DialogAddCustomer';
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { QRCodeSVG } from "qrcode.react";
import Page from "../components/Page";
import {
  getOrders,
  getOrdersInit,
  getCompleteOrderPaymentSummary,
  payAndCompleteKitchenOrder,
  cancelKitchenOrder,
  completeKitchenOrder,
  updateKitchenOrderItemStatus,
  updateKitchenOrderItemComplementaryStatus,
  getInvoiceIdFromOrderId,
  getOrderTables,
  changeOrderTable,
  mergeOrderTables,
  splitOrderBill,
  acceptDeliveryOrder,
  updateOrderItemPrices,
} from "../controllers/orders.controller";
import { toast } from "react-hot-toast";
import { IconArmchair, IconBed, IconBoxSeam, IconCash, IconCheck, IconChecks, IconClock, IconDotsVertical, IconExternalLink, IconPencil, IconReceipt, IconRefresh, IconStars, IconX, IconArrowsTransferUp, IconScissors, IconArrowRight, IconPlus, IconUser, IconDiscount, IconCalculator, IconCreditCard, IconTrash, IconScale, IconChevronDown, IconDeviceFloppy, IconRotateClockwise, IconBuildingSkyscraper } from "@tabler/icons-react";
import { FRONTEND_DOMAIN, VITE_BACKEND_SOCKET_IO, iconStroke } from "../config/config";
import { CURRENCIES } from "../config/currencies.config";
import { PAYMENT_ICONS } from "../config/payment_icons";
import { setDetailsForReceiptPrint } from "../helpers/ReceiptHelper";
import { useNavigate } from "react-router-dom";

import { SocketContext } from "../contexts/SocketContext";
import { initSocket } from "../utils/socket";
import { textToSpeech } from "../utils/textToSpeech";
import { getUserDetailsInLocalStorage } from "../helpers/UserDetails";
import QRCode from "qrcode"
import { getQRMenuLink } from "../helpers/QRMenuHelper";
import { useTheme } from "../contexts/ThemeContext";
import { getCustomerLoyalty } from "../controllers/loyalty.controller";
import { searchCustomer } from "../controllers/customers.controller";
import ApiClient from "../helpers/ApiClient";
import { IconGift } from "@tabler/icons-react";
import clsx from "clsx";
import { playNewOrderSound } from "../helpers/SoundHelper";

const SafeIconPrinter = ({ size = 24, stroke = 2, className = "", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
    <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
    <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
    <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" />
  </svg>
);


export default function OrdersPage() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const printReceiptRef = useRef();
  const searchCustomerRef = useRef();
  const user = getUserDetailsInLocalStorage();
  const { socket, isSocketConnected } = useContext(SocketContext);

  const btnSelectCustomerFromResult = async (customer) => {
    try {
      toast.loading(t('pos.please_wait'));
      const customerLoyalty = await getCustomerLoyalty(customer.phone);
      toast.dismiss();
      setState({
        ...state,
        customer: customer,
        customerLoyalty: customerLoyalty,
        customerSearchResults: [],
      })
      toast.success(`Customer Selected: ${customer.name}`);
    } catch (error) {
      toast.dismiss();
      setState({
        ...state,
        customer: customer,
        customerLoyalty: null,
        customerSearchResults: [],
      })
      toast.success(`Customer Selected: ${customer.name}`);
    }
  }

  const btnSearchCustomer = async () => {
    const query = searchCustomerRef.current.value;

    if(!query) {
      toast.error(t('pos.please_provide_phone'));
      return;
    }

    try {
      toast.loading(t('pos.please_wait'));
      const resp = await searchCustomer(query);
      toast.dismiss();
      if(resp.status == 200) {
        const results = resp.data;
        
        if (results.length === 0) {
          toast.error("No customer found!");
          return;
        }

        if (results.length === 1) {
          await btnSelectCustomerFromResult(results[0]);
          searchCustomerRef.current.value = "";
        } else {
          setState({
            ...state,
            customerSearchResults: results
          });
        }
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.getting_issues');
      console.log(error);
      toast.dismiss();
      toast.error(message);
    }
  };

  const [state, setState] = useState({
    kitchenOrders: [],
    categories: [],
    printSettings: null,
    storeSettings: null,
    paymentTypes: [],
    isLoading: true,

    cancelOrderIds: [],
    cancelReason: "",
    cancelOrderItemId: null,
    cancelOrderItemTitle: "",
    cancelOrderItemReason: "",
    completeOrderIds: [],
    completeTokenIds: "",

    currency: null,

    summaryNetTotal: 0,
    summaryTaxTotal: 0,
    summaryServiceChargeTotal:0,
    summaryTotal: 0,
    summaryOrders: [],
    summaryItems: [],
    serviceChargeRate: 0,
    pricesSaved: false,
    isSavingPrices: false,
    order: null,

    selectedPaymentType: null,

    feedbackInvoiceId: null,
    feedbackCustomerId: null,
    feedbackQRCode: null,

    discount: 0,
    paidAmount: undefined,
    cashTendered: 0,
    loyaltySettings: null,
    customerLoyalty: null,
    loyaltyRedemptionAmount: 0,
    loyaltyPointsRedeemed: 0,
    loyaltyItemsRedeemed: 0,
    multiPayments: [],
    discountType: "fixed",
    customer: null,
    customerSearchResults: [],
    addCustomerDefaultValue: null,
    // table operations
    storeTables: [],
    changeTableOrderIds: [],
    changeTableNewTableId: null,
    mergeSourceTableIds: [],
    mergeTargetTableId: null,
    // split bill
    splitBillOrderId: null,
    splitBillOriginalItems: [],
    splitBillGroups: [
      { label: 'Bill 1', items: [] },
      { label: 'Bill 2', items: [] },
    ],
    splitBillSuccessData: null,
    splitMoveItemState: null,
  });

  // Smart item-level auto-print tracking (mirrors Flutter KDS ehospitalitywindows)
  const knownItemIdsRef = useRef(new Set());
  const isFirstFetchRef = useRef(true);
  const categoriesRef = useRef([]);
  const printSettingsRef = useRef({});

  useEffect(() => {
    if (state.categories && state.categories.length > 0) {
      categoriesRef.current = state.categories;
    }
    if (state.printSettings) {
      printSettingsRef.current = state.printSettings;
    }
  }, [state.categories, state.printSettings]);

  const checkAndAutoPrintNewItems = async (ordersList) => {
    if (!Array.isArray(ordersList) || ordersList.length === 0) return;
    const shouldAutoPrint = localStorage.getItem('kdsAutoPrint') !== 'false';

    // On initial page load, record all existing item IDs so historical orders are not reprinted
    if (isFirstFetchRef.current) {
      ordersList.forEach(o => {
        (o.items || []).forEach(i => {
          if (i && i.id) knownItemIdsRef.current.add(String(i.id));
        });
      });
      isFirstFetchRef.current = false;
      return;
    }

    if (!shouldAutoPrint) {
      // Keep tracking items even if auto-print is off
      ordersList.forEach(o => {
        (o.items || []).forEach(i => {
          if (i && i.id) knownItemIdsRef.current.add(String(i.id));
        });
      });
      return;
    }

    // Subsequent loads (socket events, cloud sync, mobile orders, polling):
    // Identify items whose IDs haven't been seen yet
    for (const order of ordersList) {
      if (window.__lastLocalPlacedOrderId && String(window.__lastLocalPlacedOrderId) === String(order.id)) {
        continue;
      }
      const newItems = [];
      const globalSet = window.__printedItemFingerprints;
      (order.items || []).forEach(i => {
        if (!i || !i.id) return;
        const itemIdStr = String(i.id);
        const fp = `ord_${order.id}_it_${i.item_id || i.id}_v_${i.variant_id || 0}_q_${i.quantity ?? i.qty ?? 1}_n_${i.notes || ''}`;
        if (!knownItemIdsRef.current.has(itemIdStr) && (!globalSet || !globalSet.has(fp))) {
          if (globalSet) globalSet.add(fp);
          newItems.push({
            id: `${i.id}_${i.variant_id ?? 'nv'}`,
            item_id: i.item_id || i.id,
            category_id: i.category_id || i.category,
            title: i.item_title || i.title,
            quantity: i.quantity ?? i.qty ?? 1,
            variant: i.variant_title ? { title: i.variant_title } : (i.variant || null),
            variant_title: i.variant_title || i.variant?.title || (typeof i.variant === 'string' ? i.variant : ''),
            addons: i.addons || [],
            notes: i.notes || ''
          });
          knownItemIdsRef.current.add(itemIdStr);
        }
      });

      if (newItems.length > 0) {
        console.log(`[AutoPrint KOT] Found ${newItems.length} new item(s) in Order #${order.id}! Auto-printing to assigned category printers...`);
        try {
          const { groupItemsByPrinter, printKOT } = await import('../helpers/PrinterHelper');
          const currentCategories = (categoriesRef.current && categoriesRef.current.length > 0) 
            ? categoriesRef.current 
            : (state.categories || []);
          const currentPrintSettings = printSettingsRef.current || state.printSettings || {};
          const page_format = currentPrintSettings?.page_format || localStorage.getItem('page_format') || '58';
          const printerGroups = groupItemsByPrinter(newItems, currentCategories);

          const isRoom = order.delivery_type === 'room' || !!order.source || (order.table_title && order.table_title.toLowerCase().startsWith('room'));
          const roomNum = order.source || (order.table_title ? order.table_title.replace(/^room\s*/i, '') : '');
          const roomOrTable = isRoom
            ? (roomNum ? (roomNum.toLowerCase().startsWith('room') ? roomNum : `Room ${roomNum}`) : 'Room Order')
            : (order.table_title || '');

          await printKOT(printerGroups, {
            tableId: order.table_id || '',
            table_title: roomOrTable,
            deliveryType: order.delivery_type || (isRoom ? 'room' : ''),
            source: order.source || '',
            room_name: roomNum,
            tokenNo: order.token_no,
            orderId: order.id,
            customerName: order.customer_name || '',
            waiterName: order.waiter_name || order.created_by || '',
            page_format: page_format,
            pageFormat: page_format
          });
        } catch (printErr) {
          console.error('[OrdersPage] Auto KOT print error:', printErr);
        }
      }
    }
  };

  useEffect(() => {
    _init();

    const handleNewOrder = async (payload) => {
      console.log("[OrdersPage] received new_order:", payload);
      if (payload?.source === 'hydrate' || payload?.silent) {
        refreshOrders(true);
        return;
      }
      playNewOrderSound(payload);
      await refreshOrders(true);
    };
    
    const handleOrderUpdate = async (payload) => {
      console.log("[OrdersPage] received order_update:", payload);
      await refreshOrders(true);
    };

    const onConnect = () => {
      const u = getUserDetailsInLocalStorage();
      if (u?.tenant_id) {
        socket.emit("authenticate", u.tenant_id);
      }
      refreshOrders(true);
    };

    const u = getUserDetailsInLocalStorage();
    if (u?.tenant_id) {
      socket.emit("authenticate", u.tenant_id);
    }
    if (!socket.connected) {
      initSocket();
    }

    socket.on('connect', onConnect);
    socket.on('new_order', handleNewOrder);
    socket.on('new_qrorder', handleNewOrder);
    socket.on('new_order_notification', handleNewOrder);
    socket.on('order_update', handleOrderUpdate);

    // Electron IPC listener for cloud events (from mobile / cloud VPS sync)
    let removeIpcListener = null;
    if (typeof window !== 'undefined') {
      try {
        let ipc = null;
        if (window.electron && window.electron.ipcRenderer) {
          ipc = window.electron.ipcRenderer;
        } else if (window.require) {
          ipc = window.require('electron').ipcRenderer;
        }
        if (ipc) {
          const onCloudSocketEvent = (event, { eventName, payload }) => {
            console.log(`[OrdersPage] IPC Cloud Socket Event received: ${eventName}`, payload);
            if (['new_order', 'new_qrorder', 'new_order_notification', 'order_update'].includes(eventName)) {
              if (eventName !== 'order_update') {
                playNewOrderSound(payload);
              }
              // Step-refresh to guarantee orders display immediately as soon as sync writes to SQLite
              setTimeout(() => { refreshOrders(true); }, 300);
              setTimeout(() => { refreshOrders(true); }, 1000);
              setTimeout(() => { refreshOrders(true); }, 2500);
            }
          };
          ipc.on('cloud-socket-event', onCloudSocketEvent);
          removeIpcListener = () => {
            try { ipc.removeListener('cloud-socket-event', onCloudSocketEvent); } catch (e) {}
          };
        }
      } catch (e) {}
    }

    // Polling interval (every 4 seconds) to catch mobile orders synced in background
    const pollInterval = setInterval(() => {
      refreshOrders(true);
    }, 4000);

    return () => {
      socket.off('connect', onConnect);
      socket.off('new_order', handleNewOrder);
      socket.off('new_qrorder', handleNewOrder);
      socket.off('new_order_notification', handleNewOrder);
      socket.off('order_update', handleOrderUpdate);
      if (removeIpcListener) removeIpcListener();
      clearInterval(pollInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    kitchenOrders,
    categories,
    printSettings,
    storeSettings,
    paymentTypes,
    isLoading,
    currency,
  } = state;

  const _init = async () => {
    try {
      const [ordersResponse, ordersInitResponse, tablesResponse] = await Promise.all([
        getOrders(),
        getOrdersInit(),
        getOrderTables(),
      ]);

      if (ordersResponse.status == 200 && ordersInitResponse.status == 200) {
        const orders = ordersResponse?.data || [];
        const ordersInit = ordersInitResponse.data;

        // Seed initial items on first fetch
        if (isFirstFetchRef.current && Array.isArray(orders)) {
          orders.forEach(o => {
            (o.items || []).forEach(i => {
              if (i && i.id) knownItemIdsRef.current.add(String(i.id));
            });
          });
          isFirstFetchRef.current = false;
        }

        const currency = CURRENCIES.find(
          (c) => c.cc == ordersInit?.storeSettings?.currency
        );

        if (ordersInit?.categories) {
          categoriesRef.current = ordersInit.categories;
          try { localStorage.setItem('cached_categories', JSON.stringify(ordersInit.categories)); } catch(e) {}
        }
        if (ordersInit?.printSettings) {
          printSettingsRef.current = ordersInit.printSettings;
        }

        setState({
          ...state,
          kitchenOrders: orders,
          categories: ordersInit.categories || [],
          printSettings: ordersInit.printSettings || {},
          storeSettings: ordersInit.storeSettings || {},
          paymentTypes: ordersInit.paymentTypes || [],
          currency: currency?.symbol,
          isLoading: false,
          storeTables: tablesResponse?.data || [],
        });
      } else {
        setState({
          ...state,
          isLoading: false,
        });
      }
    } catch (error) {
      console.error(error);
      toast.dismiss();
      toast.error("Error loading orders! Please try later!");

      setState({
        ...state,
        isLoading: false,
      });
    }
  };

  const refreshOrders = async (silent = true) => {
    try {
      if (!silent) toast.loading(t('orders.loading_message'));
      const res = await getOrders();
      if (!silent) {
        toast.dismiss();
        if (res.status == 200) {
          toast.success(t('orders.orders_loaded'));
        }
      }
      if (res.status == 200) {
        setState(prevState => ({
          ...prevState,
          kitchenOrders: res.data,
          isLoading: false,
        }));
        // Auto-print any newly punched items from mobile, cloud sync, or web
        checkAndAutoPrintNewItems(res.data);
        return res.data;
      }
      return null;
    } catch (error) {
      if (!silent) {
        const message =
          error?.response?.data?.message ||
          "Error loading orders! Please try later!";
        console.error(error);
        toast.dismiss();
        toast.error(message);
      }
      setState(prevState => ({
        ...prevState,
        isLoading: false,
      }));
      return null;
    }
  };



  const sendOrderUpdateEvent = () => {
    const user = getUserDetailsInLocalStorage();

    if (isSocketConnected) {
      socket.emit("order_update_backend", {}, user.tenant_id);
    } else {
      // Handle disconnected state (optional)
      initSocket();
      socket.emit("order_update_backend", {}, user.tenant_id);
    }
  };

  if (state.isLoading) {
    return <Page>{t('orders.loading_message')}</Page>;
  }

  const btnChangeOrderItemStatus = async (orderItemId, status) => {
    try {
      toast.loading(t('orders.loading_message'));
      const res = await updateKitchenOrderItemStatus(orderItemId, status);
      toast.dismiss();
      if (res.status == 200) {
        sendOrderUpdateEvent();
        await refreshOrders();
        toast.success(res.data.message);
        document.getElementById("modal-order-item-status-update").showModal();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const btnChangeOrderItemComplementaryStatus = async (orderItemId, isComplementary) => {
    try {
      toast.loading(t('orders.loading_message'));
      const res = await updateKitchenOrderItemComplementaryStatus(orderItemId, isComplementary);
      toast.dismiss();
      if (res.status == 200) {
        sendOrderUpdateEvent();
        await refreshOrders();
        toast.success(res.data.message);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const btnShowCancelOrderModal = (orderIds) => {
    setState({
      ...state,
      cancelOrderIds: orderIds,
      cancelReason: "",
    });
    document.getElementById("modal-order-cancel").showModal();
  };
  const btnCancelOrder = async () => {
    if (!state.cancelReason) {
      toast.error("Please provide a reason for cancellation");
      return;
    }
    try {
      toast.loading(t('orders.loading_message'));
      const res = await cancelKitchenOrder(state.cancelOrderIds, state.cancelReason);
      toast.dismiss();
      if (res.status == 200) {
        sendOrderUpdateEvent();
        await refreshOrders();
        toast.success(res.data.message);
        document.getElementById("modal-order-cancel").close();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const btnShowCancelOrderItemModal = (orderItemId, itemTitle = "", totalQty = 1) => {
    const total = Number(totalQty) || 1;
    setState((prev) => ({
      ...prev,
      cancelOrderItemId: orderItemId,
      cancelOrderItemTitle: itemTitle,
      cancelItemTotalQty: total,
      cancelOrderItemQuantity: 1, // default cancel 1 item
      cancelOrderItemReason: "",
    }));
    document.getElementById("modal-order-item-cancel").showModal();
  };

  const btnConfirmCancelOrderItem = async () => {
    if (!state.cancelOrderItemReason || !state.cancelOrderItemReason.trim()) {
      toast.error("Please provide a reason for cancelling this item");
      return;
    }
    const maxQty = Number(state.cancelItemTotalQty) || 1;
    const cancelQty = Math.min(Math.max(1, Number(state.cancelOrderItemQuantity) || 1), maxQty);

    try {
      toast.loading(t('orders.loading_message'));
      const res = await updateKitchenOrderItemStatus(
        state.cancelOrderItemId,
        "cancelled",
        state.cancelOrderItemReason.trim(),
        cancelQty
      );
      toast.dismiss();
      if (res.status == 200) {
        sendOrderUpdateEvent();
        await refreshOrders();
        toast.success(res.data.message || `Successfully cancelled ${cancelQty} ${state.cancelOrderItemTitle || 'item'}`);
        document.getElementById("modal-order-item-cancel").close();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const btnShowCompleteOrderModal = (orderIds) => {
    setState({
      ...state,
      completeOrderIds: orderIds,
    });
    document.getElementById("modal-order-complete").showModal();
  };
  const btnCompleteOrder = async () => {
    try {
      toast.loading(t('orders.loading_message'));
      const res = await completeKitchenOrder(state.completeOrderIds);
      toast.dismiss();
      if (res.status == 200) {
        sendOrderUpdateEvent();
        await refreshOrders();
        toast.success(res.data.message);
        document.getElementById("modal-order-complete").close();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const btnAcceptDeliveryOrder = async (orderId) => {
    try {
      toast.loading("Accepting order and notifying delivery partners...");
      const res = await acceptDeliveryOrder(orderId);
      toast.dismiss();
      if (res.status == 200) {
        sendOrderUpdateEvent();
        await refreshOrders();
        toast.success(res.data.message);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const handleLoyaltyRedemption = (e) => {
    const value = parseFloat(String(e.target.value).replace(/,/g, "")) || 0;
    const settings = state.loyaltySettings;
    const loyalty = state.customerLoyalty;

    if (!settings || !loyalty) return;

    if (settings.type === 'points') {
      const maxRedeemablePoints = loyalty.points_balance;
      const pointsToRedeem = Math.min(value, maxRedeemablePoints);
      const amountToRedeem = (pointsToRedeem * settings.point_value) / 100;

      setState(prev => ({
        ...prev,
        loyaltyPointsRedeemed: pointsToRedeem,
        loyaltyRedemptionAmount: amountToRedeem
      }));
    } else if (settings.type === 'item') {
      const itemsToRedeem = Math.min(value, Math.floor(loyalty.items_count / settings.threshold_count));
      setState(prev => ({
        ...prev,
        loyaltyItemsRedeemed: itemsToRedeem * settings.threshold_count,
      }));
    }
  };

  const btnShowPayAndComplete = async (orderIds, order) => {
    try {
      toast.loading(t('orders.loading_message'));
      const res = await getCompleteOrderPaymentSummary(orderIds);
      toast.dismiss();

      if (res.status == 200) {
        const { subtotal, taxTotal, serviceChargeTotal, total, orders } = res.data;


        const tokenNoArray = orders.map(o=>o.token_no);
        const tokens = tokenNoArray.join(",");

        // Flatten active items for display & inline price editing
        const itemsList = [];
        for (const ord of (orders || [])) {
          for (const it of (ord.items || [])) {
            if (it.status === 'cancelled') continue;
            const unitPrice = Number(String(it.variant_price !== null && it.variant_price !== undefined ? it.variant_price : it.price).replace(/,/g, "")) || 0;
            const catalogPrice = Number(String(it.catalog_price || it.original_order_price || unitPrice).replace(/,/g, "")) || unitPrice;
            itemsList.push({
              ...it,
              order_id: ord.id,
              price: unitPrice,
              original_price: catalogPrice,
              quantity: Number(it.quantity) || 1,
              tax_rate: Number(String(it.tax_rate || 0).replace(/,/g, "")) || 0,
              tax_type: it.tax_type || "exclusive"
            });
          }
        }

        const calculatedRate = (subtotal > 0 && serviceChargeTotal > 0)
          ? ((serviceChargeTotal / subtotal) * 100)
          : (Number(state.storeSettings?.service_charge || 0));

        // Fetch loyalty settings
        let loyaltySettings = null;
        try {
          const loyaltySettingsRes = await ApiClient.get("/loyalty/settings");
          loyaltySettings = loyaltySettingsRes.data;
        } catch (error) {
          console.error("Failed to fetch loyalty settings", error);
        }

        // Fetch customer loyalty if available
        let customerLoyalty = null;
        const customerPhone = orders[0]?.customer_type === "CUSTOMER" ? orders[0].customer_id : null;
        if (customerPhone) {
          try {
            customerLoyalty = await getCustomerLoyalty(customerPhone);
          } catch (error) {
            console.error("Failed to fetch customer loyalty", error);
          }
        }

        setState({
          ...state,
          summaryNetTotal: subtotal,
          summaryTaxTotal: taxTotal,
          summaryServiceChargeTotal:serviceChargeTotal,
          summaryTotal: total,
          summaryOrders: orders,
          summaryItems: itemsList,
          serviceChargeRate: calculatedRate,
          pricesSaved: false,
          isSavingPrices: false,
          completeOrderIds: orderIds,
          completeTokenIds: tokens,
          order: order,
          activeOrderId: orders[0]?.id || order?.id || null,
          selectedPaymentType: null,
          loyaltySettings,
          customerLoyalty,
          discount: 0,
          roundOff: 0,
          targetTotal: undefined,
          paidAmount: undefined,
          loyaltyRedemptionAmount: 0,
          loyaltyPointsRedeemed: 0,
          loyaltyItemsRedeemed: 0,
          cashTendered: 0,
          multiPayments: [],
          customer: orders[0]?.customer_id ? { id: orders[0].customer_id, name: orders[0].customer_name } : { id: "WALKIN", name: "Walk-in Customer" },
        });

        document.getElementById("modal-order-summary-complete").showModal();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const handleItemPriceChange = (itemId, newPriceVal) => {
    const rawNum = parseFloat(String(newPriceVal).replace(/,/g, ""));
    const newPrice = isNaN(rawNum) ? 0 : Math.max(0, rawNum);

    setState(prev => {
      const updatedItems = (prev.summaryItems || []).map(item => {
        if (item.id === itemId) {
          return { ...item, price: newPrice };
        }
        return item;
      });

      // Recalculate subtotal, taxes, service charge, and total
      let newSubtotal = 0;
      let newTaxTotal = 0;
      let newTotal = 0;

      for (const item of updatedItems) {
        if (item.is_complementary) continue;

        let addonsTotal = 0;
        if (item.addons && Array.isArray(item.addons)) {
          for (const addon of item.addons) {
            addonsTotal += Number(String(addon.price || 0).replace(/,/g, ""));
          }
        }

        const itemUnitPrice = Number(item.price || 0);
        const itemQty = Number(item.quantity || 1);
        const lineTotal = (itemUnitPrice + addonsTotal) * itemQty;
        const taxRate = Number(item.tax_rate || 0);
        const taxType = item.tax_type || "exclusive";

        if (taxType === "exclusive") {
          const tax = (lineTotal * taxRate) / 100;
          newTaxTotal += tax;
          newSubtotal += lineTotal;
          newTotal += (lineTotal + tax);
        } else if (taxType === "inclusive") {
          const tax = lineTotal - (lineTotal * (100 / (100 + taxRate)));
          newTaxTotal += tax;
          newSubtotal += (lineTotal - tax);
          newTotal += lineTotal;
        } else {
          newSubtotal += lineTotal;
          newTotal += lineTotal;
        }
      }

      let newServiceChargeTotal = 0;
      if (prev.serviceChargeRate > 0) {
        newServiceChargeTotal = (newSubtotal * prev.serviceChargeRate) / 100;
        newTotal += newServiceChargeTotal;
      }

      return {
        ...prev,
        summaryItems: updatedItems,
        summaryNetTotal: newSubtotal,
        summaryTaxTotal: newTaxTotal,
        summaryServiceChargeTotal: newServiceChargeTotal,
        summaryTotal: newTotal,
        paidAmount: undefined,
        pricesSaved: false
      };
    });
  };

  const handleResetItemPrice = (itemId) => {
    const item = (state.summaryItems || []).find(i => i.id === itemId);
    if (!item) return;
    handleItemPriceChange(itemId, item.original_price ?? item.price);
  };

  const btnSaveOverriddenPrices = async () => {
    if (!state.summaryItems || state.summaryItems.length === 0) return;
    try {
      setState(prev => ({ ...prev, isSavingPrices: true }));
      toast.loading("Saving updated item prices...");
      const pricePayload = state.summaryItems.map(it => ({
        id: it.id,
        price: Number(it.price) || 0
      }));
      await updateOrderItemPrices(pricePayload);
      toast.dismiss();
      toast.success("Prices saved! Updated in Order and Room Folio.");
      setState(prev => ({ ...prev, pricesSaved: true, isSavingPrices: false }));
      sendOrderUpdateEvent();
      await refreshOrders(true);
    } catch (e) {
      toast.dismiss();
      console.error(e);
      toast.error(e?.response?.data?.message || "Failed to save overridden prices");
      setState(prev => ({ ...prev, isSavingPrices: false }));
    }
  };

  const addPaymentRow = () => {
    const totalToPay = state.paidAmount === undefined ? (state.summaryTotal - state.discount - state.loyaltyRedemptionAmount) : state.paidAmount;
    const currentPaid = state.multiPayments.reduce((acc, p) => acc + parseFloat(String(p.amount || 0).replace(/,/g, "")), 0);
    const remaining = totalToPay - currentPaid;

    const firstType = paymentTypes[0];
    setState({
      ...state,
      multiPayments: [
        ...state.multiPayments,
        { payment_type_id: firstType?.id, amount: Math.max(0, remaining), title: firstType?.title }
      ]
    });
  };

  const removePaymentRow = (index) => {
    const newPayments = [...state.multiPayments];
    newPayments.splice(index, 1);
    setState({ ...state, multiPayments: newPayments });
  };

  const handleMultiPaymentChange = (index, field, value) => {
    const newPayments = [...state.multiPayments];
    if (field === 'payment_type_id') {
      const type = (paymentTypes?.find ? paymentTypes : []).find(t => t.id == value);
      newPayments[index].payment_type_id = value;
      newPayments[index].title = type?.title;
    } else {
      newPayments[index][field] = value;
    }
    setState({ ...state, multiPayments: newPayments });
  };

  const btnPayAndComplete = async () => {
    const isPrintReceipt = printReceiptRef.current.checked || false;

    if (state.multiPayments.length === 0 && !state.selectedPaymentType) {
      return toast.error(t('orders.select_payment_method'));
    }

    const netTotal = state.summaryNetTotal;
    let discountAmount = 0;
    if (state.discountType === "percent") {
      discountAmount = (netTotal * state.discount) / 100;
    } else {
      discountAmount = state.discount;
    }

    const beforeRound = Math.max(0, state.summaryTotal - discountAmount - (state.loyaltyRedemptionAmount || 0));
    const roundOffAmount = Number(state.roundOff || 0);
    const total = Math.max(0, beforeRound + roundOffAmount);
    const paid = state.paidAmount === undefined ? total : state.paidAmount;
    const isDue = paid < total;

    if (isDue && (!state.customer || state.customer.id === "WALKIN")) {
      return toast.error("Customer selection is compulsory for Due payments. Walk-in customers cannot have due amounts.");
    }

    if (state.multiPayments.length > 0) {
      const sum = state.multiPayments.reduce((acc, p) => acc + parseFloat(String(p.amount || 0).replace(/,/g, "")), 0);
      if (Math.abs(sum - paid) > 0.01) {
        return toast.error(`Total of split payments (${sum.toFixed(2)}) must equal the paid amount (${paid.toFixed(2)})`);
      }
    }

    try {
      toast.loading(t('orders.loading_message'));
      const pricePayload = (state.summaryItems || []).map(it => ({
        id: it.id,
        price: Number(it.price) || 0
      }));

      const res = await payAndCompleteKitchenOrder(
        state.completeOrderIds,
        state.summaryNetTotal,
        state.summaryTaxTotal,
        state.summaryServiceChargeTotal,
        state.summaryTotal,
        state.selectedPaymentType,
        discountAmount,
        paid,
        state.loyaltyRedemptionAmount,
        state.loyaltyPointsRedeemed,
        state.loyaltyItemsRedeemed,
        state.multiPayments,
        state.customer?.id === "WALKIN" ? null : state.customer?.phone || state.customer?.id || null,
        roundOffAmount,
        pricePayload
      );
      toast.dismiss();
      if (res.status == 200) {
        const invoiceId = res.data?.invoiceId || null;
        const customerId = res.data?.customerId || null;

        sendOrderUpdateEvent();
        await refreshOrders();
        toast.success(res.data.message);
        document.getElementById("modal-order-summary-complete").close();

        if (isPrintReceipt) {
          const { table_id, table_title, floor } = state.order;

          const orders = [];
          const orderIds = state.completeOrderIds.join(", ");

          const itemsSource = (state.summaryItems && state.summaryItems.length > 0)
            ? state.summaryItems
            : state.summaryOrders.flatMap(o => o.items || []);

          itemsSource.forEach((i) => {
            const variant = i.variant_id
              ? {
                  id: i.variant_id,
                  title: i.variant_title,
                  price: i.price,
                }
              : null;
            orders.push({
              ...i,
              price: i.price,
              title: i.item_title,
              addons_ids:
                i?.addons?.length > 0 ? i?.addons?.map((a) => a.id) : [],
              variant: variant,
            });
          });

          const {
            customer_id,
            customer_type,
            customer_name,
            date,
            delivery_type,
          } = state.summaryOrders[0];

          const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v)=>v.id == state.selectedPaymentType);
          let paymentMethodText;
          if(paymentType) {
            paymentMethodText = paymentType.title;
          }

          const firstSummaryOrder = state.summaryOrders[0] || {};
          const isRoom = delivery_type === 'room' || !!firstSummaryOrder.source || !!state.order?.room_name || (table_title && table_title.toLowerCase().startsWith('room'));
          const roomNum = firstSummaryOrder.source || state.order?.room_name || (table_title ? table_title.replace(/^room\s*/i, '') : '');
          const roomOrTable = isRoom
            ? (roomNum ? (roomNum.toLowerCase().startsWith('room') ? roomNum : `Room ${roomNum}`) : 'Room Order')
            : (table_title || '');

          setDetailsForReceiptPrint({
            cartItems: orders,
            deliveryType: delivery_type,
            customerType: customer_type,
            customer: { id: customer_id, name: customer_name },
            tableId: table_id,
            table_title: roomOrTable,
            source: roomNum || null,
            room_name: roomNum || null,
            currency,
            storeSettings,
            printSettings,
            itemsTotal: state.summaryNetTotal,
            taxTotal: state.summaryTaxTotal,
            serviceChargeTotal:state.summaryServiceChargeTotal,
            storedDiscount: discountAmount,
            roundOff: roundOffAmount,
            payableTotal: total,
            paidAmount: paid,
            dueAmount: Math.max(0, total - paid),
            tokenNo: state.completeTokenIds,
            orderId: orderIds,
            paymentMethod: paymentMethodText
          });

          import('../helpers/PrinterHelper').then(({ printReceipt }) => {
            import('../helpers/ReceiptHelper').then(({ getDetailsForReceiptPrint }) => {
              const details = getDetailsForReceiptPrint();
              if (details) {
                printReceipt({
                  ...details,
                  printSettings,
                  pageFormat: printSettings?.page_format || localStorage.getItem('page_format') || '58'
                });
              }
            });
          });
        }



        // Feedback
        const link = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${invoiceId}${customerId?`&_cref=${customerId}`:''}`

        const qrDataURL = await QRCode.toDataURL(link, {width: 1080});

        if(storeSettings?.is_feedback_enabled) {
          document.getElementById("modal-collect-feedback").showModal();
        }

        setState((prev)=>({...prev,
          selectedPaymentType: null,
          feedbackInvoiceId: invoiceId,
          feedbackCustomerId: customerId,
          feedbackQRCode: qrDataURL
        }));
        // Feedback
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const triggerPrintReceiptIframe = () => {
    import('../helpers/PrinterHelper').then(({ printReceipt }) => {
      import('../helpers/ReceiptHelper').then(({ getDetailsForReceiptPrint }) => {
        const details = getDetailsForReceiptPrint();
        if (details) {
          printReceipt({
            ...details,
            printSettings,
            pageFormat: printSettings?.page_format || localStorage.getItem('page_format') || '58'
          });
        }
      });
    });
  };

  const btnPrintReceipt = async (orderIdsArr, tokens, isEstimate = false) => {
    try {
      toast.loading(t('orders.loading_message'));
      const res = await getCompleteOrderPaymentSummary(orderIdsArr);
      toast.dismiss();

      if (res.status == 200) {
        const { subtotal, taxTotal, serviceChargeTotal, total, orders: ordersArr } = res.data;

        const orders = [];
        const orderIds = orderIdsArr.join(", ");

        for (const o of ordersArr) {
          const items = o.items || [];
          items.forEach((i) => {
            const variant = i.variant_id
              ? {
                  id: i.variant_id,
                  title: i.variant_title,
                  price: i.variant_price,
                }
              : null;
            orders.push({
              ...i,
              title: i.item_title,
              addons_ids:
                i?.addons?.length > 0 ? i?.addons?.map((a) => a.id) : [],
              variant: variant,
            });
          });
        }

        const firstOrder = ordersArr[0] || {};
        const isRoom = firstOrder.delivery_type === 'room' || !!firstOrder.source || (firstOrder.table_title && firstOrder.table_title.toLowerCase().startsWith('room'));
        const roomNum = firstOrder.source || (firstOrder.table_title ? firstOrder.table_title.replace(/^room\s*/i, '') : '');
        const roomOrTable = isRoom
          ? (roomNum ? (roomNum.toLowerCase().startsWith('room') ? roomNum : `Room ${roomNum}`) : 'Room Order')
          : (firstOrder.table_title || '');

        setDetailsForReceiptPrint({
          cartItems: orders,
          deliveryType: firstOrder.delivery_type,
          customerType: firstOrder.customer_type,
          customer: { id: firstOrder.customer_id, name: firstOrder.customer_name },
          tableId: firstOrder.table_id || null,
          table_title: roomOrTable,
          source: roomNum || null,
          room_name: roomNum || null,
          currency,
          storeSettings,
          printSettings,
          itemsTotal: subtotal,
          taxTotal: taxTotal,
          serviceChargeTotal: serviceChargeTotal,
          payableTotal: total,
          tokenNo: tokens,
          orderId: orderIds,
          isEstimate: isEstimate,
          paymentMethod: isEstimate ? "ESTIMATE (UNSETTLED)" : ""
        });

        triggerPrintReceiptIframe();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error loading orders! Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const btnPrintEstimate = (orderIdsArr, tokens) => {
    btnPrintReceipt(orderIdsArr, tokens, true);
  };

  const btnPrintEstimateFromModal = () => {
    try {
      if (!state.summaryOrders || state.summaryOrders.length === 0) {
        toast.error("No active orders found to print estimate!");
        return;
      }

      const orders = [];
      const orderIds = state.completeOrderIds?.join ? state.completeOrderIds.join(", ") : String(state.completeOrderIds || '');

      const itemsSource = (state.summaryItems && state.summaryItems.length > 0)
        ? state.summaryItems
        : state.summaryOrders.flatMap(o => o.items || []);

      itemsSource.forEach((i) => {
        const variant = i.variant_id
          ? {
              id: i.variant_id,
              title: i.variant_title,
              price: i.price,
            }
          : null;
        orders.push({
          ...i,
          price: i.price,
          title: i.item_title,
          addons_ids:
            i?.addons?.length > 0 ? i?.addons?.map((a) => a.id) : [],
          variant: variant,
        });
      });

      const firstOrder = state.summaryOrders[0] || {};
      const isRoom = firstOrder.delivery_type === 'room' || !!firstOrder.source || (firstOrder.table_title && firstOrder.table_title.toLowerCase().startsWith('room'));
      const roomNum = firstOrder.source || (firstOrder.table_title ? firstOrder.table_title.replace(/^room\s*/i, '') : '');
      const roomOrTable = isRoom
        ? (roomNum ? (roomNum.toLowerCase().startsWith('room') ? roomNum : `Room ${roomNum}`) : 'Room Order')
        : (firstOrder.table_title || '');

      const discountVal = state.discountType === "percent"
        ? ((state.summaryNetTotal || 0) * (state.discount || 0) / 100)
        : Number(state.discount || 0);
      const beforeRoundEst = Math.max(0, (state.summaryTotal || 0) - discountVal - (state.loyaltyRedemptionAmount || 0));
      const roundOffVal = Number(state.roundOff || 0);
      const payableTotal = Math.max(0, beforeRoundEst + roundOffVal);

      setDetailsForReceiptPrint({
        cartItems: orders,
        deliveryType: firstOrder.delivery_type,
        customerType: firstOrder.customer_type,
        customer: state.customer || { id: firstOrder.customer_id, name: firstOrder.customer_name },
        tableId: firstOrder.table_id || null,
        table_title: roomOrTable,
        source: roomNum || null,
        room_name: roomNum || null,
        currency,
        storeSettings,
        printSettings,
        itemsTotal: state.summaryNetTotal,
        taxTotal: state.summaryTaxTotal,
        serviceChargeTotal: state.summaryServiceChargeTotal,
        storedDiscount: discountVal,
        roundOff: roundOffVal,
        payableTotal: payableTotal,
        tokenNo: state.completeTokenIds,
        orderId: orderIds,
        isEstimate: true,
        paymentMethod: "ESTIMATE (UNSETTLED)"
      });

      triggerPrintReceiptIframe();
      toast.success("Estimate bill sent to printer!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to print estimate bill");
    }
  };

  /**
   * Print KOT — builds a simple cartItems list (items only),
   * forces 2-inch page_format and opens the /print-kot route in a popup.
   *
   * orderIdsArr: array of order ids
   * tokens: string of token numbers (comma separated)
   */
  const btnPrintKOT = async (ordersArr, tokens) => {
    try {
      // Flatten items into cartItems that PrintKOT component expects
      const cartItems = [];
      const orderIds = [];
      for (const o of ordersArr) {
        orderIds.push(o.id ?? o.order_id);
        const items = o.items || [];
        items.forEach((i) => {
          cartItems.push({
            id: `${i.id}_${i.variant_id ?? 'nv'}`,
            item_id: i.item_id || i.id,
            category_id: i.category_id || i.category,
            title: i.item_title || i.title,
            quantity: i.quantity ?? i.qty ?? 0,
            variant: i.variant_title ? { title: i.variant_title } : (i.variant || null),
            variant_title: i.variant_title || i.variant?.title || (typeof i.variant === 'string' ? i.variant : ''),
            addons: i.addons || [],
            notes: i.notes || ''
          });
        });
      }

      const orderIdStr = orderIds.join(", ");
      const firstOrder = ordersArr[0] || {};
      const isRoom = firstOrder.delivery_type === 'room' || !!firstOrder.source || (firstOrder.table_title && firstOrder.table_title.toLowerCase().startsWith('room'));
      const roomNum = firstOrder.source || (firstOrder.table_title ? firstOrder.table_title.replace(/^room\s*/i, '') : '');
      const roomOrTable = isRoom
        ? (roomNum ? (roomNum.toLowerCase().startsWith('room') ? roomNum : `Room ${roomNum}`) : 'Room Order')
        : (firstOrder.table_title || '');

      import('../helpers/PrinterHelper').then(({ groupItemsByPrinter, printKOT }) => {
        const printerGroups = groupItemsByPrinter(cartItems, categories || []);
        const page_format = printSettings?.page_format || localStorage.getItem('page_format') || '58';
        printKOT(printerGroups, {
          tableId: firstOrder.table_id || '',
          table_title: roomOrTable,
          deliveryType: firstOrder.delivery_type || (isRoom ? 'room' : ''),
          source: firstOrder.source || '',
          room_name: roomNum,
          tokenNo: tokens,
          orderId: orderIdStr,
          customerName: '',
          waiterName: firstOrder.waiter_name || firstOrder.created_by || '',
          page_format: page_format,
          pageFormat: page_format
        }).catch(console.error);
      });
    } catch (error) {
      console.error(error);
      toast.error("Error preparing KOT print! Please try later!");
    }
  };

  /**
   * Print only a single item as KOT.
   * order: the order object (used for token_no, table id, etc)
   * item: the specific item object (must contain item_title, quantity, variant_title, addons, notes)
   */
  const btnPrintItemKOT = async (order, item) => {
    try {
      // Build cartItems payload expected by PrintKOTPage
      const cartItems = [{
        id: `${item.id ?? item.item_id}_${item.variant_id ?? 'nv'}`,
        item_id: item.id ?? item.item_id,
        category_id: item.category_id || item.category,
        title: item.item_title || item.title || item.productName || 'Item',
        quantity: item.quantity ?? item.qty ?? 0,
        variant: item.variant_id ? { title: item.variant_title } : (item.variant || null),
        variant_title: item.variant_title,
        addons: item.addons || [],
        addons_ids: item.addons ? item.addons.map(a => a.id) : (item.addons_ids || []),
        notes: item.notes || '',
      }];

      // Determine token to pass — use token_no on the order (if exists), else fallback to state/empty
      const token = order?.token_no || (Array.isArray(order?.orders) && order.orders[0]?.token_no) || state.completeTokenIds || '';
      const orderIdStr = order?.id ? String(order.id) : (order?.order_ids ? order.order_ids.join(',') : '');
      const firstOrder = (Array.isArray(order?.orders) && order.orders[0]) || order || {};
      const isRoom = firstOrder.delivery_type === 'room' || !!firstOrder.source || (firstOrder.table_title && firstOrder.table_title.toLowerCase().startsWith('room'));
      const roomNum = firstOrder.source || (firstOrder.table_title ? firstOrder.table_title.replace(/^room\s*/i, '') : '');
      const roomOrTable = isRoom
        ? (roomNum ? (roomNum.toLowerCase().startsWith('room') ? roomNum : `Room ${roomNum}`) : 'Room Order')
        : (firstOrder.table_title || '');

      import('../helpers/PrinterHelper').then(({ groupItemsByPrinter, printKOT }) => {
        const printerGroups = groupItemsByPrinter(cartItems, categories || []);
        const page_format = printSettings?.page_format || localStorage.getItem('page_format') || '58';
        printKOT(printerGroups, {
          tableId: firstOrder.table_id || '',
          table_title: roomOrTable,
          deliveryType: firstOrder.delivery_type || (isRoom ? 'room' : ''),
          source: firstOrder.source || '',
          room_name: roomNum,
          tokenNo: token,
          orderId: orderIdStr,
          customerName: '',
          waiterName: firstOrder.waiter_name || firstOrder.created_by || '',
          page_format: page_format,
          pageFormat: page_format
        }).catch(console.error);
      });
    } catch (e) {
      console.error("Error printing item KOT:", e);
      toast.error("Failed to print item KOT. Please try again.");
    }
  };

  const btnCollectFeedback = async (orderIdsArr) => {
    try {
      toast.loading(t('orders.loading_message'));
      const res = await getInvoiceIdFromOrderId(orderIdsArr);
      toast.dismiss();

      if (res.status == 200) {
        const { invoiceId, customerId } = res.data;

        if(!invoiceId) {
          toast.error("Please finish the order to collect feedback!");
          return;
        }

        const link = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${invoiceId}${customerId?`&_cref=${customerId}`:''}`

        const qrDataURL = await QRCode.toDataURL(link, {width: 1080});

        setState({
          ...state,
          feedbackInvoiceId: invoiceId,
          feedbackCustomerId: customerId,
          feedbackQRCode: qrDataURL
        })

        document.getElementById("modal-collect-feedback").showModal();
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Error processing your request, Please try later!";
      toast.dismiss();
      console.error(error);
      toast.error(message);
    }
  };

  const btnOpenFeedbackLink = () => {
    const a = document.createElement("a");
    a.href = getQRMenuLink(storeSettings?.unique_qr_code) + `/feedback?_ref=${state.feedbackInvoiceId}${state.feedbackCustomerId?`&_cref=${state.feedbackCustomerId}`:''}`;
    a.target = '_blank';
    a.click();
    a.remove();

    document.getElementById("modal-collect-feedback").close();
  };

  // ── Change Table ────────────────────────────────────────────────────────────
  const btnOpenChangeTableModal = (orderIds) => {
    setState({ ...state, changeTableOrderIds: orderIds, changeTableNewTableId: null });
    document.getElementById('modal-change-table').showModal();
  };

  const btnConfirmChangeTable = async () => {
    if (!state.changeTableNewTableId) { toast.error('Please select a table'); return; }
    try {
      toast.loading('Changing table...');
      await changeOrderTable(state.changeTableOrderIds, state.changeTableNewTableId);
      toast.dismiss();
      toast.success('Table changed!');
      document.getElementById('modal-change-table').close();
      refreshOrders();
    } catch (e) {
      toast.dismiss();
      toast.error(e?.response?.data?.message || 'Failed to change table');
    }
  };

  // ── Merge Tables ────────────────────────────────────────────────────────────
  const btnOpenMergeTablesModal = (currentTableId) => {
    setState({ ...state, mergeSourceTableIds: [currentTableId], mergeTargetTableId: null });
    document.getElementById('modal-merge-tables').showModal();
  };

  const btnConfirmMergeTables = async () => {
    if (!state.mergeTargetTableId) { toast.error('Please select target table'); return; }
    const sourceIds = state.mergeSourceTableIds.filter(id => id != state.mergeTargetTableId);
    if (sourceIds.length === 0) { toast.error('Source and target table cannot be the same'); return; }
    try {
      toast.loading('Merging tables...');
      await mergeOrderTables(sourceIds, state.mergeTargetTableId);
      toast.dismiss();
      toast.success('Tables merged!');
      document.getElementById('modal-merge-tables').close();
      refreshOrders();
    } catch (e) {
      toast.dismiss();
      toast.error(e?.response?.data?.message || 'Failed to merge tables');
    }
  };

  // ── Split Bill ──────────────────────────────────────────────────────────────
  const btnOpenSplitBillModal = (orderId, items) => {
    const activeItems = (items || []).filter(i => i.status !== 'cancelled');
    if (!activeItems || activeItems.length === 0) {
      toast.error('No active items to split in this order');
      return;
    }

    const bill1Items = activeItems.map(it => ({
      id: it.id,
      item_id: it.item_id,
      item_title: it.item_title,
      variant_title: it.variant_title,
      price: Number(it.price) || 0,
      original_quantity: Number(it.quantity) || 1,
      quantity: Number(it.quantity) || 1,
      addons: it.addons,
    }));

    const groups = [
      { label: 'Bill 1', items: bill1Items },
      { label: 'Bill 2', items: [] },
    ];

    setState(prev => ({
      ...prev,
      splitBillOrderId: orderId,
      splitBillOriginalItems: activeItems,
      splitBillGroups: groups,
      splitBillSuccessData: null,
    }));

    const dlg = document.getElementById('modal-split-bill');
    if (dlg) dlg.showModal();
  };

  const btnOpenMoveItemModal = (fromGroupIdx, item) => {
    const availableTargets = state.splitBillGroups
      .map((g, idx) => ({ ...g, idx }))
      .filter(g => g.idx !== fromGroupIdx);

    const defaultTargetIdx = availableTargets.length > 0 ? availableTargets[0].idx : (fromGroupIdx === 0 ? 1 : 0);

    setState(prev => ({
      ...prev,
      splitMoveItemState: {
        fromGroupIdx,
        toGroupIdx: defaultTargetIdx,
        itemId: item.id,
        itemTitle: item.item_title,
        variantTitle: item.variant_title || '',
        price: item.price,
        currentQty: item.quantity,
        moveQty: 1,
      },
    }));

    const dlg = document.getElementById('modal-split-move-item');
    if (dlg) dlg.showModal();
  };

  const btnMoveSplitItemQty = (fromGroupIdx, toGroupIdx, itemId, qtyToMove = 1) => {

    setState(prev => {
      const groups = prev.splitBillGroups.map(g => ({
        ...g,
        items: g.items.map(it => ({ ...it })),
      }));
      const fromGroup = groups[fromGroupIdx];
      const toGroup = groups[toGroupIdx];
      if (!fromGroup || !toGroup) return prev;

      const fromItemIdx = fromGroup.items.findIndex(it => it.id === itemId);
      if (fromItemIdx === -1) return prev;

      const fromItem = fromGroup.items[fromItemIdx];
      const actualMove = Math.min(qtyToMove, fromItem.quantity);
      if (actualMove <= 0) return prev;

      if (fromItem.quantity <= actualMove) {
        fromGroup.items.splice(fromItemIdx, 1);
      } else {
        fromItem.quantity -= actualMove;
      }

      const toItem = toGroup.items.find(it => it.id === itemId);
      if (toItem) {
        toItem.quantity += actualMove;
      } else {
        toGroup.items.push({
          ...fromItem,
          quantity: actualMove,
        });
      }

      return {
        ...prev,
        splitBillGroups: groups,
      };
    });
  };

  const btnAddSplitGroup = () => {
    setState(prev => {
      const n = prev.splitBillGroups.length + 1;
      return {
        ...prev,
        splitBillGroups: [...prev.splitBillGroups, { label: `Bill ${n}`, items: [] }],
      };
    });
  };

  const btnRemoveSplitGroup = (gIdx) => {
    if (state.splitBillGroups.length <= 2) {
      toast.error('At least 2 bills are required');
      return;
    }
    setState(prev => {
      const groups = prev.splitBillGroups.map(g => ({
        ...g,
        items: g.items.map(it => ({ ...it })),
      }));
      const removedGroup = groups[gIdx];
      // Return items to Bill 1
      for (const item of removedGroup.items) {
        const b1Item = groups[0].items.find(it => it.id === item.id);
        if (b1Item) {
          b1Item.quantity += item.quantity;
        } else {
          groups[0].items.push(item);
        }
      }
      groups.splice(gIdx, 1);
      const relabeled = groups.map((g, idx) => ({
        ...g,
        label: `Bill ${idx + 1}`,
      }));
      return {
        ...prev,
        splitBillGroups: relabeled,
      };
    });
  };

  const btnSplitEquallyAcrossBills = () => {
    setState(prev => {
      const numGroups = prev.splitBillGroups.length;
      if (numGroups < 2) return prev;

      const newGroups = prev.splitBillGroups.map((g, idx) => ({
        label: `Bill ${idx + 1}`,
        items: [],
      }));

      for (const orig of prev.splitBillOriginalItems) {
        const totalQty = Number(orig.quantity) || 1;
        const baseQty = Math.floor(totalQty / numGroups);
        let remainder = totalQty % numGroups;

        for (let gIdx = 0; gIdx < numGroups; gIdx++) {
          const qtyForThisBill = baseQty + (remainder > 0 ? 1 : 0);
          if (remainder > 0) remainder--;

          if (qtyForThisBill > 0) {
            newGroups[gIdx].items.push({
              id: orig.id,
              item_id: orig.item_id,
              item_title: orig.item_title,
              variant_title: orig.variant_title,
              price: Number(orig.price) || 0,
              original_quantity: totalQty,
              quantity: qtyForThisBill,
              addons: orig.addons,
            });
          }
        }
      }

      return {
        ...prev,
        splitBillGroups: newGroups,
      };
    });
    toast.success('Distributed quantities evenly across bills!');
  };

  const btnConfirmSplitBill = async () => {
    const filled = state.splitBillGroups.filter(g => g.items && g.items.some(i => i.quantity > 0));
    if (filled.length < 2) {
      toast.error('Assign items to at least 2 bills');
      return;
    }

    // Verify all original items are accounted for
    for (const orig of state.splitBillOriginalItems) {
      const allocatedQty = state.splitBillGroups.reduce((acc, g) => {
        const it = g.items.find(i => i.id === orig.id);
        return acc + (it ? it.quantity : 0);
      }, 0);
      const expectedQty = Number(orig.quantity) || 1;
      if (allocatedQty !== expectedQty) {
        toast.error(`Total allocated quantity for "${orig.item_title}" (${allocatedQty}) must equal order quantity (${expectedQty})`);
        return;
      }
    }

    const splitsPayload = filled.map(g => ({
      label: g.label,
      items: g.items.filter(i => i.quantity > 0).map(i => ({
        id: i.id,
        quantity: i.quantity,
      })),
    }));

    try {
      toast.loading('Splitting bill...');
      const res = await splitOrderBill(state.splitBillOrderId, splitsPayload);
      toast.dismiss();

      const splitResults = res.data?.splits || [];
      toast.success(`Bill split successfully into ${splitResults.length} bills!`);
      const modalSplit = document.getElementById('modal-split-bill');
      if (modalSplit) modalSplit.close();

      // Show split success & print options dialog
      setState(prev => ({
        ...prev,
        splitBillSuccessData: splitResults,
      }));
      const modalSuccess = document.getElementById('modal-split-bill-success');
      if (modalSuccess) modalSuccess.showModal();

      refreshOrders();
    } catch (e) {
      toast.dismiss();
      toast.error(e?.response?.data?.message || 'Failed to split bill');
    }
  };

  const btnPrintAllSplitEstimates = async (splits) => {
    if (!splits || splits.length === 0) return;
    toast.loading('Sending split bills to printer...');
    for (let i = 0; i < splits.length; i++) {
      const s = splits[i];
      await btnPrintEstimate([s.orderId], String(s.tokenNo));
      await new Promise(r => setTimeout(r, 600));
    }
    toast.dismiss();
    toast.success('All split estimate bills printed!');
  };


  return (
    <Page>
      <div className="flex items-center gap-6">
        <h3 className="text-3xl font-light">{t('orders.title')}</h3>
        <button
          onClick={refreshOrders}
          className = "flex items-center gap-1 rounded-xl text-restro-text shadow-none transition active:scale-95 px-2 py-1 bg-restro-gray hover:bg-restro-button-hover border border-restro-border-green"
        >
          <IconRefresh size={22} stroke={iconStroke} /> {t('orders.refresh')}
        </button>
      </div>

      {kitchenOrders?.length == 0 && (
        <div className="w-full h-[calc(100vh-15vh)] flex gap-4 flex-col items-center justify-center">
          <img
            src="/assets/illustrations/orders-not-found.webp"
            alt={t('orders.no_orders_img_alt')}
            className="w-1/2 md:w-60"
          />
          <p className="text-gray-400">{t('orders.no_orders')}</p>
        </div>
      )}

      {kitchenOrders?.length > 0 && (
        <div className={`mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 `}>
          {kitchenOrders.map((order, index) => {
            const { table_id, table_title, floor, orders, order_ids, delivery_type, room_name } = order;

            const isRoomOrder = delivery_type === 'room' || orders[0]?.delivery_type === 'room' || !!room_name || (table_title && table_title.toLowerCase().startsWith('room'));
            const roomDisplay = room_name || (table_title ? table_title.replace(/^room\s*/i, '') : '') || orders[0]?.source || '';
            const displayTitle = isRoomOrder 
              ? (roomDisplay ? (roomDisplay.toLowerCase().startsWith('room') ? roomDisplay : `Room ${roomDisplay}`) : 'Room Order')
              : (table_id ? `${table_title}` : (delivery_type ? delivery_type.toUpperCase() : "Dine Out / Delivery"));
            const displayFloor = isRoomOrder ? (floor || "Room Service") : floor;

            const tokenNoArray = orders.map(o=>o.token_no);
            const tokens = tokenNoArray.join(",")

            const isPaid = orders.every((o)=>o.payment_status=='paid');

            return (
              <div
                key={index}
                className = "flex flex-col divide-y divide-dashed divide-gray-200 dark:divide-gray-700 px-4 py-5 border rounded-2xl border-restro-border-green"
              >
                <div className="flex md:items-center flex-col md:flex-row md:justify-between md:text-center gap-2 pb-2">
                  <div className="flex items-center gap-2">
                    <div className = "flex w-12 h-12 rounded-full items-center justify-center bg-restro-gray">
                      {isRoomOrder ? (
                        <IconBed size={24} stroke={iconStroke} className="text-amber-500" />
                      ) : table_id ? (
                        <IconArmchair size={24} stroke={iconStroke} />
                      ) : (
                        <IconReceipt size={24} stroke={iconStroke} />
                      )}
                    </div>
                    <div>
                      <p className="font-bold">
                        {displayTitle}
                      </p>
                      {displayFloor && <p className="text-sm">{displayFloor}</p>}
                    </div>
                  </div>
                  <div className="dropdown dropdown-end">
                    <div
                      tabIndex={0}
                      role="button"
                      className="m-1 btn btn-sm btn-circle bg-transparent border-none shadow-none p-2 rounded-full hover:bg-restro-button-hover"
                    >
                      <IconDotsVertical size={18} stroke={iconStroke} />
                    </div>
                    <ul
                      tabIndex={0}
                      className="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-lg w-52 border border-restro-border-green "
                    >
                      <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none "
                          onClick={() => {
                            // Print KOT (kitchen order ticket) — items only, 2" format (full table)
                            btnPrintKOT(orders, tokens);
                          }}
                        >
                          <IconBoxSeam size={18} stroke={iconStroke} /> {t('orders.print_kot') || 'Print KOT (Table)'}
                        </button>
                      </li>

                      <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none text-amber-700 dark:text-amber-400 font-semibold"
                          onClick={() => {
                            btnPrintEstimate(order_ids, tokens);
                          }}
                        >
                          <SafeIconPrinter size={18} stroke={iconStroke} /> Print Estimate Bill (कच्चा बिल)
                        </button>
                      </li>

                      <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none "
                          onClick={() => {
                            btnPrintReceipt(order_ids, tokens);
                          }}
                        >
                          <IconReceipt size={18} stroke={iconStroke} /> {t('orders.print_receipt')}
                        </button>
                      </li>
                      {storeSettings?.is_feedback_enabled ? <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none "
                          onClick={() => {
                            btnCollectFeedback(order_ids);
                          }}
                        >
                          <IconStars size={18} stroke={iconStroke} /> {t('orders.collect_feedback')}
                        </button>
                      </li>:<></>}
                      <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
                          onClick={() => {
                            btnShowCancelOrderModal(order_ids);
                          }}
                        >
                          <IconX size={18} stroke={iconStroke} /> {t('orders.cancel')}
                        </button>
                      </li>
                      <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
                          onClick={() => {
                            if(isPaid == false) {
                              toast.error(t('orders.payment_not_collected_error'));
                              return;
                            }
                            btnShowCompleteOrderModal(order_ids);
                          }}
                        >
                          <IconCheck size={18} stroke={iconStroke} /> {t('orders.complete')}
                        </button>
                      </li>
                      <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none "
                          onClick={() => {
                            if(isPaid == true) {
                              toast.error(t('orders.payment_already_collected_error'));
                              return;
                            }
                            btnShowPayAndComplete(order_ids, order);
                          }}
                        >
                          <IconCash size={18} stroke={iconStroke} /> {t('orders.pay_complete')}
                        </button>
                      </li>
                      <li>
                        <button
                          className="flex items-center gap-2 bg-transparent border-none shadow-none text-blue-500"
                          onClick={() => {
                            if(isPaid == true) {
                              toast.error("Cannot edit a paid order!");
                              return;
                            }
                            // Pass all orders' items merged for editing
                            const allItems = orders.flatMap(o => o.items);
                            navigate("/dashboard/pos", {
                              state: {
                                editOrder: {
                                  orderId: orders[0].id,
                                  items: allItems,
                                  customer: { phone: orders[0].customer_id, name: orders[0].customer_name },
                                  customerType: orders[0].customer_type,
                                  deliveryType: orders[0].delivery_type,
                                  tableId: orders[0].table_id || null,
                                  source: orders[0].source || null,
                                }
                              }
                            });
                          }}
                        >
                          <IconPencil size={18} stroke={iconStroke} /> Edit Order
                        </button>
                      </li>
                      {table_id && (
                        <>
                          <div className="divider my-0.5"></div>
                          <li>
                            <button
                              className="flex items-center gap-2 bg-transparent border-none shadow-none text-violet-500"
                              onClick={() => btnOpenChangeTableModal(order_ids)}
                            >
                              <IconArrowRight size={18} stroke={iconStroke} /> Change Table
                            </button>
                          </li>
                          <li>
                            <button
                              className="flex items-center gap-2 bg-transparent border-none shadow-none text-indigo-500"
                              onClick={() => btnOpenMergeTablesModal(table_id)}
                            >
                              <IconArrowsTransferUp size={18} stroke={iconStroke} /> Merge Tables
                            </button>
                          </li>
                        </>
                      )}
                      {!isPaid && orders.length > 0 && (
                        <li>
                          <button
                            className="flex items-center gap-2 bg-transparent border-none shadow-none text-orange-500"
                            onClick={() => btnOpenSplitBillModal(orders[0].id, orders[0].items)}
                          >
                            <IconScissors size={18} stroke={iconStroke} /> Split Bill
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                {orders.map((o, i) => {
                  const {
                    id,
                    date,
                    delivery_type,
                    customer_type,
                    customer_id,
                    customer_name,
                    status,
                    payment_status,
                    token_no,
                    items,
                  } = o;

                  return (
                    <div className = "py-2 px-2 mt-2 mb-2 rounded-xl bg-gray-50 dark:bg-restro-gray" key={i}>
                      {orders.length > 1 && (
                        <div className="flex items-center justify-between pb-1.5 mb-2 border-b border-gray-200 dark:border-gray-700">
                          <span className="text-xs font-bold text-restro-green px-2 py-0.5 rounded bg-restro-green/10">
                            Bill {i + 1}
                          </span>
                          <div className="flex items-center gap-1">
                            {payment_status !== 'paid' && (
                              <button
                                type="button"
                                onClick={() => btnOpenSplitBillModal(id, items)}
                                className="btn btn-xs btn-ghost text-orange-500 gap-1 px-1.5"
                                title="Split this bill"
                              >
                                <IconScissors size={14} stroke={iconStroke} /> Split
                              </button>
                            )}
                            <button
                              type="button"
                              onClick={() => btnPrintEstimate([id], String(token_no ?? ''))}
                              className="btn btn-xs bg-amber-50 hover:bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300 border border-amber-300 px-1.5"
                              title="Print Estimate (कच्चा बिल)"
                            >
                              <SafeIconPrinter size={13} stroke={iconStroke} /> Est.
                            </button>
                            <button
                              type="button"
                              onClick={() => btnPrintReceipt([id], String(token_no ?? ''))}
                              className="btn btn-xs btn-ghost text-gray-600 dark:text-gray-300 px-1.5"
                              title="Print Receipt"
                            >
                              <IconReceipt size={13} stroke={iconStroke} />
                            </button>
                            {payment_status !== 'paid' && (
                              <button
                                type="button"
                                onClick={() => btnShowPayAndComplete([id], { ...order, orders: [o], order_ids: [id] })}
                                className="btn btn-xs bg-restro-green hover:bg-restro-green-button-hover text-white px-2 rounded-lg font-bold"
                                title="Pay this bill"
                              >
                                Pay
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="flex items-center justify-between gap-2">

                        {/* token + printer icon */}
                        <div className="flex items-center justify-center flex-col text-center">
                          <p>{t('orders.token')}</p>

                          <div className="flex items-center gap-2">
                            {/* token circle */}
                            <div className = "w-12 h-12 flex items-center justify-center font-bold rounded-full bg-gray-700 dark:bg-[#0a0a0a] text-white" >
                              {token_no}
                            </div>

                            {/* print KOT for this token (only this order) */}
                            <button
                              type="button"
                              onClick={() => {
                                // Pass single order id in array and token number string
                                btnPrintKOT([o], String(o.token_no ?? token_no ?? ''));
                              }}
                              title={t('orders.print_kot') || 'Print KOT'}
                              className="btn btn-xs btn-ghost p-1 rounded-md"
                              aria-label={t('orders.print_kot') || 'Print KOT'}
                              style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                              <SafeIconPrinter size={18} stroke={iconStroke} />
                            </button>
                          </div>
                        </div>

                        <div className="text-end">
                          <p>
                            {moment(date).format("hh:mm A")}
                          </p>
                          <p className={clsx("flex gap-2 items-center text-sm", {
                            "text-amber-500": payment_status == "pending",
                            "text-restro-green": payment_status == "paid",
                          })}>
                            {" "}
                            <IconCash stroke={iconStroke} size={18} />{" "}
                            {payment_status.toUpperCase()}
                          </p>
                        </div>
                      </div>

                      {/* order items */}
                      <div className="mt-4 flex flex-col divide-y divide-gray-200 dark:divide-gray-700">
                        {items.map((item, index) => {
                          const {
                            id: orderItemId,
                            order_id,
                            item_id,
                            item_title,
                            variant_id,
                            variant_title,
                            quantity,
                            status,
                            date,
                            addons,
                            notes,
                          } = item;

                          const addonsText =
                            addons?.length > 0
                              ? addons?.map((a) => a?.title)?.filter(Boolean)?.join(", ")
                              : null;

                          return (
                            <div
                              key={index}
                              className="flex items-center gap-2 py-2"
                            >
                              {/* status */}
                              {status == "preparing" && (
                                <IconClock
                                  stroke={iconStroke}
                                  className="text-restro-yellow"
                                />
                              )}
                              {status == "completed" && (
                                <IconCheck
                                  stroke={iconStroke}
                                  className="text-restro-green"
                                />
                              )}
                              {status == "cancelled" && (
                                <IconX
                                  stroke={iconStroke}
                                  className="text-restro-red"
                                />
                              )}
                              {status == "delivered" && (
                                <IconChecks
                                  stroke={iconStroke}
                                  className="text-restro-green"
                                />
                              )}
                              {/* status */}

                              {/* item title */}
                              <div className="flex-1">
                                <p className="flex items-center gap-2">
                                  {item_title} {variant_title} x {quantity}
                                  {item.is_complementary == 1 && (
                                    <span className="badge badge-sm bg-restro-green-light text-restro-green text-[10px] border-none font-bold">COMPLEMENTARY</span>
                                  )}
                                </p>
                                {addonsText && (
                                  <p className="text-sm text-gray-700 dark:text-white">
                                    Addons: {addonsText}
                                  </p>
                                )}
                                {notes && (
                                  <p className="text-sm text-gray-700 dark:text-white">
                                    Notes: {notes}
                                  </p>
                                )}
                              </div>
                              {/* item title */}

                              {/* action */}
                              <div className="dropdown dropdown-left">
                                <div
                                  tabIndex={0}
                                  role="button"
                                  className="btn btn-sm btn-circle bg-transparent border-none shadow-none m-1"
                                >
                                  <IconDotsVertical
                                    size={18}
                                    stroke={iconStroke}
                                  />
                                </div>
                                <ul
                                  tabIndex={0}
                                  className="dropdown-content z-[1] menu p-2 shadow bg-base-100 w-52 rounded-lg border border-restro-border-green"
                                >
                                  <li>
                                    <button
                                      className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-yellow"
                                      onClick={() => {
                                        btnChangeOrderItemStatus(
                                          orderItemId,
                                          "preparing"
                                        );
                                      }}
                                    >
                                      <IconClock
                                        size={18}
                                        stroke={iconStroke}
                                      />{" "}
                                      {t('orders.preparing')}
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
                                      onClick={() => {
                                        btnChangeOrderItemStatus(
                                          orderItemId,
                                          "completed"
                                        );
                                      }}
                                    >
                                      <IconCheck
                                        size={18}
                                        stroke={iconStroke}
                                      />{" "}
                                      {t('orders.completed')}
                                    </button>
                                  </li>

                                  {/* PRINT KOT for this item ONLY */}
                                  <li>
                                    <button
                                      className="flex items-center gap-2 bg-transparent border-none shadow-none"
                                      onClick={() => {
                                        // print only this item as KOT
                                        btnPrintItemKOT(o, item);
                                      }}
                                    >
                                      <SafeIconPrinter size={18} stroke={iconStroke} />{" "}
                                      {t('orders.print_kot_item') || 'Print KOT (Item)'}
                                    </button>
                                  </li>

                                  <li>
                                    <button
                                      className="flex items-center gap-2 bg-transparent border-none shadow-none "
                                      onClick={() => {
                                        btnChangeOrderItemStatus(
                                          orderItemId,
                                          "delivered"
                                        );
                                      }}
                                    >
                                      <IconChecks
                                        size={18}
                                        stroke={iconStroke}
                                      />{" "}
                                      {t('orders.delivered')}
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-green"
                                      onClick={() => {
                                        btnChangeOrderItemComplementaryStatus(
                                          orderItemId,
                                          !item.is_complementary
                                        );
                                      }}
                                    >
                                      <IconGift
                                        size={18}
                                        stroke={iconStroke}
                                      />{" "}
                                      {item.is_complementary ? "Remove Complementary" : "Mark Complementary"}
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="flex items-center gap-2 bg-transparent border-none shadow-none text-restro-red"
                                      onClick={() => {
                                        btnShowCancelOrderItemModal(
                                          orderItemId,
                                          item.item_title,
                                          item.quantity
                                        );
                                      }}
                                    >
                                      <IconX size={18} stroke={iconStroke} />{" "}
                                      {t('orders.cancelled')}
                                    </button>
                                  </li>
                                </ul>
                              </div>
                              {/* action */}
                            </div>
                          );
                        })}
                      </div>
                      {/* order items */}
                    </div>
                  );
                })}
                {!isPaid && (
                  <div className="pt-4 mt-auto flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() => btnPrintEstimate(order_ids, tokens)}
                      className="px-3 py-2 rounded-xl bg-amber-50 hover:bg-amber-100 dark:bg-amber-950/40 dark:hover:bg-amber-900/60 text-amber-800 dark:text-amber-200 border border-amber-300 dark:border-amber-700 text-xs font-bold flex items-center justify-center gap-1.5 transition active:scale-95 shadow-sm"
                      title="Print Estimate Bill (Not a Tax Invoice / कच्चा बिल)"
                    >
                      <SafeIconPrinter size={16} stroke={iconStroke} /> Estimate
                    </button>
                    <button
                      onClick={() => btnShowPayAndComplete(order_ids, order)}
                      className="flex-1 flex items-center justify-center gap-2 py-2 rounded-xl bg-restro-green text-white font-bold hover:bg-restro-green-button-hover transition active:scale-95 shadow-lg shadow-restro-green/20"
                    >
                      <IconCash size={18} stroke={iconStroke} /> {t('orders.pay_complete')}
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* dialog: successful order item status update */}
      <dialog id="modal-order-item-status-update" className="modal">
        <div className = "modal-box border border-restro-border-green rounded-2xl">
          <h3 className="font-bold text-lg">{t('orders.success')}</h3>
          <p className="py-4">{t('orders.order_item_status_success')}</p>
          <div className="modal-action">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl dark:hover:border-restro-gray">{t('orders.close')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: successful order item status update */}

      {/* dialog: cancel order */}
      <dialog id="modal-order-cancel" className="modal">
        <div className="modal-box border border-restro-border-green rounded-2xl ">
          <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
          <p className="py-4">
            {t('orders.cancel_order_alert')}
          </p>
          <div className="form-control w-full">
            <label className="label"><span className="label-text">Reason for cancellation *</span></label>
            <textarea 
              className="textarea textarea-bordered h-24" 
              placeholder="E.g., Customer changed mind, Out of stock..."
              value={state.cancelReason}
              onChange={(e) => setState({...state, cancelReason: e.target.value})}
              required
            ></textarea>
          </div>
          <div className="modal-action">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className="btn transition active:scale-95 hover:shadow-lg px-4 py-3 border border-restro-border-green rounded-xl bg-restro-gray hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
              <button
                onClick={() => {
                  btnCancelOrder();
                }}
                className={`ml-2 btn bg-restro-red text-white hover:bg-red-500 transition active:scale-95 px-4 py-3 rounded-xl border-restro-red hover:border-red-600`}
              >
                {t('orders.confirm')}
              </button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: cancel order */}

      {/* dialog: cancel order item */}
      <dialog id="modal-order-item-cancel" className="modal">
        <div className="modal-box border border-restro-border-green rounded-2xl max-w-md">
          <h3 className="font-bold text-lg text-restro-red flex items-center gap-2">
            <IconTrash size={20} /> Cancel Item / वस्तु रद्द गर्नुहोस्
          </h3>
          <p className="py-2 text-sm text-gray-600 dark:text-gray-300">
            Cancelling item: <span className="font-bold text-restro-text">{state.cancelOrderItemTitle || "Item"}</span>
          </p>

          {/* Quantity Selector if Total Quantity > 1 */}
          {(Number(state.cancelItemTotalQty) > 1) && (
            <div className="my-3 p-3 bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800/50 rounded-xl">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-semibold uppercase tracking-wider text-red-800 dark:text-red-300">
                  Quantity to Cancel (Total in Order: {state.cancelItemTotalQty})
                </span>
                <span className="text-xs text-gray-500">
                  Remaining: <strong className="text-emerald-600 dark:text-emerald-400 font-bold">{Math.max(0, (Number(state.cancelItemTotalQty) || 1) - (Number(state.cancelOrderItemQuantity) || 1))}</strong>
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden bg-white dark:bg-gray-800">
                  <button
                    type="button"
                    onClick={() => setState(prev => ({
                      ...prev,
                      cancelOrderItemQuantity: Math.max(1, (Number(prev.cancelOrderItemQuantity) || 1) - 1)
                    }))}
                    className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 font-bold text-base transition active:scale-95"
                  >
                    -
                  </button>
                  <input
                    type="number"
                    min="1"
                    max={state.cancelItemTotalQty || 1}
                    value={state.cancelOrderItemQuantity || 1}
                    onChange={(e) => {
                      const val = Math.min(Math.max(1, parseInt(e.target.value) || 1), Number(state.cancelItemTotalQty) || 1);
                      setState(prev => ({ ...prev, cancelOrderItemQuantity: val }));
                    }}
                    className="w-14 text-center font-bold text-sm bg-transparent outline-none py-1"
                  />
                  <button
                    type="button"
                    onClick={() => setState(prev => ({
                      ...prev,
                      cancelOrderItemQuantity: Math.min(Number(prev.cancelItemTotalQty) || 1, (Number(prev.cancelOrderItemQuantity) || 1) + 1)
                    }))}
                    className="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 font-bold text-base transition active:scale-95"
                  >
                    +
                  </button>
                </div>

                <div className="flex items-center gap-1.5 flex-wrap">
                  <button
                    type="button"
                    onClick={() => setState(prev => ({ ...prev, cancelOrderItemQuantity: 1 }))}
                    className={`px-2.5 py-1 text-xs font-semibold rounded-md border transition ${
                      Number(state.cancelOrderItemQuantity) === 1
                        ? "bg-red-600 text-white border-red-600"
                        : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    Cancel 1
                  </button>
                  <button
                    type="button"
                    onClick={() => setState(prev => ({ ...prev, cancelOrderItemQuantity: Number(prev.cancelItemTotalQty) || 1 }))}
                    className={`px-2.5 py-1 text-xs font-semibold rounded-md border transition ${
                      Number(state.cancelOrderItemQuantity) === Number(state.cancelItemTotalQty)
                        ? "bg-red-600 text-white border-red-600"
                        : "bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    Cancel All ({state.cancelItemTotalQty})
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="form-control w-full mt-2">
            <label className="label py-1"><span className="label-text font-semibold text-xs text-gray-600 dark:text-gray-300">Reason for Cancellation *</span></label>
            <textarea 
              className="textarea textarea-bordered h-20 text-sm focus:border-restro-green focus:ring-1 focus:ring-restro-green" 
              placeholder="Provide reason for cancelling..."
              value={state.cancelOrderItemReason || ""}
              onChange={(e) => setState({...state, cancelOrderItemReason: e.target.value})}
              required
            ></textarea>
            
            {/* Quick Reason Chips */}
            <div className="flex flex-wrap gap-1.5 mt-2">
              {[
                "Customer changed mind",
                "Wrong item entered",
                "Preparation delayed",
                "Item out of stock",
                "Guest left"
              ].map((reasonText) => (
                <button
                  key={reasonText}
                  type="button"
                  onClick={() => setState(prev => ({ ...prev, cancelOrderItemReason: reasonText }))}
                  className="px-2 py-0.5 text-[11px] rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-red-100 hover:text-red-700 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-gray-600 transition"
                >
                  {reasonText}
                </button>
              ))}
            </div>
          </div>

          <div className="modal-action mt-5">
            <form method="dialog" className="flex items-center gap-2">
              <button className="btn transition active:scale-95 px-4 py-2 text-sm border border-restro-border-green rounded-xl bg-restro-gray hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
              <button
                type="button"
                onClick={btnConfirmCancelOrderItem}
                className="btn bg-restro-red text-white hover:bg-red-500 transition active:scale-95 px-4 py-2 text-sm rounded-xl border-restro-red hover:border-red-600 flex items-center gap-1.5"
              >
                <IconTrash size={16} /> Confirm Cancellation
              </button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: cancel order item */}

      {/* dialog: complete order */}
      <dialog id="modal-order-complete" className="modal">
        <div className="modal-box border border-restro-border-green rounded-2xl ">
          <h3 className="font-bold text-lg">{t('orders.alert')}</h3>
          <p className="py-4">
            {t('orders.complete_order_alert')}
          </p>
          <div className="modal-action">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className="btn border-restro-gray bg-restro-gray rounded-xl hover:bg-restro-button-hover">{t('orders.dismiss')}</button>
              <button
                onClick={() => {
                  btnCompleteOrder();
                }}
                className="ml-2 btn bg-restro-green border-restro-green-light hover:bg-restro-green-button-hover rounded-xl"
              >
                {t('orders.confirm')}
              </button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: complete order */}

      {/* dialog: complete order & payment summary */}
      <dialog id="modal-order-summary-complete" className="modal">
        <div className="modal-box border border-gray-200 dark:border-zinc-800 rounded-2xl w-11/12 max-w-5xl bg-white dark:bg-zinc-950 p-0 overflow-hidden shadow-2xl">
          {/* Modal Header */}
          <div className="flex items-center justify-between px-6 py-4 bg-gray-50/80 dark:bg-zinc-900/90 border-b border-gray-200 dark:border-zinc-800">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-restro-green/10 dark:bg-restro-green/20 flex items-center justify-center text-restro-green shadow-sm">
                <IconReceipt size={22} />
              </div>
              <div>
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-extrabold text-lg text-gray-900 dark:text-white">
                    {t('orders.pay_complete_order')}
                  </h3>
                  {state.completeTokenIds && (
                    <span className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-gray-200/70 dark:bg-zinc-800 text-gray-700 dark:text-zinc-300">
                      Token #{state.completeTokenIds}
                    </span>
                  )}
                  {(() => {
                    const firstOrder = state.summaryOrders?.[0] || {};
                    const isRoom = firstOrder.delivery_type === 'room' || !!firstOrder.source || !!state.order?.room_name || (firstOrder.table_title && firstOrder.table_title.toLowerCase().startsWith('room'));
                    const roomNum = firstOrder.source || state.order?.room_name || (firstOrder.table_title ? firstOrder.table_title.replace(/^room\s*/i, '') : '');
                    if (isRoom && roomNum) {
                      return (
                        <span className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 flex items-center gap-1 border border-blue-200 dark:border-blue-800">
                          <IconBed size={13} /> Room {roomNum}
                        </span>
                      );
                    }
                    if (firstOrder.table_title) {
                      return (
                        <span className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                          Table: {firstOrder.table_title}
                        </span>
                      );
                    }
                    return null;
                  })()}
                </div>
                <p className="text-xs text-gray-400 dark:text-zinc-400">
                  Override item prices, apply discounts & round off, and complete bill settlement
                </p>
              </div>
            </div>
            <form method="dialog">
              <button className="btn btn-sm btn-circle text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-zinc-800 border-none transition">
                <IconX size={18} stroke={iconStroke} />
              </button>
            </form>
          </div>

          {/* Modal Body - 2 Columns */}
          <div className="p-6 max-h-[72vh] overflow-y-auto overscroll-contain bg-gray-50/50 dark:bg-zinc-950">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
              
              {/* LEFT COLUMN: Items list & Customer */}
              <div className="lg:col-span-7 space-y-5">
                
                {/* Section: Items & Price Overrides */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm overflow-hidden">
                  <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/60 dark:bg-zinc-950/60 flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-2">
                      <IconPencil size={18} className="text-amber-500" />
                      <div>
                        <h4 className="font-bold text-sm text-gray-900 dark:text-white">
                          Order Items & Price Overrides ({state.summaryItems?.length || 0})
                        </h4>
                        <p className="text-[11px] text-gray-400 dark:text-zinc-400">
                          Edit unit prices below. Changes dynamically recalculate bill & update Room Folio.
                        </p>
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={btnSaveOverriddenPrices}
                      disabled={state.isSavingPrices}
                      className={`px-3 py-1.5 text-xs font-bold rounded-xl flex items-center gap-1.5 transition shadow-sm active:scale-95 ${
                        state.pricesSaved
                          ? "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-700"
                          : "bg-blue-600 hover:bg-blue-700 text-white"
                      }`}
                      title="Save overridden prices to order and room folio immediately without completing payment"
                    >
                      {state.isSavingPrices ? (
                        <span>Saving...</span>
                      ) : state.pricesSaved ? (
                        <>
                          <IconChecks size={15} /> Prices Saved to Folio
                        </>
                      ) : (
                        <>
                          <IconDeviceFloppy size={15} /> Save Prices to Folio
                        </>
                      )}
                    </button>
                  </div>

                  {/* Room Folio Sync Notification Banner */}
                  {(() => {
                    const firstOrder = state.summaryOrders?.[0] || {};
                    const isRoom = firstOrder.delivery_type === 'room' || !!firstOrder.source || !!state.order?.room_name || (firstOrder.table_title && firstOrder.table_title.toLowerCase().startsWith('room'));
                    const roomNum = firstOrder.source || state.order?.room_name || (firstOrder.table_title ? firstOrder.table_title.replace(/^room\s*/i, '') : '');
                    if (isRoom && roomNum) {
                      return (
                        <div className="mx-4 mt-3 p-2.5 rounded-xl bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-900/50 flex items-center gap-2 text-xs text-blue-800 dark:text-blue-300">
                          <IconBuildingSkyscraper size={16} className="text-blue-600 shrink-0" />
                          <span>
                            <strong>Room {roomNum} Folio Linked:</strong> Overriding and saving prices here directly updates the room folio balance and room checkout bill.
                          </span>
                        </div>
                      );
                    }
                    return null;
                  })()}

                  {/* Items List */}
                  <div className="p-3 space-y-2 max-h-[380px] overflow-y-auto">
                    {state.summaryItems && state.summaryItems.length > 0 ? (
                      state.summaryItems.map((it) => {
                        const itAddonsTotal = it.addons
                          ? it.addons.reduce((sum, a) => sum + Number(String(a.price || 0).replace(/,/g, "")), 0)
                          : 0;
                        const itLineTotal = (Number(it.price || 0) + itAddonsTotal) * Number(it.quantity || 1);
                        const isModified = Number(it.price) !== Number(it.original_price);

                        return (
                          <div
                            key={it.id}
                            className={`flex items-center justify-between p-3 rounded-xl border transition ${
                              isModified
                                ? "bg-amber-50/40 dark:bg-amber-950/20 border-amber-300 dark:border-amber-800/60 shadow-sm"
                                : "bg-gray-50/60 dark:bg-zinc-950/60 border-gray-150 dark:border-zinc-800/80 hover:border-gray-300 dark:hover:border-zinc-700"
                            }`}
                          >
                            {/* Item Info */}
                            <div className="flex-1 min-w-0 pr-3">
                              <div className="flex items-center gap-1.5 flex-wrap">
                                <span className="font-bold text-sm text-gray-900 dark:text-zinc-100 truncate">
                                  {it.item_title}
                                </span>
                                {it.variant_title && (
                                  <span className="px-2 py-0.5 rounded text-[11px] font-semibold bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 border border-emerald-200/50 dark:border-emerald-800/50">
                                    {it.variant_title}
                                  </span>
                                )}
                                {it.is_complementary ? (
                                  <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">
                                    FREE
                                  </span>
                                ) : null}
                                {isModified && (
                                  <span className="px-1.5 py-0.2 text-[10px] font-extrabold uppercase rounded bg-amber-200 text-amber-900 dark:bg-amber-800/60 dark:text-amber-200">
                                    Edited
                                  </span>
                                )}
                              </div>
                              <div className="text-xs text-gray-500 dark:text-zinc-400 mt-1 flex items-center gap-2 flex-wrap">
                                <span className="font-bold text-gray-700 dark:text-zinc-300">
                                  Qty: {it.quantity}
                                </span>
                                {it.tax_rate > 0 && (
                                  <span className="text-[11px] text-gray-400">
                                    Tax: {it.tax_rate}% ({it.tax_type})
                                  </span>
                                )}
                                {it.addons && it.addons.length > 0 && (
                                  <span className="text-[11px] text-gray-400">
                                    + Addons: {it.addons.map(a => a.title).join(", ")} ({currency}{itAddonsTotal.toFixed(2)})
                                  </span>
                                )}
                                {isModified && (
                                  <span className="text-[11px] text-gray-400 line-through">
                                    Orig: {currency}{Number(it.original_price).toFixed(2)}
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* Price Override Input & Total */}
                            <div className="flex items-center gap-2 shrink-0">
                              <div className="flex flex-col items-end">
                                <label className="text-[10px] uppercase font-bold text-gray-400 dark:text-zinc-500 tracking-wider">
                                  Unit Price
                                </label>
                                <div className="relative flex items-center">
                                  <span className="absolute left-2.5 text-xs text-gray-400 font-semibold pointer-events-none">
                                    {currency}
                                  </span>
                                  <input
                                    type="number"
                                    step="any"
                                    min="0"
                                    value={it.price}
                                    onChange={(e) => handleItemPriceChange(it.id, e.target.value)}
                                    className="w-24 pl-7 pr-2 py-1.5 text-right font-extrabold text-sm bg-white dark:bg-zinc-900 border border-gray-300 dark:border-zinc-700 rounded-lg focus:ring-1 focus:ring-restro-green focus:border-restro-green outline-none shadow-sm transition"
                                    title="Click to edit unit price"
                                  />
                                </div>
                              </div>

                              {isModified && (
                                <button
                                  type="button"
                                  onClick={() => handleResetItemPrice(it.id)}
                                  className="p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-950/30 transition mt-3"
                                  title="Reset to original catalog price"
                                >
                                  <IconRotateClockwise size={15} />
                                </button>
                              )}

                              <div className="w-20 text-right mt-3">
                                <div className="text-[10px] uppercase font-bold text-gray-400 dark:text-zinc-500 tracking-wider">
                                  Line Total
                                </div>
                                <div className="text-sm font-black text-gray-900 dark:text-zinc-100">
                                  {currency}{itLineTotal.toFixed(2)}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-center py-6 text-sm text-gray-400">No items available</p>
                    )}
                  </div>
                </div>

                {/* Section: Customer & Loyalty */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm overflow-hidden">
                  <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/60 dark:bg-zinc-950/60 flex items-center gap-2">
                    <IconUser size={18} className="text-blue-500" />
                    <h4 className="font-semibold text-sm text-gray-900 dark:text-white">Customer & Loyalty</h4>
                  </div>
                  <div className="p-4 space-y-4">
                    <div className="flex flex-col gap-2">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-400">Select Customer</label>
                      {state.customer ? (
                        <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/20 p-3 rounded-xl border border-blue-100 dark:border-blue-900 animate-in zoom-in duration-200">
                          <div>
                            <p className="font-bold text-blue-700 dark:text-blue-300">{state.customer.name}</p>
                            <p className="text-xs text-blue-500 dark:text-blue-400">{state.customer.phone || state.customer.id}</p>
                          </div>
                          <button 
                            onClick={() => setState({ 
                              ...state, 
                              customer: null,
                              customerLoyalty: null,
                              loyaltyRedemptionAmount: 0,
                              loyaltyPointsRedeemed: 0,
                              loyaltyItemsRedeemed: 0
                            })}
                            className="btn btn-sm btn-circle btn-ghost text-red-500 hover:bg-red-100"
                          >
                            <IconX size={16} />
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2">
                          <input 
                            ref={searchCustomerRef}
                            type="text" 
                            placeholder="Search by phone or name..."
                            className="flex-1 p-2.5 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-sm focus:ring-1 focus:ring-restro-green focus:outline-none"
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                btnSearchCustomer();
                              }
                            }}
                          />
                          <button 
                            type="button"
                            onClick={btnSearchCustomer}
                            className="px-3.5 py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-zinc-700 text-restro-text dark:text-white rounded-xl font-medium text-xs transition"
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              const val = searchCustomerRef.current?.value || "";
                              setState(prev => ({ ...prev, addCustomerDefaultValue: val }));
                              document.getElementById("modal-add-customer").showModal();
                            }}
                            className="p-2.5 bg-restro-green hover:bg-restro-green-button-hover text-white rounded-xl font-medium transition flex items-center justify-center shadow-sm"
                            title="Add New Customer"
                          >
                            <IconPlus size={18} />
                          </button>
                        </div>
                      )}
                    </div>

                    {state.customerSearchResults.length > 0 && !state.customer && (
                      <div className="border border-gray-200 dark:border-zinc-800 rounded-xl overflow-hidden shadow-sm max-h-40 overflow-y-auto">
                        <div className="p-2 border-b border-gray-100 dark:border-zinc-800 flex justify-between items-center bg-gray-50 dark:bg-zinc-950">
                          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-tighter">Search Results ({state.customerSearchResults.length})</p>
                          <button onClick={() => setState({ ...state, customerSearchResults: [] })} className="text-gray-400 hover:text-red-500"><IconX size={12} /></button>
                        </div>
                        {state.customerSearchResults.map((res, i) => (
                          <button 
                            key={i}
                            type="button"
                            onClick={() => {
                              btnSelectCustomerFromResult(res);
                              searchCustomerRef.current.value = "";
                            }}
                            className="w-full text-left px-3 py-2 hover:bg-blue-50 dark:hover:bg-blue-900/20 flex flex-col transition group border-b border-gray-50 dark:border-zinc-800 last:border-none"
                          >
                            <p className="font-bold text-sm group-hover:text-blue-600 transition">{res.name}</p>
                            <p className="text-xs text-gray-400">{res.phone}</p>
                          </button>
                        ))}
                      </div>
                    )}

                    {state.loyaltySettings && state.loyaltySettings.is_enabled && state.customerLoyalty && (
                      <div className="bg-amber-50 dark:bg-amber-900/10 p-3.5 rounded-xl border border-amber-200 dark:border-amber-800 space-y-2">
                        <div className="flex items-center justify-between">
                          <p className="text-xs font-semibold text-amber-800 dark:text-amber-300 uppercase tracking-wider flex items-center gap-1">
                            <IconGift size={14} /> Loyalty Rewards
                          </p>
                          <span className="badge badge-outline border-amber-300 text-amber-800 bg-white dark:bg-amber-900/20 text-xs">
                            {state.loyaltySettings.type === 'points' 
                              ? `${state.customerLoyalty.points_balance.toFixed(2)} Points`
                              : `${state.customerLoyalty.items_count} Counted`
                            }
                          </span>
                        </div>

                        {state.loyaltySettings.type === 'points' ? (
                          <div className="flex items-center gap-2">
                            <input 
                              type="number" 
                              placeholder="Points to redeem"
                              value={state.loyaltyPointsRedeemed || ""}
                              onChange={handleLoyaltyRedemption}
                              max={state.customerLoyalty.points_balance}
                              className="w-32 p-2 rounded-lg border border-amber-200 dark:border-amber-700 bg-white dark:bg-amber-950 text-sm focus:outline-none focus:ring-1 ring-amber-400"
                            />
                            <button 
                              type="button"
                              onClick={() => {
                                handleLoyaltyRedemption({target: {value: state.customerLoyalty.points_balance}});
                              }}
                              className="px-3 py-1.5 text-xs font-medium text-amber-700 bg-amber-100 rounded-lg hover:bg-amber-200 transition"
                            >
                              Max
                            </button>
                            {state.loyaltyRedemptionAmount > 0 && (
                              <span className="text-xs font-bold text-amber-700 dark:text-amber-400">
                                -{currency}{state.loyaltyRedemptionAmount.toFixed(2)} off
                              </span>
                            )}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* RIGHT COLUMN: Live Calculation, Discount, Round Off, Payments */}
              <div className="lg:col-span-5 space-y-5">
                
                {/* Section: Live Bill Summary Card */}
                <div className="bg-gradient-to-br from-white to-gray-50 dark:from-zinc-900 dark:to-zinc-950 rounded-2xl border border-gray-200 dark:border-zinc-800 p-5 shadow-sm space-y-4">
                  <div className="grid grid-cols-2 gap-4 pb-4 border-b border-gray-150 dark:border-zinc-800">
                    <div className="space-y-0.5">
                      <div className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">Gross Total</div>
                      <div className="text-xl font-bold text-gray-900 dark:text-zinc-200">{currency}{state.summaryTotal?.toFixed(2)}</div>
                    </div>
                    <div className="space-y-0.5 text-right">
                      <div className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">Net Payable</div>
                      <div className="text-2xl font-black text-restro-green">
                        {currency}{(Math.max(0, (state.summaryTotal - (state.discountType === "percent" ? (state.summaryNetTotal * state.discount / 100) : state.discount) - state.loyaltyRedemptionAmount) + Number(state.roundOff || 0))).toFixed(2)}
                      </div>
                    </div>
                  </div>
                  
                  {/* Detailed Breakdown */}
                  <div className="space-y-2 text-xs">
                    <div className="flex justify-between text-gray-600 dark:text-zinc-400 font-medium">
                      <span>{t('orders.items_net_total')}</span>
                      <span className="font-semibold text-gray-900 dark:text-zinc-200">{currency}{state.summaryNetTotal?.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between text-gray-600 dark:text-zinc-400 font-medium">
                      <span>{t('orders.tax_total')}</span>
                      <span className="font-semibold text-gray-900 dark:text-zinc-200">+{currency}{state.summaryTaxTotal?.toFixed(2)}</span>
                    </div>
                    {state.summaryServiceChargeTotal > 0 && (
                      <div className="flex justify-between text-gray-600 dark:text-zinc-400 font-medium">
                        <span>{t('orders.service_charge_total')}</span>
                        <span className="font-semibold text-gray-900 dark:text-zinc-200">+{currency}{state.summaryServiceChargeTotal?.toFixed(2)}</span>
                      </div>
                    )}
                    
                    {/* Discounts and adjustments */}
                    {(state.discount > 0 || state.loyaltyRedemptionAmount > 0 || Number(state.roundOff || 0) !== 0) && (
                      <div className="pt-2 border-t border-gray-150 dark:border-zinc-800 space-y-1.5">
                        {(state.discountType === "percent" ? (state.summaryNetTotal * state.discount / 100) : state.discount) > 0 && (
                          <div className="flex justify-between items-center text-emerald-600 font-semibold">
                            <span>Direct Discount:</span>
                            <span>-{currency}{(state.discountType === "percent" ? (state.summaryNetTotal * state.discount / 100) : state.discount).toFixed(2)}</span>
                          </div>
                        )}
                        {state.loyaltyRedemptionAmount > 0 && (
                          <div className="flex justify-between items-center text-amber-600 font-semibold">
                            <span>Points Redemption:</span>
                            <span>-{currency}{state.loyaltyRedemptionAmount.toFixed(2)}</span>
                          </div>
                        )}
                        {Number(state.roundOff || 0) !== 0 && (
                          <div className="flex justify-between items-center text-blue-600 font-semibold">
                            <span>Round Off:</span>
                            <span>
                              {Number(state.roundOff) > 0 ? `+${currency}${Number(state.roundOff).toFixed(2)}` : `-${currency}${Math.abs(Number(state.roundOff)).toFixed(2)}`}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Section: Additional Discount & Round Off */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm p-4 space-y-4">
                  {/* Discount */}
                  <div>
                    <div className="flex justify-between items-center mb-1.5">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-zinc-400 flex items-center gap-1.5">
                        <IconDiscount size={15} className="text-emerald-500" /> Apply Discount
                      </label>
                      <select 
                        value={state.discountType}
                        onChange={(e) => setState({ ...state, discountType: e.target.value, targetTotal: undefined })}
                        className="text-xs font-bold bg-gray-100 dark:bg-zinc-800 rounded-lg px-2 py-1 outline-none text-gray-700 dark:text-zinc-200"
                      >
                        <option value="fixed">Fixed ({currency})</option>
                        <option value="percent">Percent (%)</option>
                      </select>
                    </div>
                    <input 
                      type="number" 
                      min="0"
                      value={state.discount || ""} 
                      onChange={(e) => {
                        const discount = parseFloat(String(e.target.value).replace(/,/g, "")) || 0;
                        setState({ ...state, discount, targetTotal: undefined });
                      }} 
                      placeholder="0.00"
                      className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-sm font-semibold focus:ring-1 focus:ring-restro-green focus:outline-none"
                    />
                  </div>

                  {/* Round Off */}
                  <div className="pt-2 border-t border-gray-100 dark:border-zinc-800">
                    <div className="flex justify-between items-center mb-1.5">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-zinc-400 flex items-center gap-1.5">
                        <IconScale size={15} className="text-blue-500" /> Round Off
                      </label>
                      {Number(state.roundOff || 0) !== 0 && (
                        <span className="text-[11px] font-bold text-blue-600">
                          {Number(state.roundOff) > 0 ? `+${Number(state.roundOff).toFixed(2)}` : Number(state.roundOff).toFixed(2)}
                        </span>
                      )}
                    </div>
                    <div className="flex flex-wrap gap-1.5 mb-2">
                      {[
                        { label: "Floor 10", fn: (before) => Math.floor(before / 10) * 10 },
                        { label: "Nearest 10", fn: (before) => Math.round(before / 10) * 10 },
                        { label: "Floor 5", fn: (before) => Math.floor(before / 5) * 5 },
                        { label: "Nearest 1", fn: (before) => Math.round(before) },
                      ].map(preset => (
                        <button
                          key={preset.label}
                          type="button"
                          onClick={() => {
                            const before = Math.max(0, (state.summaryTotal || 0) - (state.discountType === "percent" ? ((state.summaryNetTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                            const target = preset.fn(before);
                            const diff = parseFloat((target - before).toFixed(2));
                            setState(prev => ({ ...prev, roundOff: diff, targetTotal: undefined, paidAmount: undefined }));
                          }}
                          className="px-2.5 py-1 bg-gray-100 hover:bg-blue-50 hover:text-blue-600 dark:bg-zinc-800 dark:hover:bg-zinc-700 rounded-lg text-[11px] font-bold transition text-gray-600 dark:text-zinc-300"
                        >
                          {preset.label}
                        </button>
                      ))}
                      <button
                        type="button"
                        onClick={() => setState(prev => ({ ...prev, roundOff: 0, targetTotal: undefined, paidAmount: undefined }))}
                        className="px-2.5 py-1 bg-gray-100 hover:bg-red-50 hover:text-red-600 dark:bg-zinc-800 rounded-lg text-[11px] font-bold transition text-gray-400"
                      >
                        Reset
                      </button>
                    </div>
                    <div className="grid grid-cols-2 gap-3 pt-1">
                      <div>
                        <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Round Off (+/-)</label>
                        <input
                          type="number"
                          step="any"
                          value={state.roundOff !== undefined && state.roundOff !== 0 ? state.roundOff : ""}
                          onChange={(e) => {
                            const val = e.target.value === "" ? 0 : parseFloat(e.target.value) || 0;
                            setState(prev => ({ ...prev, roundOff: val, targetTotal: undefined, paidAmount: undefined }));
                          }}
                          placeholder="0.00"
                          className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-xs font-semibold focus:ring-1 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                      <div>
                        <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Target Rounded Total</label>
                        <input
                          type="number"
                          step="any"
                          value={
                            state.targetTotal !== undefined
                              ? state.targetTotal
                              : (() => {
                                  const before = Math.max(0, (state.summaryTotal || 0) - (state.discountType === "percent" ? ((state.summaryNetTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                                  return Number((before + Number(state.roundOff || 0)).toFixed(2));
                                })()
                          }
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                              setState(prev => ({ ...prev, targetTotal: "", roundOff: 0, paidAmount: undefined }));
                              return;
                            }
                            const target = parseFloat(val);
                            if (!isNaN(target)) {
                              const before = Math.max(0, (state.summaryTotal || 0) - (state.discountType === "percent" ? ((state.summaryNetTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                              const diff = parseFloat((target - before).toFixed(2));
                              setState(prev => ({ ...prev, targetTotal: val, roundOff: diff, paidAmount: undefined }));
                            } else {
                              setState(prev => ({ ...prev, targetTotal: val }));
                            }
                          }}
                          onBlur={() => {
                            setState(prev => ({ ...prev, targetTotal: undefined }));
                          }}
                          placeholder="Target Bill"
                          className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-xs font-bold text-restro-green focus:ring-1 focus:ring-restro-green focus:outline-none"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Section: Payments Selection */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm p-4 space-y-4">
                  <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-zinc-800">
                    <div className="flex items-center gap-1.5">
                      <IconCreditCard size={17} className="text-indigo-500" />
                      <h4 className="font-bold text-xs uppercase tracking-wider text-gray-700 dark:text-zinc-300">
                        Payment Method
                      </h4>
                    </div>
                    <button 
                      type="button"
                      onClick={addPaymentRow}
                      className="text-xs font-bold text-indigo-600 hover:underline"
                    >
                      + Split Payment
                    </button>
                  </div>

                  {state.multiPayments.length > 0 ? (
                    <div className="space-y-2">
                      {state.multiPayments.map((payment, index) => (
                        <div key={index} className="flex gap-2 items-center bg-gray-50 dark:bg-zinc-950 p-2.5 rounded-xl border border-gray-150 dark:border-zinc-800">
                          <select 
                            value={payment.payment_type_id} 
                            onChange={(e) => handleMultiPaymentChange(index, 'payment_type_id', e.target.value)}
                            className="flex-1 bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700 rounded-lg px-2.5 py-1.5 text-xs outline-none focus:ring-1 ring-indigo-500"
                          >
                            {(paymentTypes || []).map(pt => (
                              <option key={pt.id} value={pt.id}>{pt.title}</option>
                            ))}
                          </select>
                          <div className="relative w-28">
                            <input 
                              type="number" 
                              value={payment.amount}
                              onChange={(e) => handleMultiPaymentChange(index, 'amount', parseFloat(String(e.target.value).replace(/,/g, "")) || 0)}
                              className="w-full bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700 rounded-lg pl-6 pr-2 py-1.5 text-xs font-bold outline-none focus:ring-1 ring-indigo-500"
                            />
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">{currency}</span>
                          </div>
                          <button 
                            type="button"
                            onClick={() => removePaymentRow(index)}
                            className="btn btn-xs btn-circle btn-ghost text-red-400 hover:text-red-600"
                          >
                            <IconTrash size={14} />
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                      {(paymentTypes || []).map((paymentType, i) => {
                        const uniqueId = `pay-type-${paymentType?.id}`;
                        const isSelected = state.selectedPaymentType == paymentType?.id;
                        return (
                          <label key={i} className="block cursor-pointer">
                            <input
                              checked={isSelected}
                              onChange={() => setState({ ...state, selectedPaymentType: paymentType?.id })}
                              type="radio" 
                              name="payment_type" 
                              id={uniqueId} 
                              value={paymentType?.id} 
                              className="peer hidden" 
                            />
                            <div className="border border-gray-200 dark:border-zinc-800 dark:bg-zinc-950 bg-gray-50/80 rounded-xl flex items-center justify-center gap-1.5 flex-col px-2 py-3 peer-checked:border-restro-green peer-checked:bg-restro-green-light/10 peer-checked:text-restro-green transition shadow-xs text-center">
                              {paymentType?.icon && (
                                <div className={isSelected ? 'text-restro-green' : 'text-gray-400'}>
                                  {PAYMENT_ICONS[paymentType?.icon]}
                                </div>
                              )}
                              <p className="text-[11px] font-bold truncate max-w-full">{paymentType.title}</p>
                            </div>
                          </label>
                        );
                      })}
                    </div>
                  )}

                  {/* Cash Tendered & Change */}
                  <div className="grid grid-cols-2 gap-3 pt-2 border-t border-gray-100 dark:border-zinc-800">
                    <div>
                      <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Cash Tendered</label>
                      <input 
                        type="number" 
                        value={state.cashTendered || ""} 
                        onChange={(e) => {
                          const cashTendered = parseFloat(String(e.target.value).replace(/,/g, "")) || 0;
                          setState({ ...state, cashTendered });
                        }} 
                        placeholder="0.00"
                        className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-sm font-semibold focus:ring-1 focus:ring-amber-500 focus:outline-none"
                      />
                    </div>
                    <div className="p-2.5 bg-gray-50 dark:bg-zinc-950 rounded-xl border border-gray-150 dark:border-zinc-800 flex flex-col justify-center">
                      <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400">Change Due</span>
                      <span className="font-extrabold text-blue-600 dark:text-blue-400 text-base">
                        {currency}{(Math.max(0, (state.cashTendered || 0) - (state.paidAmount === undefined ? (Math.max(0, (state.summaryTotal - (state.discountType === "percent" ? (state.summaryNetTotal * state.discount / 100) : state.discount) - state.loyaltyRedemptionAmount) + Number(state.roundOff || 0))) : state.paidAmount))).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  {/* Total Received Input */}
                  <div className="flex items-center justify-between bg-emerald-50 dark:bg-emerald-950/20 p-3 rounded-xl border border-emerald-200 dark:border-emerald-900/60">
                    <span className="text-xs font-bold text-emerald-800 dark:text-emerald-300 uppercase tracking-wider">Total Received</span>
                    <div className="flex items-center gap-1.5">
                      <span className="text-emerald-700 font-bold text-sm">{currency}</span>
                      <input 
                        type="number" 
                        value={state.paidAmount === undefined ? (Math.max(0, (state.summaryTotal - (state.discountType === "percent" ? (state.summaryNetTotal * state.discount / 100) : state.discount) - state.loyaltyRedemptionAmount) + Number(state.roundOff || 0))) : state.paidAmount} 
                        onChange={(e) => {
                          const paidAmount = parseFloat(String(e.target.value).replace(/,/g, ""));
                          setState({ ...state, paidAmount });
                        }} 
                        className="w-28 text-right bg-transparent border-b-2 border-emerald-400 dark:border-emerald-700 text-lg font-black text-emerald-700 dark:text-emerald-300 focus:outline-none focus:border-emerald-600"
                      />
                    </div>
                  </div>
                </div>

                {/* Print Receipt Option */}
                <label
                  htmlFor="print_receipt"
                  className="flex items-center justify-end gap-2.5 cursor-pointer py-1"
                >
                  <input
                    type="checkbox"
                    className="checkbox checkbox-primary rounded-lg checkbox-sm"
                    id="print_receipt"
                    ref={printReceiptRef}
                    defaultChecked={printSettings?.is_enable_print ? true : false}
                  />
                  <span className="text-xs font-semibold text-gray-700 dark:text-zinc-300">{t('orders.print_receipt_option')}</span>
                </label>

              </div>
            </div>
          </div>

          {/* Modal Footer Actions */}
          <div className="p-4 px-6 bg-gray-50 dark:bg-zinc-900 border-t border-gray-200 dark:border-zinc-800 flex flex-col sm:flex-row justify-between items-center gap-3">
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <button
                type="button"
                onClick={btnPrintEstimateFromModal}
                className="w-full sm:w-auto px-4 py-2.5 rounded-xl font-bold transition active:scale-95 border border-amber-300 bg-amber-50 hover:bg-amber-100 text-amber-900 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-800 flex items-center justify-center gap-2 text-xs shadow-xs"
                title="Print Estimate Bill (कच्चा बिल) with current overridden prices"
              >
                <SafeIconPrinter size={16} stroke={iconStroke} /> Print Estimate Bill (कच्चा बिल)
              </button>

              <button
                type="button"
                onClick={btnSaveOverriddenPrices}
                disabled={state.isSavingPrices}
                className="w-full sm:w-auto px-4 py-2.5 rounded-xl font-bold transition active:scale-95 border border-blue-300 bg-blue-50 hover:bg-blue-100 text-blue-900 dark:bg-blue-950/40 dark:text-blue-200 dark:border-blue-800 flex items-center justify-center gap-1.5 text-xs shadow-xs"
                title="Save overridden prices to order and update Room Folio immediately"
              >
                <IconDeviceFloppy size={16} /> Save Prices (Folio Update)
              </button>
            </div>

            <button
              onClick={btnPayAndComplete}
              className="w-full sm:w-auto px-8 py-3 rounded-xl font-bold transition active:scale-95 shadow-lg bg-restro-green hover:bg-restro-green-button-hover text-white flex items-center justify-center gap-2 text-sm"
            >
              <IconCheck size={18} /> {t('orders.pay_complete_order')}
            </button>
          </div>
        </div>
      </dialog>
      {/* dialog: complete order & payment summary */}
      {/* dialog: complete order & payment summary */}

      {/* dialog: complete order */}
      <dialog id="modal-collect-feedback" className="modal">
        <div className="modal-box border border-restro-border-green rounded-2xl ">
          <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-restro-gray">
            <IconStars stroke={iconStroke} />
          </div>
          <h3 className="mt-4 font-bold text-lg text-center">{t('orders.collect_feedback')}</h3>

          <div className="absolute top-6 right-6">
            <form method="dialog">
              <button className="btn btn-sm btn-circle border-none transition active:scale-95 text-restro-red hover:bg-restro-button-hover">
                <IconX stroke={iconStroke} size={18} />
              </button>
            </form>
          </div>

          <div className="my-4">
            <img src={state.feedbackQRCode} alt={t('orders.feedback_qr_img_alt')} className="w-52 h-52 mx-auto border rounded-lg" />
          </div>

          <p className="text-center italic mb-10" dangerouslySetInnerHTML={{__html: t('orders.feedback_message')}}>

          </p>

          <div className="flex items-center gap-2 text-sm">
            <div className="flex-1 border-b border-restro-gray"></div>
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-restro-gray">
              OR
            </div>
            <div className="flex-1 border-b border-restro-gray"></div>
          </div>

          <div className="modal-action justify-center">
            <form method="dialog">
              <button
                onClick={() => {
                  btnOpenFeedbackLink();
                }}
                className="btn ml-2 transition active:scale-95 hover:shadow-lg px-4 py-3 border bg-restro-green hover:bg-restro-green-button-hover text-white rounded-xl"
              >
                {t('orders.open_in_new_tab')} <IconExternalLink stroke={iconStroke} />
              </button>
            </form>
          </div>
          </div>
      </dialog>
      {/* dialog: change table */}
      <dialog id="modal-change-table" className="modal modal-bottom sm:modal-middle">
        <div className="modal-box bg-restro-gray border border-restro-border-green">
          <h3 className="font-bold text-lg mb-4">Change Table</h3>
          <p className="text-sm mb-4">Select the new table for the selected order(s).</p>
          
          <select 
            className="select select-bordered w-full bg-restro-gray border-restro-border-green"
            value={state.changeTableNewTableId || ""}
            onChange={(e) => setState({ ...state, changeTableNewTableId: e.target.value })}
          >
            <option value="">Select Table</option>
            {state.storeTables.map(t => (
              <option key={t.id} value={t.id}>{t.table_title} ({t.floor})</option>
            ))}
          </select>

          <div className="modal-action">
            <form method="dialog">
              <button className="btn btn-ghost mr-2">Cancel</button>
            </form>
            <button onClick={btnConfirmChangeTable} className="btn bg-restro-green hover:bg-restro-green-button-hover text-white border-none rounded-xl">
              Confirm Change
            </button>
          </div>
        </div>
      </dialog>

      {/* dialog: merge tables */}
      <dialog id="modal-merge-tables" className="modal modal-bottom sm:modal-middle">
        <div className="modal-box bg-restro-gray border border-restro-border-green">
          <h3 className="font-bold text-lg mb-4">Merge Tables</h3>
          <div className="mb-4">
            <p className="text-xs font-bold uppercase mb-2 text-gray-400 tracking-widest">Select Source Tables</p>
            <div className="flex flex-wrap gap-2 max-h-40 overflow-y-auto p-1">
              {kitchenOrders.filter(o => o.table_id).map((order) => (
                <label key={order.table_id} className={`flex items-center gap-2 p-2 border rounded-xl cursor-pointer transition ${state.mergeSourceTableIds.includes(order.table_id) ? 'bg-indigo-50 border-indigo-500 text-indigo-700' : 'bg-white dark:bg-slate-800 border-gray-200 dark:border-gray-700'}`}>
                  <input 
                    type="checkbox" 
                    className="checkbox checkbox-sm checkbox-primary" 
                    checked={state.mergeSourceTableIds.includes(order.table_id)}
                    onChange={(e) => {
                      const ids = e.target.checked 
                        ? [...new Set([...state.mergeSourceTableIds, order.table_id])]
                        : state.mergeSourceTableIds.filter(id => id != order.table_id);
                      setState({ ...state, mergeSourceTableIds: ids });
                    }}
                  />
                  <span className="text-xs font-bold">{order.table_title}</span>
                </label>
              ))}
            </div>
          </div>

          <p className="text-xs font-bold uppercase mb-2 text-gray-400 tracking-widest">Select Target Table</p>
          <select 
            className="select select-bordered w-full bg-restro-gray border-restro-border-green rounded-xl"
            value={state.mergeTargetTableId || ""}
            onChange={(e) => setState({ ...state, mergeTargetTableId: e.target.value })}
          >
            <option value="">Select Target Table</option>
            {state.storeTables.map(t => (
              <option key={t.id} value={t.id}>{t.table_title} ({t.floor})</option>
            ))}
          </select>

          <div className="modal-action">
            <form method="dialog">
              <button className="btn btn-ghost mr-2">Cancel</button>
            </form>
            <button onClick={btnConfirmMergeTables} className="btn bg-restro-green hover:bg-restro-green-button-hover text-white border-none rounded-xl">
              Confirm Merge
            </button>
          </div>
        </div>
      </dialog>

      {/* dialog: split bill */}
      <dialog id="modal-split-bill" className="modal modal-bottom sm:modal-middle">
        <div className="modal-box bg-white dark:bg-slate-900 border border-restro-border-green w-11/12 max-w-5xl p-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700">
            <div>
              <h3 className="font-bold text-xl flex items-center gap-2">
                <IconScissors className="text-orange-500" size={24} /> Split Bill by Item & Quantity
              </h3>
              <p className="text-xs text-gray-500 mt-0.5">
                Assign specific quantities of each item to different bills.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={btnSplitEquallyAcrossBills}
                className="btn btn-xs btn-outline border-restro-border-green hover:bg-restro-gray text-xs"
                title="Evenly distribute item quantities across all open bills"
              >
                Distribute Quantities Evenly
              </button>
            </div>
          </div>

          {/* Grid of Bills */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 overflow-y-auto max-h-[60vh] p-1">
            {state.splitBillGroups.map((group, gIdx) => {
              const groupTotal = (group.items || []).reduce(
                (acc, it) => acc + (Number(it.price) || 0) * (Number(it.quantity) || 0),
                0
              );
              const groupTotalQty = (group.items || []).reduce(
                (acc, it) => acc + (Number(it.quantity) || 0),
                0
              );

              return (
                <div
                  key={gIdx}
                  className="p-4 border border-restro-border-green rounded-2xl bg-gray-50 dark:bg-slate-800 flex flex-col justify-between shadow-sm"
                >
                  <div>
                    {/* Header */}
                    <div className="flex justify-between items-center mb-2 pb-2 border-b border-gray-200 dark:border-gray-700">
                      <div>
                        <h4 className="font-bold text-sm text-restro-green flex items-center gap-1.5">
                          <IconReceipt size={16} /> {group.label}
                        </h4>
                        <span className="text-[11px] text-gray-500 font-medium">
                          {groupTotalQty} pcs • {currency} {groupTotal.toFixed(2)}
                        </span>
                      </div>
                      {gIdx >= 2 && (
                        <button
                          type="button"
                          onClick={() => btnRemoveSplitGroup(gIdx)}
                          className="btn btn-ghost btn-xs text-red-500 p-1"
                          title="Remove this bill and move items back to Bill 1"
                        >
                          <IconTrash size={14} />
                        </button>
                      )}
                    </div>

                    {/* Items in this bill */}
                    <div className="space-y-2 mt-2">
                      {(group.items || []).map((item) => (
                        <div
                          key={item.id}
                          className="p-2.5 bg-white dark:bg-slate-700/70 border border-gray-200 dark:border-gray-600 rounded-xl flex flex-col gap-1.5 shadow-xs"
                        >
                          <div className="flex justify-between items-start gap-1">
                            <div>
                              <p className="font-semibold text-xs leading-tight">
                                {item.item_title}
                                {item.variant_title ? ` (${item.variant_title})` : ""}
                              </p>
                              <p className="text-[11px] text-gray-500">
                                {currency} {Number(item.price || 0).toFixed(2)} each
                              </p>
                            </div>
                            <div className="text-right">
                              <span className="font-bold text-xs text-restro-green">
                                {currency} {(Number(item.price || 0) * item.quantity).toFixed(2)}
                              </span>
                            </div>
                          </div>

                          {/* Quantity control & move menu */}
                          <div className="flex items-center justify-between pt-1 border-t border-gray-100 dark:border-gray-600">
                            <span className="text-xs font-semibold bg-gray-100 dark:bg-slate-800 px-2 py-0.5 rounded-md">
                              Qty: <strong className="text-restro-green">{item.quantity}</strong>
                              {item.original_quantity > item.quantity ? (
                                <span className="text-gray-400 font-normal"> / {item.original_quantity}</span>
                              ) : null}
                            </span>

                            {/* Move controls */}
                            <div className="flex items-center gap-1.5">
                              {state.splitBillGroups.length === 2 && (
                                <button
                                  type="button"
                                  onClick={() => btnMoveSplitItemQty(gIdx, gIdx === 0 ? 1 : 0, item.id, 1)}
                                  className="btn btn-xs bg-gray-100 hover:bg-restro-gray border border-gray-200 dark:bg-slate-800 dark:border-gray-600 font-medium text-[11px] px-2 py-0.5"
                                  title={`Move 1 to ${state.splitBillGroups[gIdx === 0 ? 1 : 0].label}`}
                                >
                                  {gIdx === 0 ? "+1 to Bill 2" : "+1 to Bill 1"}
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={() => btnOpenMoveItemModal(gIdx, item)}
                                className="btn btn-xs bg-restro-green hover:bg-restro-green-button-hover text-white border-none gap-1 font-semibold text-xs px-2.5"
                              >
                                <IconArrowsTransferUp size={13} stroke={iconStroke} /> Move
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}

                      {(!group.items || group.items.length === 0) && (
                        <div className="p-4 border border-dashed border-gray-300 dark:border-gray-700 rounded-xl text-center">
                          <p className="text-xs text-gray-400 italic">No items assigned yet</p>
                          <p className="text-[11px] text-gray-400 mt-0.5">Use "Move" from other bills to add items</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Add Bill Button */}
            <button
              type="button"
              onClick={btnAddSplitGroup}
              className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-restro-border-green rounded-2xl hover:bg-restro-gray/40 transition min-h-[140px]"
            >
              <div className="w-10 h-10 rounded-full bg-restro-green/10 flex items-center justify-center text-restro-green mb-2">
                <IconPlus stroke={iconStroke} size={22} />
              </div>
              <span className="text-sm font-bold">Add Another Bill</span>
              <span className="text-xs text-gray-400 mt-0.5">Create Bill {state.splitBillGroups.length + 1}</span>
            </button>
          </div>

          <div className="modal-action mt-6 flex justify-between items-center">
            <form method="dialog">
              <button className="btn btn-ghost">Cancel</button>
            </form>
            <button
              type="button"
              onClick={btnConfirmSplitBill}
              className="btn bg-restro-green hover:bg-restro-green-button-hover text-white border-none rounded-xl px-6"
            >
              Confirm Split ({state.splitBillGroups.filter(g => g.items && g.items.some(i => i.quantity > 0)).length} Bills)
            </button>
          </div>
        </div>
      </dialog>

      {/* dialog: move item quantity between split bills */}
      <dialog id="modal-split-move-item" className="modal modal-bottom sm:modal-middle z-[60]">
        <div className="modal-box bg-white dark:bg-slate-900 border border-restro-border-green w-11/12 max-w-md p-6">
          <div className="flex justify-between items-start mb-4 pb-3 border-b border-gray-200 dark:border-gray-700">
            <div>
              <h3 className="font-bold text-lg text-restro-green flex items-center gap-2">
                <IconArrowsTransferUp size={20} stroke={iconStroke} /> Move Item
              </h3>
              <p className="text-xs text-gray-500 mt-1 font-medium">
                {state.splitMoveItemState?.itemTitle}
                {state.splitMoveItemState?.variantTitle ? ` (${state.splitMoveItemState?.variantTitle})` : ''}
              </p>
            </div>
            <span className="badge badge-neutral text-xs">
              In {state.splitBillGroups[state.splitMoveItemState?.fromGroupIdx]?.label}: {state.splitMoveItemState?.currentQty} pcs
            </span>
          </div>

          {/* Select Target Bill */}
          <div className="mb-4">
            <label className="text-xs font-bold uppercase tracking-wider text-gray-400 block mb-2">
              Move to Bill:
            </label>
            <div className="grid grid-cols-2 gap-2">
              {state.splitBillGroups.map((g, idx) => {
                if (idx === state.splitMoveItemState?.fromGroupIdx) return null;
                const isSelected = state.splitMoveItemState?.toGroupIdx === idx;
                return (
                  <button
                    key={idx}
                    type="button"
                    onClick={() => setState(prev => ({
                      ...prev,
                      splitMoveItemState: { ...prev.splitMoveItemState, toGroupIdx: idx }
                    }))}
                    className={clsx(
                      "p-3 rounded-xl border text-left font-bold text-sm transition flex items-center justify-between",
                      isSelected
                        ? "bg-restro-green/10 border-restro-green text-restro-green ring-1 ring-restro-green"
                        : "bg-gray-50 dark:bg-slate-800 border-gray-200 dark:border-gray-700 hover:border-restro-border-green"
                    )}
                  >
                    <span>{g.label}</span>
                    {isSelected && <IconCheck size={16} stroke={iconStroke} />}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Select Quantity */}
          <div className="mb-6">
            <label className="text-xs font-bold uppercase tracking-wider text-gray-400 block mb-2">
              Quantity to Move:
            </label>
            <div className="flex items-center gap-3">
              <div className="flex items-center border border-gray-300 dark:border-gray-600 rounded-xl overflow-hidden bg-gray-50 dark:bg-slate-800">
                <button
                  type="button"
                  onClick={() => setState(prev => ({
                    ...prev,
                    splitMoveItemState: {
                      ...prev.splitMoveItemState,
                      moveQty: Math.max(1, (prev.splitMoveItemState?.moveQty || 1) - 1)
                    }
                  }))}
                  disabled={(state.splitMoveItemState?.moveQty || 1) <= 1}
                  className="px-3 py-2 text-lg font-bold hover:bg-gray-200 dark:hover:bg-slate-700 disabled:opacity-40 transition"
                >
                  -
                </button>
                <span className="w-12 text-center font-bold text-base text-restro-green">
                  {state.splitMoveItemState?.moveQty || 1}
                </span>
                <button
                  type="button"
                  onClick={() => setState(prev => ({
                    ...prev,
                    splitMoveItemState: {
                      ...prev.splitMoveItemState,
                      moveQty: Math.min(
                        prev.splitMoveItemState?.currentQty || 1,
                        (prev.splitMoveItemState?.moveQty || 1) + 1
                      )
                    }
                  }))}
                  disabled={(state.splitMoveItemState?.moveQty || 1) >= (state.splitMoveItemState?.currentQty || 1)}
                  className="px-3 py-2 text-lg font-bold hover:bg-gray-200 dark:hover:bg-slate-700 disabled:opacity-40 transition"
                >
                  +
                </button>
              </div>

              {/* Quick Preset Buttons */}
              <div className="flex items-center gap-1.5 flex-wrap">
                <button
                  type="button"
                  onClick={() => setState(prev => ({
                    ...prev,
                    splitMoveItemState: { ...prev.splitMoveItemState, moveQty: 1 }
                  }))}
                  className={clsx("btn btn-xs rounded-lg", (state.splitMoveItemState?.moveQty === 1) ? "btn-neutral" : "btn-ghost border border-gray-300")}
                >
                  1
                </button>
                {(state.splitMoveItemState?.currentQty > 2) && (
                  <button
                    type="button"
                    onClick={() => setState(prev => ({
                      ...prev,
                      splitMoveItemState: { ...prev.splitMoveItemState, moveQty: 2 }
                    }))}
                    className={clsx("btn btn-xs rounded-lg", (state.splitMoveItemState?.moveQty === 2) ? "btn-neutral" : "btn-ghost border border-gray-300")}
                  >
                    2
                  </button>
                )}
                {(state.splitMoveItemState?.currentQty > 1) && (
                  <button
                    type="button"
                    onClick={() => setState(prev => ({
                      ...prev,
                      splitMoveItemState: {
                        ...prev.splitMoveItemState,
                        moveQty: prev.splitMoveItemState?.currentQty
                      }
                    }))}
                    className={clsx(
                      "btn btn-xs rounded-lg",
                      (state.splitMoveItemState?.moveQty === state.splitMoveItemState?.currentQty) ? "bg-orange-500 text-white" : "btn-ghost border border-gray-300"
                    )}
                  >
                    All ({state.splitMoveItemState?.currentQty})
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="modal-action flex justify-between items-center">
            <form method="dialog">
              <button className="btn btn-ghost">Cancel</button>
            </form>
            <button
              type="button"
              onClick={() => {
                const { fromGroupIdx, toGroupIdx, itemId, moveQty } = state.splitMoveItemState || {};
                if (fromGroupIdx !== undefined && toGroupIdx !== undefined && itemId && moveQty > 0) {
                  btnMoveSplitItemQty(fromGroupIdx, toGroupIdx, itemId, moveQty);
                }
                const dlg = document.getElementById('modal-split-move-item');
                if (dlg) dlg.close();
              }}
              className="btn bg-restro-green hover:bg-restro-green-button-hover text-white border-none rounded-xl"
            >
              Move {state.splitMoveItemState?.moveQty || 1} to {state.splitBillGroups[state.splitMoveItemState?.toGroupIdx]?.label}
            </button>
          </div>
        </div>
      </dialog>


      {/* dialog: split bill success & print options */}
      <dialog id="modal-split-bill-success" className="modal modal-bottom sm:modal-middle">
        <div className="modal-box bg-white dark:bg-slate-900 border border-restro-border-green w-11/12 max-w-2xl p-6">
          <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700">
            <div className="w-12 h-12 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center">
              <IconReceipt size={24} />
            </div>
            <div>
              <h3 className="font-bold text-lg">Bill Split Successfully!</h3>
              <p className="text-xs text-gray-500">
                The order has been divided into separate bills as per your split quantities.
              </p>
            </div>
          </div>

          <div className="space-y-3 my-4">
            {(state.splitBillSuccessData || []).map((bill, bIdx) => (
              <div
                key={bIdx}
                className="p-3.5 bg-gray-50 dark:bg-slate-800 border border-restro-border-green rounded-xl flex items-center justify-between"
              >
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-sm text-restro-green">{bill.label}</span>
                    <span className="badge badge-sm badge-neutral">Token #{bill.tokenNo}</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    {bill.totalQty} items • <strong className="text-gray-700 dark:text-gray-200">{currency} {Number(bill.totalAmount || 0).toFixed(2)}</strong>
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => btnPrintEstimate([bill.orderId], String(bill.tokenNo))}
                    className="btn btn-xs bg-amber-50 hover:bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300 border border-amber-300 font-semibold gap-1"
                    title="Print Estimate (कच्चा बिल)"
                  >
                    <SafeIconPrinter size={13} stroke={iconStroke} /> Estimate
                  </button>
                  <button
                    type="button"
                    onClick={() => btnPrintReceipt([bill.orderId], String(bill.tokenNo))}
                    className="btn btn-xs btn-outline border-gray-300 gap-1"
                    title="Print Receipt"
                  >
                    <IconReceipt size={13} stroke={iconStroke} /> Receipt
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="modal-action flex justify-between items-center mt-6">
            <button
              type="button"
              onClick={() => btnPrintAllSplitEstimates(state.splitBillSuccessData)}
              className="btn btn-sm bg-amber-500 hover:bg-amber-600 text-white border-none gap-1.5 font-bold"
            >
              <SafeIconPrinter size={16} stroke={iconStroke} /> Print All Estimates
            </button>
            <form method="dialog">
              <button className="btn btn-sm btn-ghost">Done</button>
            </form>
          </div>
        </div>
      </dialog>


      {/* dialog: add customer */}
      <DialogAddCustomer
        defaultValue={state.addCustomerDefaultValue}
        onSuccess={async (phone, name) => {
          try {
            const resp = await searchCustomer(phone);
            if (resp.status === 200 && resp.data && resp.data.length > 0) {
              await btnSelectCustomerFromResult(resp.data[0]);
            } else {
              setState((prev) => ({ ...prev, customer: { name, phone } }));
            }
          } catch (e) {
            setState((prev) => ({ ...prev, customer: { name, phone } }));
          }
          if (searchCustomerRef.current) {
            searchCustomerRef.current.value = "";
          }
        }}
      />

    </Page>
  );
}

